import { BaseColumnBinding, BaseEntityRecordBinding, ColumnBinding, EntityBinding } from "../../mirage/metadata/BaseEntityRecordBinding";
import { IPApplication } from "../entities/IPApplication";
import { MetaBinding } from "../../mirage/metadata/MetaBinding";
const labelsMapObj = {
    easting: "Easting (x)",
    receivedDate: "Received Date",
    validDate: "Valid Date",
    timeExtensionAgreed: "Time extension agreed?",
    drawingNumber: "Drawing Number",
    northing: "Northing (y)",
    statementDue: "Statement Due",
    statementSent: "Statement Sent",
    finalCommentsDue: "Final Comments Due",
    finalCommentsSent: "Final Comments Sent",
    siteVisit: "Site Visit",
    useCodeId: "Use Code",
    committeeDateId: "Committee Date ID",
    decisionDate: "Actual Decision Date",
    officerTelephone: "Telephone",
    appealReceived: "Appeal received",
    appealDecisionDate: "Appeal Decision Date",
    polygonPrimaryKey: "Polygon Primary Key",
    paymentAmount: "Payment Amount",
    startingDate: "Starting Date",
    postcode: "Postcode",
    statusDate: "Status Date",
    planningTeamId: "Planning Team",
    ward: "Ward",
    parish: "Parish",
    decisionTargetDate: "Decision Target Date",
    feesOutstanding: "Total Fees Outstanding",
    floorArea: "Floor Area (sq.m)",
    bufferValue: "Buffer Value",
    applicationTypeId: "Application Type",
    receivedById: "Received By",
    methodReceived: "How Received",
    multipleAddresses: "Multiple addresses?",
    committeeDate: "Committee Date",
    relatedApplicationId: "Related application",
    appealDecision: "Appeal Decision",
    noOfDwellings: "No. of Dwellings",
    newFloorspace: "New Floorspace (sq.m)",
    dateWorkStarted: "Date Work Started",
    dateWorkFinished: "Date Work Finished",
    workStartedChangeOfUse: "Work already started / change of use happened",
    vat: "V.A.T",
    feesDue: "Total Fees Due",
    totalRefunds: "Total Refunds",
    eiaRequired: "EIA Required",
    designation: "Designation",
    ppaOrExtensionAgreed: "PPA Agreed",
    contingencyDatesComments: "Comments",
    extendedDate: "PPA Agreed Date",
    validityStatusDate: "Validity Status Date",
    articleNoticeReceived: "Article Notice Received?",
    dateArticleNoticeReceived: "Date Article Notice Received",
    articleNoticeComments: "Article Notice Comments",
    preApplicationId: "Pre-application",
    consulteeResponsesDeadline: "Consultee Responses Deadline",
    wasWithdrawn: "Withdrawn",
    calledIn: "Called In",
    referredToSos: "Referred to Secretary of State",
    location: "Address",
    articleNoticeDocument: "Article Notice Document",
    reportDueDate: "Report Due Date",
    certificateOfOwnershipTypeRequired: "Type Required",
    appropriateCertificateProvided: "Appropriate Certificate Provided?",
    agriculturalCertificateProvided: "Agricultural Certificate Provided?",
    ownershipCertTitle: "Title",
    declarationDate: "Declaration Date",
    declarationMade: "Declaration Made",
    personRole: "Person Role",
    ownershipCertificate: "Ownership Certificate",
    decision: "Decision",
    refundDue: "Refund Due",
    uprn: "UPRN",
    siteVisitContactType: "Contact Type",
    siteVisitContactName: "Name",
    siteVisitContactCompany: "Company",
    siteVisitContactAddress: "Address",
    siteVisitContactPhoneNo: "Phone No.",
    siteVisitContactEmail: "Email",
    phoneType: "Phone Type",
    residentialIncludesGainLoss: "Residential - includes gain / loss?",
    residentialMarket: "Market",
    residentialSocial: "Social",
    residentialKeyWorker: "Key Worker",
    residentialIntermediate: "Intermediate",
    residentialStarterHomes: "Starter Homes",
    residentialSelfBuildCustomBuilt: "Self-Build / Custom Built",
    scopingOpinionSought: "Scoping Opinion Sought",
    scopingOpinionProvided: "Scoping Opinion Provided",
    environmentalStatementReceived: "Environmental Statement Received",
    environmentalStatementRequired: "Environmental Statement Required",
    schedule_1Or_2: "Schedule 1 or 2",
    planningPortalRefNo: "Planning Portal Reference No.",
    ps12Code: "PS1/2 Code",
    siteCanBeSeenFromPublicRoadPublic: "Site can be seen from public road, public footpath, bridleway or other public land",
    preferredContactMethod: "Preferred Contact Method",
    residentialMarketProposed: "Market",
    residentialSocialProposed: "Social",
    residentialKeyWorkerProposed: "Key Worker",
    residentialIntermediateProposed: "Intermediate",
    residentialStarterHomesProposed: "Starter Homes",
    residentialSelfBuildCustomBuiltProposed: "Self-Build / Custom Built",
    involvesLossGainOrChangeOfNonresidential: "Involves Loss, Gain, or Change of non-residential floorspace",
    includesHotelsResidentialInstitutionsEtc: "Includes hotels, residential institutions, etc.",
    anyPeoplePresentlyEmployedOnSite: "Any people presently employed on site?",
    proposedEmploymentAtSite: "Proposed employment at site?",
    involvesOpeningHours: "Involves Opening Hours",
    detailsOfIndustrialProcessesAndMachinery: "Details of Industrial Processes and Machinery",
    employmentComments: "Employment comments",
    cilAgreementDate: "CIL Agreement Date",
    expiryDate: "Expiry Date",
    adviceSought: "Advice Sought",
    adviceDetails: "Advice Details",
    unitMeasurement: "Unit Measurement",
    workStartedWoPermission: "Work Started Without Planning Permission",
    workStartedWoPermissionDate: "Work Started Date",
    workCompletedWoPermission: "Work Completed Without Planning Permission",
    workCompletedWoPermissionDate: "Work Completed Date",
    buildingRegulationsRequired: "Building Regulations Required",
    siteArea: "Site Area",
    buildingAge: "Building Age",
    priorApprovalType: "Prior Approval Type",
    detailedPlanningLikelyRequired: "Detailed planning likely to be required",
    notesHistoryAndInformation: "Notes",
    buildingType: "Building Type",
    occupancy: "Occupancy",
    locationType: "Location Type",
    commercialFloorspaceLostM: "Sq.m",
    commercialFloorspaceLostHa: "Ha.",
    noOfDwellingsNew: "No. of dwellings",
    proposedEmployeesFullTime: "Proposed Employees (full time)",
    proposedEmployeesPartTime: "Proposed Employees (part time)",
    proposedEmployeesFullTimeEquivalent: "Proposed Employees (full time equivalent)",
    agentAddressTextarea: "Address",
    agentPostTown: "Post Town",
    agentPostcode: "Postcode",
    agentTelephone: "Telephone",
    agentFax: "Fax",
    agentMobile: "Mobile",
    agentEmail: "Email",
    agentTitle: "Title",
    agentFirstName: "First Name",
    agentSurname: "Surname",
    agentPreferredContact: "Preferred Contact",
    agentCountry: "Country",
    agentAddress: "Address",
    applicantAddressTextarea: "Address",
    applicantPostTown: "Post Town",
    applicantTelephone: "Telephone",
    applicantFax: "Fax",
    applicantMobile: "Mobile",
    applicantEmail: "Email",
    applicantTitle: "Title",
    applicantFirstName: "First Name",
    applicantSurname: "Surname",
    applicantPreferredContact: "Preferred Contact",
    applicantCountry: "Country",
    applicantAddress: "Address",
    vehicleParkingRelevantToApplication: "Vehicle Parking relevant to application",
    sameAddressAsApplication: "Same address as Application",
    smApplicationFromPlanningPortal: "Application from Planning Portal?",
    addressLine_1: "Address Line 1",
    addressLine_2: "Address Line 2",
    addressLine_3: "Address Line 3",
    postTown: "Post Town",
    plansIndexed: "Plans and Documents uploaded and indexed",
    validationStage: "Validation Stage",
    validationChallengeStatus: "Validation Challenge Status",
    challengeStatusAppealDecision: "Challenge Status Appeal Decision",
    validationAppealIssued: "Appeal Issued",
    validationPinsDecision: "PINS Decision",
    caseOfficerId: "Case Officer",
    applicationReceiptAcknowledged: "Application Receipt Acknowledged",
    parentApplicationId: "Parent Application",
    paymentFinalized: "Payment Finalized",
    listedBuildingExemption: "Listed Building Exemption",
    disabledAdaptationWorks: "Disabled Adaptation Works",
    freeGoApplication: "Free Go Application",
    feesImported: "Fees Imported",
    feesPaid: "Fees Paid",
    feesTransferred: "Fees Transferred",
    feesExemption: "Fees Exemption",
    feesTransferredIn: "Fees Transferred In",
    feesTransferredOut: "Fees Transferred Out",
    applicantFullName: "Full Name",
    agentFullName: "Full Name",
    applicantAddressLine_2: "Address Line 2",
    applicantAddressLine_3: "Address Line 3",
    applicantAddressLine_1: "Address Line 1",
    agentAddressLine_2: "Address Line 2",
    agentAddressLine_3: "Address Line 3",
    agentAddressLine_1: "Address Line 1",
    applicantPostcode: "Postcode",
    validationProcessingComplete: "Validation Processing Complete",
    correctFeeConfirmed: "Correct Fee Confirmed",
    plottedBoundaryConfirmed: "Plotted Boundary Confirmed",
    plansScanned: "Plans and Documents being scanned",
    validationStatus: "Validation Status",
    validationChallenged: "Validation Challenged",
    plottedBoundaryRequired: "Plotted Boundary Required",
    validationChallengeStatusAppealed: "Challenge Status Appealed",
    plansToFollow: "Plans and Documents to follow",
    involvesChangeOfUseClass: "Involves Change of Use",
    boundaryPlotRequired: "Boundary Plot Required",
    applicationPlotted: "Application Plotted",
    noBoundaryInformationProvided: "No Boundary Information Provided",
    declaredBoundaryArea: "Declared Boundary Area",
    feeAmount: "Fee Amount (\u00A3)",
    originalBoundaryArea: "Original Boundary Area",
    agentCompany: "Company",
    applicantCompany: "Company",
    registrationValidationConfirmedDate: "Registration Validation Confirmation Date",
    registrationValidationConfirmed: "Registration Validation Confirmed",
    applicationStatus: "Status",
    timeExtensionDate: "Agreed Time Extension Date",
    notificationsConsultationsSent: "Notifications / Consultations Sent",
    publicNoticePublished: "Public Notice Published",
    furtherInformationRequestedDate: "Further Information Requested Date",
    initialSiteVisitUndertaken: "Initial Site Visit Undertaken",
    amendedApplication: "Amended Application",
    retrospectiveApplication: "Retrospective Application",
    addressCareOfAgent: "Address Care of Agent",
    applicantAgentIsAMemberOfStaff: "Applicant, Agent is a member of staff, councillor, or related to one",
    councillorRelativeDetails: "Relationship details",
    proposal: "Proposal Details",
    existingGrossFloorspace: "Existing Gross Floorspace",
    grossFloorspaceToBeLost: "Gross Floorspace to be Lost",
    totalGrossFloorspaceProposed: "Total Gross Floorspace Proposed",
    netAdditionalGrossFloorspace: "Net Additional Gross Floorspace",
    technicalOfficerId: "Technical Officer",
    submittedDetails: "Submitted Details",
    feesComments: "Fees Comments",
    parishCouncilDiscount: "Parish Council Discount",
    decisionCode: "Decision Code",
    decisionClass: "Decision Class",
    changeAffectingCentre: "Change of Use Affecting Town Centre",
    appealTargetDate: "Appeal Target Date",
    notificationResponseDeadline: "Notification Response Deadline",
    renotificationResponseDeadline: "Renotification Response Deadline",
    consultationResponseDeadline: "Consultation Response Deadline",
    reconsultationResponseDeadline: "Reconsultation Response Deadline",
    siteVisitContactBefore: "Contact before arrival",
    plottedBoundaryArea: "Plotted Boundary Area",
    validationConfirmationOfficerId: "Registration Validation Confirmation Officer",
    registrationValidationConfirmationUserId: "Registration Validation Confirmation Officer",
    feeCategory: "Fee Category",
    applicantTypeId: "Applicant Type",
    addedDate: "Added Date",
    registeredDate: "Registered Date",
    existingEmployeesFullTime: "Existing Employees (full time)",
    existingEmployeesFullTimeEquivalent: "Existing Employees (full time equivalent)",
    existingEmployeesPartTime: "Existing Employees (part time)",
    declarationFirstName: "First Name",
    declarationSurname: "Surname",
    committeeAreaId: "Committee Area",
    referredToGla: "Referred to GLA",
    dateSentToGla: "Date Sent To GLA",
    dateReturnedFromGla: "Date Returned from GLA",
    daysForGlaReturn: "Days for GLA return",
    reasonForGla: "Reason for referral to GLA",
    dateSentToSos: "Date sent to SoS",
    dateReturnedFromSos: "Date returned from SoS",
    daysMtgReturnFromSos: "No. days from MTG to return from SoS",
    reasonForSos: "Reason for referral to SoS",
    initialAppRef: "Initial Application Reference",
    outstandingValidationStageTasks: "Outstanding Tasks",
    advertisementDate: "Advertisement Date",
    advertisementPublication: "Advertisement Publication",
    notificationStepsTaken: "Notification Steps Taken",
    smFullNameGenerated: "SM Full Name Generated",
    paymentStatusNotes: "Payment Status Notes",
    prevalidationCommentary: "Prevalidation Commentary",
    certificateOfOwnershipTypeProvided: "Type Provided",
    incorrectPlanningAuthority: "Incorrect Planning Authority",
    proposalDescriptionConfirmed: "Proposal Description Confirmed",
    importFromApplicationId: "Import from Application",
    plottedBoundaryAreaTemp: "Plotted Boundary Area Temp",
    agentId: "Agent",
    validationDecisionDate: "Validation Decision Date",
    timeExtensionAgreedCorrespId: "Time Extension Agreement Correspondence",
    multipleApplicants: "Multiple Applicants",
    importFromDecisionId: "Conditions from Decision",
    consultationsRequired: "Consultations Required",
    notificationsRequired: "Neighbour Notifications Required",
    supersedesPreviousApplication: "Supersedes Previous Application",
    applicationSuperseded: "Application Superseded",
    supersededBy: "Application Superseded By",
    partiallySuperseded: "Partially Superseded",
    validationDecision: "Validation Decision",
    proposedUseClassId: "Proposed Use Class",
    currentUseClassId: "Current Use Class",
    amendmentDecision: "Amendment Decision",
    eiaDocumentLocation: "EIA Document Location",
    validationChallengeStatusDate: "Validation Challenge Status Date",
    publicNoticeDisplayedOnSite: "Public Notice Displayed On Site",
    footpathCrossesBoundary: "Footpath crosses boundary",
    isADepartureFromLocalPlan: "Is a departure from Local Plan",
    workToAListedBuilding: "Work to a Listed Building",
    affectsSettingOfListedBuilding: "Affects setting of Listed Building",
    demolitionInConservationArea: "Demolition in Conservation Area",
    affectsSettingOfConservationArea: "Affects setting of Conservation Area",
    includeInNextWeeklyList: "Include in next Weekly List",
    proposalDetailsChanged: "Proposal Details Changed",
    requiresReadvertisement: "Requires Readvertisement",
    dateProposalChanged: "Date Proposal Changed",
    weeklyListDate: "Weekly List Date",
    weeklyListSetDate: "Weekly List Set Date",
    weeklyListSetBy: "Weekly List Set By",
    mediaPublicationId: "Media Publication",
    ward_1: "Ward 2",
    ward_2: "Ward 3",
    ward_3: "Ward 4",
    ward_4: "Ward 5",
    ward_5: "Ward 6",
    parish_1: "Parish 2",
    parish_2: "Parish 3",
    parish_3: "Parish 4",
    parish_4: "Parish 5",
    parish_5: "Parish 6",
    multipleWards: "Multiple Wards",
    multipleParishes: "Multiple Parishes",
    publicResponseDeadline: "Public Response Deadline",
    finalCorrectionNoticeId: "FInal Correction Decision Notice",
    planningPerformanceAgreementId: "PPA",
    publicNoticeAssessmentCheck: "Public Notice Assessment Checks Completed",
    councillorCallIn: "Councillor Call In",
    decisionLevel: "Decision Level",
    planningTeamName: "Planning Team Name",
    cilLiable: "CIL Liable",
    cilLiableNotes: "CIL Liable Notes",
    potentiallyCilLiable: "Potentially CIL Liable",
    potentiallyCilLiableNotes: "Potentially CIL Liable Notes",
    s106Liable: "S106 Liable",
    s106LiableNotes: "S106 Liable Notes",
    useCategory: "Use Category",
    ppaAgreedDate: "PPA Agreed Date",
    ppApplicationVersion: "PP Application version",
    applicationNotes: "Application Notes",
    sameDetailsAsApplicant: "Same details as Applicant",
    vuid: "Virtual user id",
    publicResponseDeadlineManually: "Public Response Deadline Manually",
    eiaRequestedDate: "EIA Requested Date",
    eiaReceivedDate: "EIA Received Date",
    netIncreaseOfDwellings: "Net Increase of Dwellings",
    publicApplicationNotes: "Public Application Notes",
    geometry: "Geometry",
    constraintCheckDate: "Last Check Run on",
    bngApplicable: "BNG Applicable",
    includeOnRegister: "Include On Register",
    initialHabitatSurveyUndertaken: "Initial Habitat Survey Undertaken",
    surveyDate: "Survey Date",
    surveyNotes: "Survey Notes",
    ecologicalImpactAssessment: "Ecological Impact Assessment",
    assessmentDate: "Ecological Impact Assessment Date",
    assessmentNotes: "Assessment Notes",
    unitChangeHabitat: "Unit Change Habitat",
    unitChangeHedgeRow: "Unit Change Hedge Row",
    unitChangeRiver: "Unit Change River",
    percentChangeHabitat: "Percent Change Habitat",
    percentChangeHedgeRow: "Percent Change Hedge Row",
    percentChangeRiver: "Percent Change River",
    onSiteBaselineHabitat: "On Site Baseline Habitat",
    onSiteBaselineHedgeRow: "On Site Baseline Hedge Row",
    onSiteBaselineRiver: "On Site Baseline River",
    postInterventionHabitat: "Post Intervention Habitat",
    postInterventionHedgeRow: "Post Intervention Hedge Row",
    postInterventionRiver: "Post Intervention River",
    onSiteNetChangeHabitat: "On Site Net Change Habitat",
    onSiteNetChangeHedgeRow: "On Site Net Change Hedge Row",
    onSiteNetChangeRiver: "On Site Net Change River",
    offSiteBaselineHabitat: "Off Site Baseline Habitat",
    offSiteBaselineHedgeRow: "Off Site Baseline Hedge Row",
    offSiteBaselineRiver: "Off Site Baseline River",
    offSitePostInterventionHabitat: "Off Site Post Intervention Habitat",
    offSitePostInterventionHedgeRow: "Off Site Post Intervention Hedge Row",
    offSitePostInterventionRiver: "Off Site Post Intervention River",
    offSiteNetChangeHabitat: "Off Site Net Change Habitat",
    offSiteNetChangeHedgeRow: "Off Site Net Change Hedge Row",
    offSiteNetChangeRiver: "Off Site Net Change River",
    unitsFromCreditsHabitat: "Units from Credits Habitat",
    unitsFromCreditsHedgeRow: "Units from Credits Hedge Row",
    unitsFromCreditsRiver: "Units from Credits River",
    offsettingSitesIdentified: "Offsetting Sites Identified",
    offsettingWhereWhat: "Where/What",
    ecologicalCompensation: "Ecological Compensation",
    selfBuild: "Self Build",
    decisionExpiryDate: "Decision Expiry Date",
    committeeDecisionDate: "Committee Decision Date",
    biologicalNetGainDoesNotApply: "Biodiversity Net Gain DOES NOT Apply",
    reasonForBngNotApplyingId: "Reason for BNG Not Applying",
    name: "Name"
};
@MetaBinding()
export class PApplicationBinding extends BaseEntityRecordBinding {
    public static metadata(): EntityBinding<IPApplication> {
        return {
            entityName: "P_APPLICATION",
            pluralName: "Planning Applications",
            singularName: "Planning Application",
            entityClass: "PApplication",
            recordName: "Planning Application Name",
            relations: {
                ...BaseEntityRecordBinding.getBaseRelations(),
                useCodeId: "P_USE_CODE",
                committeeDateId: "P_COMMITTEE_DATE",
                planningTeamId: "P_TEAM",
                applicationTypeId: "P_APPLICATION_TYPE",
                receivedById: "USERS_",
                relatedApplicationId: "P_APPLICATION",
                preApplicationId: "P_APPLICATION",
                articleNoticeDocument: "ATTACHMENT",
                ownershipCertificate: "ATTACHMENT",
                ps12Code: "P_PS_12_CODE",
                priorApprovalType: "P_PRIOR_APPROVAL_TYPE",
                caseOfficerId: "USERS_",
                parentApplicationId: "P_APPLICATION",
                technicalOfficerId: "USERS_",
                validationConfirmationOfficerId: "USERS_",
                registrationValidationConfirmationUserId: "USERS_",
                applicantTypeId: "P_APPLICANT_TYPE",
                committeeAreaId: "P_COMMITTEE",
                importFromApplicationId: "P_APPLICATION",
                agentId: "P_AGENT",
                timeExtensionAgreedCorrespId: "ATTACHMENT",
                importFromDecisionId: "P_DECISION",
                supersededBy: "P_APPLICATION",
                proposedUseClassId: "P_USE_CLASS",
                currentUseClassId: "P_USE_CLASS",
                mediaPublicationId: "P_MEDIA_PUBLICATION_COVERAGE",
                finalCorrectionNoticeId: "P_DRAFT_DECISION_NOTICE",
                planningPerformanceAgreementId: "P_PLANNING_PERFORMANCE_AGREEMENT",
                reasonForBngNotApplyingId: "P_BNG_NOT_APPLYING_REASON"
            },
            columns: {
                ...BaseEntityRecordBinding.getBaseColumnBinding(),
                easting: PApplicationBinding._eastingBaseColumnBinding,
                receivedDate: PApplicationBinding._receivedDateBaseColumnBinding,
                validDate: PApplicationBinding._validDateBaseColumnBinding,
                timeExtensionAgreed: PApplicationBinding._timeExtensionAgreedBaseColumnBinding,
                drawingNumber: PApplicationBinding._drawingNumberBaseColumnBinding,
                northing: PApplicationBinding._northingBaseColumnBinding,
                statementDue: PApplicationBinding._statementDueBaseColumnBinding,
                statementSent: PApplicationBinding._statementSentBaseColumnBinding,
                finalCommentsDue: PApplicationBinding._finalCommentsDueBaseColumnBinding,
                finalCommentsSent: PApplicationBinding._finalCommentsSentBaseColumnBinding,
                siteVisit: PApplicationBinding._siteVisitBaseColumnBinding,
                useCodeId: PApplicationBinding._useCodeIdBaseColumnBinding,
                committeeDateId: PApplicationBinding._committeeDateIdBaseColumnBinding,
                decisionDate: PApplicationBinding._decisionDateBaseColumnBinding,
                officerTelephone: PApplicationBinding._officerTelephoneBaseColumnBinding,
                appealReceived: PApplicationBinding._appealReceivedBaseColumnBinding,
                appealDecisionDate: PApplicationBinding._appealDecisionDateBaseColumnBinding,
                polygonPrimaryKey: PApplicationBinding._polygonPrimaryKeyBaseColumnBinding,
                paymentAmount: PApplicationBinding._paymentAmountBaseColumnBinding,
                startingDate: PApplicationBinding._startingDateBaseColumnBinding,
                postcode: PApplicationBinding._postcodeBaseColumnBinding,
                statusDate: PApplicationBinding._statusDateBaseColumnBinding,
                planningTeamId: PApplicationBinding._planningTeamIdBaseColumnBinding,
                ward: PApplicationBinding._wardBaseColumnBinding,
                parish: PApplicationBinding._parishBaseColumnBinding,
                decisionTargetDate: PApplicationBinding._decisionTargetDateBaseColumnBinding,
                feesOutstanding: PApplicationBinding._feesOutstandingBaseColumnBinding,
                floorArea: PApplicationBinding._floorAreaBaseColumnBinding,
                bufferValue: PApplicationBinding._bufferValueBaseColumnBinding,
                applicationTypeId: PApplicationBinding._applicationTypeIdBaseColumnBinding,
                receivedById: PApplicationBinding._receivedByIdBaseColumnBinding,
                methodReceived: PApplicationBinding._methodReceivedBaseColumnBinding,
                multipleAddresses: PApplicationBinding._multipleAddressesBaseColumnBinding,
                committeeDate: PApplicationBinding._committeeDateBaseColumnBinding,
                relatedApplicationId: PApplicationBinding._relatedApplicationIdBaseColumnBinding,
                appealDecision: PApplicationBinding._appealDecisionBaseColumnBinding,
                noOfDwellings: PApplicationBinding._noOfDwellingsBaseColumnBinding,
                newFloorspace: PApplicationBinding._newFloorspaceBaseColumnBinding,
                dateWorkStarted: PApplicationBinding._dateWorkStartedBaseColumnBinding,
                dateWorkFinished: PApplicationBinding._dateWorkFinishedBaseColumnBinding,
                workStartedChangeOfUse: PApplicationBinding._workStartedChangeOfUseBaseColumnBinding,
                vat: PApplicationBinding._vatBaseColumnBinding,
                feesDue: PApplicationBinding._feesDueBaseColumnBinding,
                totalRefunds: PApplicationBinding._totalRefundsBaseColumnBinding,
                eiaRequired: PApplicationBinding._eiaRequiredBaseColumnBinding,
                designation: PApplicationBinding._designationBaseColumnBinding,
                ppaOrExtensionAgreed: PApplicationBinding._ppaOrExtensionAgreedBaseColumnBinding,
                contingencyDatesComments: PApplicationBinding._contingencyDatesCommentsBaseColumnBinding,
                extendedDate: PApplicationBinding._extendedDateBaseColumnBinding,
                validityStatusDate: PApplicationBinding._validityStatusDateBaseColumnBinding,
                articleNoticeReceived: PApplicationBinding._articleNoticeReceivedBaseColumnBinding,
                dateArticleNoticeReceived: PApplicationBinding._dateArticleNoticeReceivedBaseColumnBinding,
                articleNoticeComments: PApplicationBinding._articleNoticeCommentsBaseColumnBinding,
                preApplicationId: PApplicationBinding._preApplicationIdBaseColumnBinding,
                consulteeResponsesDeadline: PApplicationBinding._consulteeResponsesDeadlineBaseColumnBinding,
                wasWithdrawn: PApplicationBinding._wasWithdrawnBaseColumnBinding,
                calledIn: PApplicationBinding._calledInBaseColumnBinding,
                referredToSos: PApplicationBinding._referredToSosBaseColumnBinding,
                location: PApplicationBinding._locationBaseColumnBinding,
                articleNoticeDocument: PApplicationBinding._articleNoticeDocumentBaseColumnBinding,
                reportDueDate: PApplicationBinding._reportDueDateBaseColumnBinding,
                certificateOfOwnershipTypeRequired: PApplicationBinding._certificateOfOwnershipTypeRequiredBaseColumnBinding,
                appropriateCertificateProvided: PApplicationBinding._appropriateCertificateProvidedBaseColumnBinding,
                agriculturalCertificateProvided: PApplicationBinding._agriculturalCertificateProvidedBaseColumnBinding,
                ownershipCertTitle: PApplicationBinding._ownershipCertTitleBaseColumnBinding,
                declarationDate: PApplicationBinding._declarationDateBaseColumnBinding,
                declarationMade: PApplicationBinding._declarationMadeBaseColumnBinding,
                personRole: PApplicationBinding._personRoleBaseColumnBinding,
                ownershipCertificate: PApplicationBinding._ownershipCertificateBaseColumnBinding,
                decision: PApplicationBinding._decisionBaseColumnBinding,
                refundDue: PApplicationBinding._refundDueBaseColumnBinding,
                uprn: PApplicationBinding._uprnBaseColumnBinding,
                siteVisitContactType: PApplicationBinding._siteVisitContactTypeBaseColumnBinding,
                siteVisitContactName: PApplicationBinding._siteVisitContactNameBaseColumnBinding,
                siteVisitContactCompany: PApplicationBinding._siteVisitContactCompanyBaseColumnBinding,
                siteVisitContactAddress: PApplicationBinding._siteVisitContactAddressBaseColumnBinding,
                siteVisitContactPhoneNo: PApplicationBinding._siteVisitContactPhoneNoBaseColumnBinding,
                siteVisitContactEmail: PApplicationBinding._siteVisitContactEmailBaseColumnBinding,
                phoneType: PApplicationBinding._phoneTypeBaseColumnBinding,
                residentialIncludesGainLoss: PApplicationBinding._residentialIncludesGainLossBaseColumnBinding,
                residentialMarket: PApplicationBinding._residentialMarketBaseColumnBinding,
                residentialSocial: PApplicationBinding._residentialSocialBaseColumnBinding,
                residentialKeyWorker: PApplicationBinding._residentialKeyWorkerBaseColumnBinding,
                residentialIntermediate: PApplicationBinding._residentialIntermediateBaseColumnBinding,
                residentialStarterHomes: PApplicationBinding._residentialStarterHomesBaseColumnBinding,
                residentialSelfBuildCustomBuilt: PApplicationBinding._residentialSelfBuildCustomBuiltBaseColumnBinding,
                scopingOpinionSought: PApplicationBinding._scopingOpinionSoughtBaseColumnBinding,
                scopingOpinionProvided: PApplicationBinding._scopingOpinionProvidedBaseColumnBinding,
                environmentalStatementReceived: PApplicationBinding._environmentalStatementReceivedBaseColumnBinding,
                environmentalStatementRequired: PApplicationBinding._environmentalStatementRequiredBaseColumnBinding,
                schedule_1Or_2: PApplicationBinding._schedule_1Or_2BaseColumnBinding,
                planningPortalRefNo: PApplicationBinding._planningPortalRefNoBaseColumnBinding,
                ps12Code: PApplicationBinding._ps12CodeBaseColumnBinding,
                siteCanBeSeenFromPublicRoadPublic: PApplicationBinding._siteCanBeSeenFromPublicRoadPublicBaseColumnBinding,
                preferredContactMethod: PApplicationBinding._preferredContactMethodBaseColumnBinding,
                residentialMarketProposed: PApplicationBinding._residentialMarketProposedBaseColumnBinding,
                residentialSocialProposed: PApplicationBinding._residentialSocialProposedBaseColumnBinding,
                residentialKeyWorkerProposed: PApplicationBinding._residentialKeyWorkerProposedBaseColumnBinding,
                residentialIntermediateProposed: PApplicationBinding._residentialIntermediateProposedBaseColumnBinding,
                residentialStarterHomesProposed: PApplicationBinding._residentialStarterHomesProposedBaseColumnBinding,
                residentialSelfBuildCustomBuiltProposed: PApplicationBinding._residentialSelfBuildCustomBuiltProposedBaseColumnBinding,
                involvesLossGainOrChangeOfNonresidential: PApplicationBinding._involvesLossGainOrChangeOfNonresidentialBaseColumnBinding,
                includesHotelsResidentialInstitutionsEtc: PApplicationBinding._includesHotelsResidentialInstitutionsEtcBaseColumnBinding,
                anyPeoplePresentlyEmployedOnSite: PApplicationBinding._anyPeoplePresentlyEmployedOnSiteBaseColumnBinding,
                proposedEmploymentAtSite: PApplicationBinding._proposedEmploymentAtSiteBaseColumnBinding,
                involvesOpeningHours: PApplicationBinding._involvesOpeningHoursBaseColumnBinding,
                detailsOfIndustrialProcessesAndMachinery: PApplicationBinding._detailsOfIndustrialProcessesAndMachineryBaseColumnBinding,
                employmentComments: PApplicationBinding._employmentCommentsBaseColumnBinding,
                cilAgreementDate: PApplicationBinding._cilAgreementDateBaseColumnBinding,
                expiryDate: PApplicationBinding._expiryDateBaseColumnBinding,
                adviceSought: PApplicationBinding._adviceSoughtBaseColumnBinding,
                adviceDetails: PApplicationBinding._adviceDetailsBaseColumnBinding,
                unitMeasurement: PApplicationBinding._unitMeasurementBaseColumnBinding,
                workStartedWoPermission: PApplicationBinding._workStartedWoPermissionBaseColumnBinding,
                workStartedWoPermissionDate: PApplicationBinding._workStartedWoPermissionDateBaseColumnBinding,
                workCompletedWoPermission: PApplicationBinding._workCompletedWoPermissionBaseColumnBinding,
                workCompletedWoPermissionDate: PApplicationBinding._workCompletedWoPermissionDateBaseColumnBinding,
                buildingRegulationsRequired: PApplicationBinding._buildingRegulationsRequiredBaseColumnBinding,
                siteArea: PApplicationBinding._siteAreaBaseColumnBinding,
                buildingAge: PApplicationBinding._buildingAgeBaseColumnBinding,
                priorApprovalType: PApplicationBinding._priorApprovalTypeBaseColumnBinding,
                detailedPlanningLikelyRequired: PApplicationBinding._detailedPlanningLikelyRequiredBaseColumnBinding,
                notesHistoryAndInformation: PApplicationBinding._notesHistoryAndInformationBaseColumnBinding,
                buildingType: PApplicationBinding._buildingTypeBaseColumnBinding,
                occupancy: PApplicationBinding._occupancyBaseColumnBinding,
                locationType: PApplicationBinding._locationTypeBaseColumnBinding,
                commercialFloorspaceLostM: PApplicationBinding._commercialFloorspaceLostMBaseColumnBinding,
                commercialFloorspaceLostHa: PApplicationBinding._commercialFloorspaceLostHaBaseColumnBinding,
                noOfDwellingsNew: PApplicationBinding._noOfDwellingsNewBaseColumnBinding,
                proposedEmployeesFullTime: PApplicationBinding._proposedEmployeesFullTimeBaseColumnBinding,
                proposedEmployeesPartTime: PApplicationBinding._proposedEmployeesPartTimeBaseColumnBinding,
                proposedEmployeesFullTimeEquivalent: PApplicationBinding._proposedEmployeesFullTimeEquivalentBaseColumnBinding,
                agentAddressTextarea: PApplicationBinding._agentAddressTextareaBaseColumnBinding,
                agentPostTown: PApplicationBinding._agentPostTownBaseColumnBinding,
                agentPostcode: PApplicationBinding._agentPostcodeBaseColumnBinding,
                agentTelephone: PApplicationBinding._agentTelephoneBaseColumnBinding,
                agentFax: PApplicationBinding._agentFaxBaseColumnBinding,
                agentMobile: PApplicationBinding._agentMobileBaseColumnBinding,
                agentEmail: PApplicationBinding._agentEmailBaseColumnBinding,
                agentTitle: PApplicationBinding._agentTitleBaseColumnBinding,
                agentFirstName: PApplicationBinding._agentFirstNameBaseColumnBinding,
                agentSurname: PApplicationBinding._agentSurnameBaseColumnBinding,
                agentPreferredContact: PApplicationBinding._agentPreferredContactBaseColumnBinding,
                agentCountry: PApplicationBinding._agentCountryBaseColumnBinding,
                agentAddress: PApplicationBinding._agentAddressBaseColumnBinding,
                applicantAddressTextarea: PApplicationBinding._applicantAddressTextareaBaseColumnBinding,
                applicantPostTown: PApplicationBinding._applicantPostTownBaseColumnBinding,
                applicantTelephone: PApplicationBinding._applicantTelephoneBaseColumnBinding,
                applicantFax: PApplicationBinding._applicantFaxBaseColumnBinding,
                applicantMobile: PApplicationBinding._applicantMobileBaseColumnBinding,
                applicantEmail: PApplicationBinding._applicantEmailBaseColumnBinding,
                applicantTitle: PApplicationBinding._applicantTitleBaseColumnBinding,
                applicantFirstName: PApplicationBinding._applicantFirstNameBaseColumnBinding,
                applicantSurname: PApplicationBinding._applicantSurnameBaseColumnBinding,
                applicantPreferredContact: PApplicationBinding._applicantPreferredContactBaseColumnBinding,
                applicantCountry: PApplicationBinding._applicantCountryBaseColumnBinding,
                applicantAddress: PApplicationBinding._applicantAddressBaseColumnBinding,
                vehicleParkingRelevantToApplication: PApplicationBinding._vehicleParkingRelevantToApplicationBaseColumnBinding,
                sameAddressAsApplication: PApplicationBinding._sameAddressAsApplicationBaseColumnBinding,
                smApplicationFromPlanningPortal: PApplicationBinding._smApplicationFromPlanningPortalBaseColumnBinding,
                addressLine_1: PApplicationBinding._addressLine_1BaseColumnBinding,
                addressLine_2: PApplicationBinding._addressLine_2BaseColumnBinding,
                addressLine_3: PApplicationBinding._addressLine_3BaseColumnBinding,
                postTown: PApplicationBinding._postTownBaseColumnBinding,
                plansIndexed: PApplicationBinding._plansIndexedBaseColumnBinding,
                validationStage: PApplicationBinding._validationStageBaseColumnBinding,
                validationChallengeStatus: PApplicationBinding._validationChallengeStatusBaseColumnBinding,
                challengeStatusAppealDecision: PApplicationBinding._challengeStatusAppealDecisionBaseColumnBinding,
                validationAppealIssued: PApplicationBinding._validationAppealIssuedBaseColumnBinding,
                validationPinsDecision: PApplicationBinding._validationPinsDecisionBaseColumnBinding,
                caseOfficerId: PApplicationBinding._caseOfficerIdBaseColumnBinding,
                applicationReceiptAcknowledged: PApplicationBinding._applicationReceiptAcknowledgedBaseColumnBinding,
                parentApplicationId: PApplicationBinding._parentApplicationIdBaseColumnBinding,
                paymentFinalized: PApplicationBinding._paymentFinalizedBaseColumnBinding,
                listedBuildingExemption: PApplicationBinding._listedBuildingExemptionBaseColumnBinding,
                disabledAdaptationWorks: PApplicationBinding._disabledAdaptationWorksBaseColumnBinding,
                freeGoApplication: PApplicationBinding._freeGoApplicationBaseColumnBinding,
                feesImported: PApplicationBinding._feesImportedBaseColumnBinding,
                feesPaid: PApplicationBinding._feesPaidBaseColumnBinding,
                feesTransferred: PApplicationBinding._feesTransferredBaseColumnBinding,
                feesExemption: PApplicationBinding._feesExemptionBaseColumnBinding,
                feesTransferredIn: PApplicationBinding._feesTransferredInBaseColumnBinding,
                feesTransferredOut: PApplicationBinding._feesTransferredOutBaseColumnBinding,
                applicantFullName: PApplicationBinding._applicantFullNameBaseColumnBinding,
                agentFullName: PApplicationBinding._agentFullNameBaseColumnBinding,
                applicantAddressLine_2: PApplicationBinding._applicantAddressLine_2BaseColumnBinding,
                applicantAddressLine_3: PApplicationBinding._applicantAddressLine_3BaseColumnBinding,
                applicantAddressLine_1: PApplicationBinding._applicantAddressLine_1BaseColumnBinding,
                agentAddressLine_2: PApplicationBinding._agentAddressLine_2BaseColumnBinding,
                agentAddressLine_3: PApplicationBinding._agentAddressLine_3BaseColumnBinding,
                agentAddressLine_1: PApplicationBinding._agentAddressLine_1BaseColumnBinding,
                applicantPostcode: PApplicationBinding._applicantPostcodeBaseColumnBinding,
                validationProcessingComplete: PApplicationBinding._validationProcessingCompleteBaseColumnBinding,
                correctFeeConfirmed: PApplicationBinding._correctFeeConfirmedBaseColumnBinding,
                plottedBoundaryConfirmed: PApplicationBinding._plottedBoundaryConfirmedBaseColumnBinding,
                plansScanned: PApplicationBinding._plansScannedBaseColumnBinding,
                validationStatus: PApplicationBinding._validationStatusBaseColumnBinding,
                validationChallenged: PApplicationBinding._validationChallengedBaseColumnBinding,
                plottedBoundaryRequired: PApplicationBinding._plottedBoundaryRequiredBaseColumnBinding,
                validationChallengeStatusAppealed: PApplicationBinding._validationChallengeStatusAppealedBaseColumnBinding,
                plansToFollow: PApplicationBinding._plansToFollowBaseColumnBinding,
                involvesChangeOfUseClass: PApplicationBinding._involvesChangeOfUseClassBaseColumnBinding,
                boundaryPlotRequired: PApplicationBinding._boundaryPlotRequiredBaseColumnBinding,
                applicationPlotted: PApplicationBinding._applicationPlottedBaseColumnBinding,
                noBoundaryInformationProvided: PApplicationBinding._noBoundaryInformationProvidedBaseColumnBinding,
                declaredBoundaryArea: PApplicationBinding._declaredBoundaryAreaBaseColumnBinding,
                feeAmount: PApplicationBinding._feeAmountBaseColumnBinding,
                originalBoundaryArea: PApplicationBinding._originalBoundaryAreaBaseColumnBinding,
                agentCompany: PApplicationBinding._agentCompanyBaseColumnBinding,
                applicantCompany: PApplicationBinding._applicantCompanyBaseColumnBinding,
                registrationValidationConfirmedDate: PApplicationBinding._registrationValidationConfirmedDateBaseColumnBinding,
                registrationValidationConfirmed: PApplicationBinding._registrationValidationConfirmedBaseColumnBinding,
                applicationStatus: PApplicationBinding._applicationStatusBaseColumnBinding,
                timeExtensionDate: PApplicationBinding._timeExtensionDateBaseColumnBinding,
                notificationsConsultationsSent: PApplicationBinding._notificationsConsultationsSentBaseColumnBinding,
                publicNoticePublished: PApplicationBinding._publicNoticePublishedBaseColumnBinding,
                furtherInformationRequestedDate: PApplicationBinding._furtherInformationRequestedDateBaseColumnBinding,
                initialSiteVisitUndertaken: PApplicationBinding._initialSiteVisitUndertakenBaseColumnBinding,
                amendedApplication: PApplicationBinding._amendedApplicationBaseColumnBinding,
                retrospectiveApplication: PApplicationBinding._retrospectiveApplicationBaseColumnBinding,
                addressCareOfAgent: PApplicationBinding._addressCareOfAgentBaseColumnBinding,
                applicantAgentIsAMemberOfStaff: PApplicationBinding._applicantAgentIsAMemberOfStaffBaseColumnBinding,
                councillorRelativeDetails: PApplicationBinding._councillorRelativeDetailsBaseColumnBinding,
                proposal: PApplicationBinding._proposalBaseColumnBinding,
                existingGrossFloorspace: PApplicationBinding._existingGrossFloorspaceBaseColumnBinding,
                grossFloorspaceToBeLost: PApplicationBinding._grossFloorspaceToBeLostBaseColumnBinding,
                totalGrossFloorspaceProposed: PApplicationBinding._totalGrossFloorspaceProposedBaseColumnBinding,
                netAdditionalGrossFloorspace: PApplicationBinding._netAdditionalGrossFloorspaceBaseColumnBinding,
                technicalOfficerId: PApplicationBinding._technicalOfficerIdBaseColumnBinding,
                submittedDetails: PApplicationBinding._submittedDetailsBaseColumnBinding,
                feesComments: PApplicationBinding._feesCommentsBaseColumnBinding,
                parishCouncilDiscount: PApplicationBinding._parishCouncilDiscountBaseColumnBinding,
                decisionCode: PApplicationBinding._decisionCodeBaseColumnBinding,
                decisionClass: PApplicationBinding._decisionClassBaseColumnBinding,
                changeAffectingCentre: PApplicationBinding._changeAffectingCentreBaseColumnBinding,
                appealTargetDate: PApplicationBinding._appealTargetDateBaseColumnBinding,
                notificationResponseDeadline: PApplicationBinding._notificationResponseDeadlineBaseColumnBinding,
                renotificationResponseDeadline: PApplicationBinding._renotificationResponseDeadlineBaseColumnBinding,
                consultationResponseDeadline: PApplicationBinding._consultationResponseDeadlineBaseColumnBinding,
                reconsultationResponseDeadline: PApplicationBinding._reconsultationResponseDeadlineBaseColumnBinding,
                siteVisitContactBefore: PApplicationBinding._siteVisitContactBeforeBaseColumnBinding,
                plottedBoundaryArea: PApplicationBinding._plottedBoundaryAreaBaseColumnBinding,
                validationConfirmationOfficerId: PApplicationBinding._validationConfirmationOfficerIdBaseColumnBinding,
                registrationValidationConfirmationUserId: PApplicationBinding._registrationValidationConfirmationUserIdBaseColumnBinding,
                feeCategory: PApplicationBinding._feeCategoryBaseColumnBinding,
                applicantTypeId: PApplicationBinding._applicantTypeIdBaseColumnBinding,
                addedDate: PApplicationBinding._addedDateBaseColumnBinding,
                registeredDate: PApplicationBinding._registeredDateBaseColumnBinding,
                existingEmployeesFullTime: PApplicationBinding._existingEmployeesFullTimeBaseColumnBinding,
                existingEmployeesFullTimeEquivalent: PApplicationBinding._existingEmployeesFullTimeEquivalentBaseColumnBinding,
                existingEmployeesPartTime: PApplicationBinding._existingEmployeesPartTimeBaseColumnBinding,
                declarationFirstName: PApplicationBinding._declarationFirstNameBaseColumnBinding,
                declarationSurname: PApplicationBinding._declarationSurnameBaseColumnBinding,
                committeeAreaId: PApplicationBinding._committeeAreaIdBaseColumnBinding,
                referredToGla: PApplicationBinding._referredToGlaBaseColumnBinding,
                dateSentToGla: PApplicationBinding._dateSentToGlaBaseColumnBinding,
                dateReturnedFromGla: PApplicationBinding._dateReturnedFromGlaBaseColumnBinding,
                daysForGlaReturn: PApplicationBinding._daysForGlaReturnBaseColumnBinding,
                reasonForGla: PApplicationBinding._reasonForGlaBaseColumnBinding,
                dateSentToSos: PApplicationBinding._dateSentToSosBaseColumnBinding,
                dateReturnedFromSos: PApplicationBinding._dateReturnedFromSosBaseColumnBinding,
                daysMtgReturnFromSos: PApplicationBinding._daysMtgReturnFromSosBaseColumnBinding,
                reasonForSos: PApplicationBinding._reasonForSosBaseColumnBinding,
                initialAppRef: PApplicationBinding._initialAppRefBaseColumnBinding,
                outstandingValidationStageTasks: PApplicationBinding._outstandingValidationStageTasksBaseColumnBinding,
                advertisementDate: PApplicationBinding._advertisementDateBaseColumnBinding,
                advertisementPublication: PApplicationBinding._advertisementPublicationBaseColumnBinding,
                notificationStepsTaken: PApplicationBinding._notificationStepsTakenBaseColumnBinding,
                smFullNameGenerated: PApplicationBinding._smFullNameGeneratedBaseColumnBinding,
                paymentStatusNotes: PApplicationBinding._paymentStatusNotesBaseColumnBinding,
                prevalidationCommentary: PApplicationBinding._prevalidationCommentaryBaseColumnBinding,
                certificateOfOwnershipTypeProvided: PApplicationBinding._certificateOfOwnershipTypeProvidedBaseColumnBinding,
                incorrectPlanningAuthority: PApplicationBinding._incorrectPlanningAuthorityBaseColumnBinding,
                proposalDescriptionConfirmed: PApplicationBinding._proposalDescriptionConfirmedBaseColumnBinding,
                importFromApplicationId: PApplicationBinding._importFromApplicationIdBaseColumnBinding,
                plottedBoundaryAreaTemp: PApplicationBinding._plottedBoundaryAreaTempBaseColumnBinding,
                agentId: PApplicationBinding._agentIdBaseColumnBinding,
                validationDecisionDate: PApplicationBinding._validationDecisionDateBaseColumnBinding,
                timeExtensionAgreedCorrespId: PApplicationBinding._timeExtensionAgreedCorrespIdBaseColumnBinding,
                multipleApplicants: PApplicationBinding._multipleApplicantsBaseColumnBinding,
                importFromDecisionId: PApplicationBinding._importFromDecisionIdBaseColumnBinding,
                consultationsRequired: PApplicationBinding._consultationsRequiredBaseColumnBinding,
                notificationsRequired: PApplicationBinding._notificationsRequiredBaseColumnBinding,
                supersedesPreviousApplication: PApplicationBinding._supersedesPreviousApplicationBaseColumnBinding,
                applicationSuperseded: PApplicationBinding._applicationSupersededBaseColumnBinding,
                supersededBy: PApplicationBinding._supersededByBaseColumnBinding,
                partiallySuperseded: PApplicationBinding._partiallySupersededBaseColumnBinding,
                validationDecision: PApplicationBinding._validationDecisionBaseColumnBinding,
                proposedUseClassId: PApplicationBinding._proposedUseClassIdBaseColumnBinding,
                currentUseClassId: PApplicationBinding._currentUseClassIdBaseColumnBinding,
                amendmentDecision: PApplicationBinding._amendmentDecisionBaseColumnBinding,
                eiaDocumentLocation: PApplicationBinding._eiaDocumentLocationBaseColumnBinding,
                validationChallengeStatusDate: PApplicationBinding._validationChallengeStatusDateBaseColumnBinding,
                publicNoticeDisplayedOnSite: PApplicationBinding._publicNoticeDisplayedOnSiteBaseColumnBinding,
                footpathCrossesBoundary: PApplicationBinding._footpathCrossesBoundaryBaseColumnBinding,
                isADepartureFromLocalPlan: PApplicationBinding._isADepartureFromLocalPlanBaseColumnBinding,
                workToAListedBuilding: PApplicationBinding._workToAListedBuildingBaseColumnBinding,
                affectsSettingOfListedBuilding: PApplicationBinding._affectsSettingOfListedBuildingBaseColumnBinding,
                demolitionInConservationArea: PApplicationBinding._demolitionInConservationAreaBaseColumnBinding,
                affectsSettingOfConservationArea: PApplicationBinding._affectsSettingOfConservationAreaBaseColumnBinding,
                includeInNextWeeklyList: PApplicationBinding._includeInNextWeeklyListBaseColumnBinding,
                proposalDetailsChanged: PApplicationBinding._proposalDetailsChangedBaseColumnBinding,
                requiresReadvertisement: PApplicationBinding._requiresReadvertisementBaseColumnBinding,
                dateProposalChanged: PApplicationBinding._dateProposalChangedBaseColumnBinding,
                weeklyListDate: PApplicationBinding._weeklyListDateBaseColumnBinding,
                weeklyListSetDate: PApplicationBinding._weeklyListSetDateBaseColumnBinding,
                weeklyListSetBy: PApplicationBinding._weeklyListSetByBaseColumnBinding,
                mediaPublicationId: PApplicationBinding._mediaPublicationIdBaseColumnBinding,
                ward_1: PApplicationBinding._ward_1BaseColumnBinding,
                ward_2: PApplicationBinding._ward_2BaseColumnBinding,
                ward_3: PApplicationBinding._ward_3BaseColumnBinding,
                ward_4: PApplicationBinding._ward_4BaseColumnBinding,
                ward_5: PApplicationBinding._ward_5BaseColumnBinding,
                parish_1: PApplicationBinding._parish_1BaseColumnBinding,
                parish_2: PApplicationBinding._parish_2BaseColumnBinding,
                parish_3: PApplicationBinding._parish_3BaseColumnBinding,
                parish_4: PApplicationBinding._parish_4BaseColumnBinding,
                parish_5: PApplicationBinding._parish_5BaseColumnBinding,
                multipleWards: PApplicationBinding._multipleWardsBaseColumnBinding,
                multipleParishes: PApplicationBinding._multipleParishesBaseColumnBinding,
                publicResponseDeadline: PApplicationBinding._publicResponseDeadlineBaseColumnBinding,
                finalCorrectionNoticeId: PApplicationBinding._finalCorrectionNoticeIdBaseColumnBinding,
                planningPerformanceAgreementId: PApplicationBinding._planningPerformanceAgreementIdBaseColumnBinding,
                publicNoticeAssessmentCheck: PApplicationBinding._publicNoticeAssessmentCheckBaseColumnBinding,
                councillorCallIn: PApplicationBinding._councillorCallInBaseColumnBinding,
                decisionLevel: PApplicationBinding._decisionLevelBaseColumnBinding,
                planningTeamName: PApplicationBinding._planningTeamNameBaseColumnBinding,
                cilLiable: PApplicationBinding._cilLiableBaseColumnBinding,
                cilLiableNotes: PApplicationBinding._cilLiableNotesBaseColumnBinding,
                potentiallyCilLiable: PApplicationBinding._potentiallyCilLiableBaseColumnBinding,
                potentiallyCilLiableNotes: PApplicationBinding._potentiallyCilLiableNotesBaseColumnBinding,
                s106Liable: PApplicationBinding._s106LiableBaseColumnBinding,
                s106LiableNotes: PApplicationBinding._s106LiableNotesBaseColumnBinding,
                useCategory: PApplicationBinding._useCategoryBaseColumnBinding,
                ppaAgreedDate: PApplicationBinding._ppaAgreedDateBaseColumnBinding,
                ppApplicationVersion: PApplicationBinding._ppApplicationVersionBaseColumnBinding,
                applicationNotes: PApplicationBinding._applicationNotesBaseColumnBinding,
                sameDetailsAsApplicant: PApplicationBinding._sameDetailsAsApplicantBaseColumnBinding,
                vuid: PApplicationBinding._vuidBaseColumnBinding,
                publicResponseDeadlineManually: PApplicationBinding._publicResponseDeadlineManuallyBaseColumnBinding,
                eiaRequestedDate: PApplicationBinding._eiaRequestedDateBaseColumnBinding,
                eiaReceivedDate: PApplicationBinding._eiaReceivedDateBaseColumnBinding,
                netIncreaseOfDwellings: PApplicationBinding._netIncreaseOfDwellingsBaseColumnBinding,
                publicApplicationNotes: PApplicationBinding._publicApplicationNotesBaseColumnBinding,
                geometry: PApplicationBinding._geometryBaseColumnBinding,
                constraintCheckDate: PApplicationBinding._constraintCheckDateBaseColumnBinding,
                bngApplicable: PApplicationBinding._bngApplicableBaseColumnBinding,
                includeOnRegister: PApplicationBinding._includeOnRegisterBaseColumnBinding,
                initialHabitatSurveyUndertaken: PApplicationBinding._initialHabitatSurveyUndertakenBaseColumnBinding,
                surveyDate: PApplicationBinding._surveyDateBaseColumnBinding,
                surveyNotes: PApplicationBinding._surveyNotesBaseColumnBinding,
                ecologicalImpactAssessment: PApplicationBinding._ecologicalImpactAssessmentBaseColumnBinding,
                assessmentDate: PApplicationBinding._assessmentDateBaseColumnBinding,
                assessmentNotes: PApplicationBinding._assessmentNotesBaseColumnBinding,
                unitChangeHabitat: PApplicationBinding._unitChangeHabitatBaseColumnBinding,
                unitChangeHedgeRow: PApplicationBinding._unitChangeHedgeRowBaseColumnBinding,
                unitChangeRiver: PApplicationBinding._unitChangeRiverBaseColumnBinding,
                percentChangeHabitat: PApplicationBinding._percentChangeHabitatBaseColumnBinding,
                percentChangeHedgeRow: PApplicationBinding._percentChangeHedgeRowBaseColumnBinding,
                percentChangeRiver: PApplicationBinding._percentChangeRiverBaseColumnBinding,
                onSiteBaselineHabitat: PApplicationBinding._onSiteBaselineHabitatBaseColumnBinding,
                onSiteBaselineHedgeRow: PApplicationBinding._onSiteBaselineHedgeRowBaseColumnBinding,
                onSiteBaselineRiver: PApplicationBinding._onSiteBaselineRiverBaseColumnBinding,
                postInterventionHabitat: PApplicationBinding._postInterventionHabitatBaseColumnBinding,
                postInterventionHedgeRow: PApplicationBinding._postInterventionHedgeRowBaseColumnBinding,
                postInterventionRiver: PApplicationBinding._postInterventionRiverBaseColumnBinding,
                onSiteNetChangeHabitat: PApplicationBinding._onSiteNetChangeHabitatBaseColumnBinding,
                onSiteNetChangeHedgeRow: PApplicationBinding._onSiteNetChangeHedgeRowBaseColumnBinding,
                onSiteNetChangeRiver: PApplicationBinding._onSiteNetChangeRiverBaseColumnBinding,
                offSiteBaselineHabitat: PApplicationBinding._offSiteBaselineHabitatBaseColumnBinding,
                offSiteBaselineHedgeRow: PApplicationBinding._offSiteBaselineHedgeRowBaseColumnBinding,
                offSiteBaselineRiver: PApplicationBinding._offSiteBaselineRiverBaseColumnBinding,
                offSitePostInterventionHabitat: PApplicationBinding._offSitePostInterventionHabitatBaseColumnBinding,
                offSitePostInterventionHedgeRow: PApplicationBinding._offSitePostInterventionHedgeRowBaseColumnBinding,
                offSitePostInterventionRiver: PApplicationBinding._offSitePostInterventionRiverBaseColumnBinding,
                offSiteNetChangeHabitat: PApplicationBinding._offSiteNetChangeHabitatBaseColumnBinding,
                offSiteNetChangeHedgeRow: PApplicationBinding._offSiteNetChangeHedgeRowBaseColumnBinding,
                offSiteNetChangeRiver: PApplicationBinding._offSiteNetChangeRiverBaseColumnBinding,
                unitsFromCreditsHabitat: PApplicationBinding._unitsFromCreditsHabitatBaseColumnBinding,
                unitsFromCreditsHedgeRow: PApplicationBinding._unitsFromCreditsHedgeRowBaseColumnBinding,
                unitsFromCreditsRiver: PApplicationBinding._unitsFromCreditsRiverBaseColumnBinding,
                offsettingSitesIdentified: PApplicationBinding._offsettingSitesIdentifiedBaseColumnBinding,
                offsettingWhereWhat: PApplicationBinding._offsettingWhereWhatBaseColumnBinding,
                ecologicalCompensation: PApplicationBinding._ecologicalCompensationBaseColumnBinding,
                selfBuild: PApplicationBinding._selfBuildBaseColumnBinding,
                decisionExpiryDate: PApplicationBinding._decisionExpiryDateBaseColumnBinding,
                committeeDecisionDate: PApplicationBinding._committeeDecisionDateBaseColumnBinding,
                biologicalNetGainDoesNotApply: PApplicationBinding._biologicalNetGainDoesNotApplyBaseColumnBinding,
                reasonForBngNotApplyingId: PApplicationBinding._reasonForBngNotApplyingIdBaseColumnBinding
            },
            labelsMap: new Map<string, string>(Object.entries(labelsMapObj))
        };
    }
    protected static _eastingBaseColumnBinding: BaseColumnBinding = {
        label: "Easting (x)",
        templateLabel: "",
        fieldName: "easting",
        dbColumnName: "EASTING",
        isRequired: false,
        contentType: "NUMBER",
        length: 9,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _eastingColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._eastingBaseColumnBinding),
    };
    public get easting(): ColumnBinding<number | null> {
        return this._eastingColumnBinding;
    }
    protected static _receivedDateBaseColumnBinding: BaseColumnBinding = {
        label: "Received Date",
        templateLabel: "",
        fieldName: "receivedDate",
        dbColumnName: "RECEIVED_DATE",
        isRequired: true,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _receivedDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._receivedDateBaseColumnBinding),
    };
    public get receivedDate(): ColumnBinding<Date | null> {
        return this._receivedDateColumnBinding;
    }
    protected static _validDateBaseColumnBinding: BaseColumnBinding = {
        label: "Valid Date",
        templateLabel: "",
        fieldName: "validDate",
        dbColumnName: "VALID_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _validDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._validDateBaseColumnBinding),
    };
    public get validDate(): ColumnBinding<Date | null> {
        return this._validDateColumnBinding;
    }
    protected static _timeExtensionAgreedBaseColumnBinding: BaseColumnBinding = {
        label: "Time extension agreed?",
        templateLabel: "",
        fieldName: "timeExtensionAgreed",
        dbColumnName: "TIME_EXTENSION_AGREED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _timeExtensionAgreedColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._timeExtensionAgreedBaseColumnBinding),
    };
    public get timeExtensionAgreed(): ColumnBinding<number | null> {
        return this._timeExtensionAgreedColumnBinding;
    }
    protected static _drawingNumberBaseColumnBinding: BaseColumnBinding = {
        label: "Drawing Number",
        templateLabel: "",
        fieldName: "drawingNumber",
        dbColumnName: "DRAWING_NUMBER",
        isRequired: false,
        contentType: "TEXTAREA",
        length: 100,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _drawingNumberColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._drawingNumberBaseColumnBinding),
    };
    public get drawingNumber(): ColumnBinding<string | null> {
        return this._drawingNumberColumnBinding;
    }
    protected static _northingBaseColumnBinding: BaseColumnBinding = {
        label: "Northing (y)",
        templateLabel: "",
        fieldName: "northing",
        dbColumnName: "NORTHING",
        isRequired: false,
        contentType: "NUMBER",
        length: 9,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _northingColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._northingBaseColumnBinding),
    };
    public get northing(): ColumnBinding<number | null> {
        return this._northingColumnBinding;
    }
    protected static _statementDueBaseColumnBinding: BaseColumnBinding = {
        label: "Statement Due",
        templateLabel: "",
        fieldName: "statementDue",
        dbColumnName: "STATEMENT_DUE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _statementDueColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._statementDueBaseColumnBinding),
    };
    public get statementDue(): ColumnBinding<Date | null> {
        return this._statementDueColumnBinding;
    }
    protected static _statementSentBaseColumnBinding: BaseColumnBinding = {
        label: "Statement Sent",
        templateLabel: "",
        fieldName: "statementSent",
        dbColumnName: "STATEMENT_SENT",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _statementSentColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._statementSentBaseColumnBinding),
    };
    public get statementSent(): ColumnBinding<Date | null> {
        return this._statementSentColumnBinding;
    }
    protected static _finalCommentsDueBaseColumnBinding: BaseColumnBinding = {
        label: "Final Comments Due",
        templateLabel: "",
        fieldName: "finalCommentsDue",
        dbColumnName: "FINAL_COMMENTS_DUE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _finalCommentsDueColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._finalCommentsDueBaseColumnBinding),
    };
    public get finalCommentsDue(): ColumnBinding<Date | null> {
        return this._finalCommentsDueColumnBinding;
    }
    protected static _finalCommentsSentBaseColumnBinding: BaseColumnBinding = {
        label: "Final Comments Sent",
        templateLabel: "",
        fieldName: "finalCommentsSent",
        dbColumnName: "FINAL_COMMENTS_SENT",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _finalCommentsSentColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._finalCommentsSentBaseColumnBinding),
    };
    public get finalCommentsSent(): ColumnBinding<Date | null> {
        return this._finalCommentsSentColumnBinding;
    }
    protected static _siteVisitBaseColumnBinding: BaseColumnBinding = {
        label: "Site Visit",
        templateLabel: "",
        fieldName: "siteVisit",
        dbColumnName: "SITE_VISIT",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _siteVisitColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._siteVisitBaseColumnBinding),
    };
    public get siteVisit(): ColumnBinding<Date | null> {
        return this._siteVisitColumnBinding;
    }
    protected static _useCodeIdBaseColumnBinding: BaseColumnBinding = {
        label: "Use Code",
        templateLabel: "",
        fieldName: "useCodeId",
        dbColumnName: "USE_CODE_ID",
        isRequired: false,
        contentType: "LOOKUP",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: "P_USE_CODE",
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _useCodeIdColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._useCodeIdBaseColumnBinding),
    };
    public get useCodeId(): ColumnBinding<number | null> {
        return this._useCodeIdColumnBinding;
    }
    protected static _committeeDateIdBaseColumnBinding: BaseColumnBinding = {
        label: "Committee Date ID",
        templateLabel: "",
        fieldName: "committeeDateId",
        dbColumnName: "COMMITTEE_DATE_ID",
        isRequired: false,
        contentType: "LOOKUP",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: "P_COMMITTEE_DATE",
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _committeeDateIdColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._committeeDateIdBaseColumnBinding),
    };
    public get committeeDateId(): ColumnBinding<number | null> {
        return this._committeeDateIdColumnBinding;
    }
    protected static _decisionDateBaseColumnBinding: BaseColumnBinding = {
        label: "Actual Decision Date",
        templateLabel: "",
        fieldName: "decisionDate",
        dbColumnName: "DECISION_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _decisionDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._decisionDateBaseColumnBinding),
    };
    public get decisionDate(): ColumnBinding<Date | null> {
        return this._decisionDateColumnBinding;
    }
    protected static _officerTelephoneBaseColumnBinding: BaseColumnBinding = {
        label: "Telephone",
        templateLabel: "",
        fieldName: "officerTelephone",
        dbColumnName: "OFFICER_TELEPHONE",
        isRequired: false,
        contentType: "TEXT",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _officerTelephoneColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._officerTelephoneBaseColumnBinding),
    };
    public get officerTelephone(): ColumnBinding<string | null> {
        return this._officerTelephoneColumnBinding;
    }
    protected static _appealReceivedBaseColumnBinding: BaseColumnBinding = {
        label: "Appeal received",
        templateLabel: "",
        fieldName: "appealReceived",
        dbColumnName: "APPEAL_RECEIVED",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _appealReceivedColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._appealReceivedBaseColumnBinding),
    };
    public get appealReceived(): ColumnBinding<Date | null> {
        return this._appealReceivedColumnBinding;
    }
    protected static _appealDecisionDateBaseColumnBinding: BaseColumnBinding = {
        label: "Appeal Decision Date",
        templateLabel: "",
        fieldName: "appealDecisionDate",
        dbColumnName: "APPEAL_DECISION_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _appealDecisionDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._appealDecisionDateBaseColumnBinding),
    };
    public get appealDecisionDate(): ColumnBinding<Date | null> {
        return this._appealDecisionDateColumnBinding;
    }
    protected static _polygonPrimaryKeyBaseColumnBinding: BaseColumnBinding = {
        label: "Polygon Primary Key",
        templateLabel: "",
        fieldName: "polygonPrimaryKey",
        dbColumnName: "POLYGON_PRIMARY_KEY",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _polygonPrimaryKeyColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._polygonPrimaryKeyBaseColumnBinding),
    };
    public get polygonPrimaryKey(): ColumnBinding<number | null> {
        return this._polygonPrimaryKeyColumnBinding;
    }
    protected static _paymentAmountBaseColumnBinding: BaseColumnBinding = {
        label: "Payment Amount",
        templateLabel: "",
        fieldName: "paymentAmount",
        dbColumnName: "PAYMENT_AMOUNT",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _paymentAmountColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._paymentAmountBaseColumnBinding),
    };
    public get paymentAmount(): ColumnBinding<number | null> {
        return this._paymentAmountColumnBinding;
    }
    protected static _startingDateBaseColumnBinding: BaseColumnBinding = {
        label: "Starting Date",
        templateLabel: "",
        fieldName: "startingDate",
        dbColumnName: "STARTING_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _startingDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._startingDateBaseColumnBinding),
    };
    public get startingDate(): ColumnBinding<Date | null> {
        return this._startingDateColumnBinding;
    }
    protected static _postcodeBaseColumnBinding: BaseColumnBinding = {
        label: "Postcode",
        templateLabel: "",
        fieldName: "postcode",
        dbColumnName: "POSTCODE",
        isRequired: false,
        contentType: "TEXT",
        length: 100,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _postcodeColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._postcodeBaseColumnBinding),
    };
    public get postcode(): ColumnBinding<string | null> {
        return this._postcodeColumnBinding;
    }
    protected static _statusDateBaseColumnBinding: BaseColumnBinding = {
        label: "Status Date",
        templateLabel: "",
        fieldName: "statusDate",
        dbColumnName: "STATUS_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _statusDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._statusDateBaseColumnBinding),
    };
    public get statusDate(): ColumnBinding<Date | null> {
        return this._statusDateColumnBinding;
    }
    protected static _planningTeamIdBaseColumnBinding: BaseColumnBinding = {
        label: "Planning Team",
        templateLabel: "",
        fieldName: "planningTeamId",
        dbColumnName: "PLANNING_TEAM_ID",
        isRequired: false,
        contentType: "LOOKUP",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: "P_TEAM",
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _planningTeamIdColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._planningTeamIdBaseColumnBinding),
    };
    public get planningTeamId(): ColumnBinding<number | null> {
        return this._planningTeamIdColumnBinding;
    }
    protected static _wardBaseColumnBinding: BaseColumnBinding = {
        label: "Ward",
        templateLabel: "",
        fieldName: "ward",
        dbColumnName: "WARD",
        isRequired: false,
        contentType: "TEXT",
        length: 100,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _wardColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._wardBaseColumnBinding),
    };
    public get ward(): ColumnBinding<string | null> {
        return this._wardColumnBinding;
    }
    protected static _parishBaseColumnBinding: BaseColumnBinding = {
        label: "Parish",
        templateLabel: "",
        fieldName: "parish",
        dbColumnName: "PARISH",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _parishColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._parishBaseColumnBinding),
    };
    public get parish(): ColumnBinding<string | null> {
        return this._parishColumnBinding;
    }
    protected static _decisionTargetDateBaseColumnBinding: BaseColumnBinding = {
        label: "Decision Target Date",
        templateLabel: "",
        fieldName: "decisionTargetDate",
        dbColumnName: "DECISION_TARGET_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _decisionTargetDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._decisionTargetDateBaseColumnBinding),
    };
    public get decisionTargetDate(): ColumnBinding<Date | null> {
        return this._decisionTargetDateColumnBinding;
    }
    protected static _feesOutstandingBaseColumnBinding: BaseColumnBinding = {
        label: "Total Fees Outstanding",
        templateLabel: "",
        fieldName: "feesOutstanding",
        dbColumnName: "FEES_OUTSTANDING",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _feesOutstandingColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._feesOutstandingBaseColumnBinding),
    };
    public get feesOutstanding(): ColumnBinding<number | null> {
        return this._feesOutstandingColumnBinding;
    }
    protected static _floorAreaBaseColumnBinding: BaseColumnBinding = {
        label: "Floor Area (sq.m)",
        templateLabel: "",
        fieldName: "floorArea",
        dbColumnName: "FLOOR_AREA",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _floorAreaColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._floorAreaBaseColumnBinding),
    };
    public get floorArea(): ColumnBinding<number | null> {
        return this._floorAreaColumnBinding;
    }
    protected static _bufferValueBaseColumnBinding: BaseColumnBinding = {
        label: "Buffer Value",
        templateLabel: "",
        fieldName: "bufferValue",
        dbColumnName: "BUFFER_VALUE",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _bufferValueColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._bufferValueBaseColumnBinding),
    };
    public get bufferValue(): ColumnBinding<number | null> {
        return this._bufferValueColumnBinding;
    }
    protected static _applicationTypeIdBaseColumnBinding: BaseColumnBinding = {
        label: "Application Type",
        templateLabel: "",
        fieldName: "applicationTypeId",
        dbColumnName: "APPLICATION_TYPE_ID",
        isRequired: true,
        contentType: "LOOKUP",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: "P_APPLICATION_TYPE",
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _applicationTypeIdColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._applicationTypeIdBaseColumnBinding),
    };
    public get applicationTypeId(): ColumnBinding<number | null> {
        return this._applicationTypeIdColumnBinding;
    }
    protected static _receivedByIdBaseColumnBinding: BaseColumnBinding = {
        label: "Received By",
        templateLabel: "",
        fieldName: "receivedById",
        dbColumnName: "RECEIVED_BY_ID",
        isRequired: false,
        contentType: "LOOKUP",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: "USERS_",
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _receivedByIdColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._receivedByIdBaseColumnBinding),
    };
    public get receivedById(): ColumnBinding<number | null> {
        return this._receivedByIdColumnBinding;
    }
    protected static _methodReceivedBaseColumnBinding: BaseColumnBinding = {
        label: "How Received",
        templateLabel: "",
        fieldName: "methodReceived",
        dbColumnName: "METHOD_RECEIVED",
        isRequired: true,
        contentType: "PICKLIST",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: "PM_HOW_RECEIVED",
        options: [
            "E-mail",
            "Hardcopy / Post",
            "Planning Portal"
        ],
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _methodReceivedColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._methodReceivedBaseColumnBinding),
    };
    public get methodReceived(): ColumnBinding<string | null> {
        return this._methodReceivedColumnBinding;
    }
    protected static _multipleAddressesBaseColumnBinding: BaseColumnBinding = {
        label: "Multiple addresses?",
        templateLabel: "",
        fieldName: "multipleAddresses",
        dbColumnName: "MULTIPLE_ADDRESSES",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _multipleAddressesColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._multipleAddressesBaseColumnBinding),
    };
    public get multipleAddresses(): ColumnBinding<number | null> {
        return this._multipleAddressesColumnBinding;
    }
    protected static _committeeDateBaseColumnBinding: BaseColumnBinding = {
        label: "Committee Date",
        templateLabel: "",
        fieldName: "committeeDate",
        dbColumnName: "COMMITTEE_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _committeeDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._committeeDateBaseColumnBinding),
    };
    public get committeeDate(): ColumnBinding<Date | null> {
        return this._committeeDateColumnBinding;
    }
    protected static _relatedApplicationIdBaseColumnBinding: BaseColumnBinding = {
        label: "Related application",
        templateLabel: "",
        fieldName: "relatedApplicationId",
        dbColumnName: "RELATED_APPLICATION_ID",
        isRequired: false,
        contentType: "LOOKUP",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: "P_APPLICATION",
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _relatedApplicationIdColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._relatedApplicationIdBaseColumnBinding),
    };
    public get relatedApplicationId(): ColumnBinding<number | null> {
        return this._relatedApplicationIdColumnBinding;
    }
    protected static _appealDecisionBaseColumnBinding: BaseColumnBinding = {
        label: "Appeal Decision",
        templateLabel: "",
        fieldName: "appealDecision",
        dbColumnName: "APPEAL_DECISION",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _appealDecisionColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._appealDecisionBaseColumnBinding),
    };
    public get appealDecision(): ColumnBinding<string | null> {
        return this._appealDecisionColumnBinding;
    }
    protected static _noOfDwellingsBaseColumnBinding: BaseColumnBinding = {
        label: "No. of Dwellings",
        templateLabel: "",
        fieldName: "noOfDwellings",
        dbColumnName: "NO_OF_DWELLINGS",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _noOfDwellingsColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._noOfDwellingsBaseColumnBinding),
    };
    public get noOfDwellings(): ColumnBinding<number | null> {
        return this._noOfDwellingsColumnBinding;
    }
    protected static _newFloorspaceBaseColumnBinding: BaseColumnBinding = {
        label: "New Floorspace (sq.m)",
        templateLabel: "",
        fieldName: "newFloorspace",
        dbColumnName: "NEW_FLOORSPACE",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _newFloorspaceColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._newFloorspaceBaseColumnBinding),
    };
    public get newFloorspace(): ColumnBinding<number | null> {
        return this._newFloorspaceColumnBinding;
    }
    protected static _dateWorkStartedBaseColumnBinding: BaseColumnBinding = {
        label: "Date Work Started",
        templateLabel: "",
        fieldName: "dateWorkStarted",
        dbColumnName: "DATE_WORK_STARTED",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _dateWorkStartedColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._dateWorkStartedBaseColumnBinding),
    };
    public get dateWorkStarted(): ColumnBinding<Date | null> {
        return this._dateWorkStartedColumnBinding;
    }
    protected static _dateWorkFinishedBaseColumnBinding: BaseColumnBinding = {
        label: "Date Work Finished",
        templateLabel: "",
        fieldName: "dateWorkFinished",
        dbColumnName: "DATE_WORK_FINISHED",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _dateWorkFinishedColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._dateWorkFinishedBaseColumnBinding),
    };
    public get dateWorkFinished(): ColumnBinding<Date | null> {
        return this._dateWorkFinishedColumnBinding;
    }
    protected static _workStartedChangeOfUseBaseColumnBinding: BaseColumnBinding = {
        label: "Work already started / change of use happened",
        templateLabel: "",
        fieldName: "workStartedChangeOfUse",
        dbColumnName: "WORK_STARTED_CHANGE_OF_USE",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _workStartedChangeOfUseColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._workStartedChangeOfUseBaseColumnBinding),
    };
    public get workStartedChangeOfUse(): ColumnBinding<number | null> {
        return this._workStartedChangeOfUseColumnBinding;
    }
    protected static _vatBaseColumnBinding: BaseColumnBinding = {
        label: "V.A.T",
        templateLabel: "",
        fieldName: "vat",
        dbColumnName: "VAT",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _vatColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._vatBaseColumnBinding),
    };
    public get vat(): ColumnBinding<number | null> {
        return this._vatColumnBinding;
    }
    protected static _feesDueBaseColumnBinding: BaseColumnBinding = {
        label: "Total Fees Due",
        templateLabel: "",
        fieldName: "feesDue",
        dbColumnName: "FEES_DUE",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _feesDueColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._feesDueBaseColumnBinding),
    };
    public get feesDue(): ColumnBinding<number | null> {
        return this._feesDueColumnBinding;
    }
    protected static _totalRefundsBaseColumnBinding: BaseColumnBinding = {
        label: "Total Refunds",
        templateLabel: "",
        fieldName: "totalRefunds",
        dbColumnName: "TOTAL_REFUNDS",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _totalRefundsColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._totalRefundsBaseColumnBinding),
    };
    public get totalRefunds(): ColumnBinding<number | null> {
        return this._totalRefundsColumnBinding;
    }
    protected static _eiaRequiredBaseColumnBinding: BaseColumnBinding = {
        label: "EIA Required",
        templateLabel: "",
        fieldName: "eiaRequired",
        dbColumnName: "EIA_REQUIRED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _eiaRequiredColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._eiaRequiredBaseColumnBinding),
    };
    public get eiaRequired(): ColumnBinding<number | null> {
        return this._eiaRequiredColumnBinding;
    }
    protected static _designationBaseColumnBinding: BaseColumnBinding = {
        label: "Designation",
        templateLabel: "",
        fieldName: "designation",
        dbColumnName: "DESIGNATION",
        isRequired: true,
        contentType: "PICKLIST",
        length: 0,
        defaultValue: "(i) MINOR",
        helpText: null,
        picklistName: "PM_DESIGNATION",
        options: [
            "(i) MINOR",
            "(ii) MAJOR",
            "(iii) OTHER"
        ],
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _designationColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._designationBaseColumnBinding),
    };
    public get designation(): ColumnBinding<string | null> {
        return this._designationColumnBinding;
    }
    protected static _ppaOrExtensionAgreedBaseColumnBinding: BaseColumnBinding = {
        label: "PPA Agreed",
        templateLabel: "",
        fieldName: "ppaOrExtensionAgreed",
        dbColumnName: "PPA_OR_EXTENSION_AGREED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _ppaOrExtensionAgreedColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._ppaOrExtensionAgreedBaseColumnBinding),
    };
    public get ppaOrExtensionAgreed(): ColumnBinding<number | null> {
        return this._ppaOrExtensionAgreedColumnBinding;
    }
    protected static _contingencyDatesCommentsBaseColumnBinding: BaseColumnBinding = {
        label: "Comments",
        templateLabel: "",
        fieldName: "contingencyDatesComments",
        dbColumnName: "CONTINGENCY_DATES_COMMENTS",
        isRequired: false,
        contentType: "TEXTAREA",
        length: 100,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _contingencyDatesCommentsColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._contingencyDatesCommentsBaseColumnBinding),
    };
    public get contingencyDatesComments(): ColumnBinding<string | null> {
        return this._contingencyDatesCommentsColumnBinding;
    }
    protected static _extendedDateBaseColumnBinding: BaseColumnBinding = {
        label: "PPA Agreed Date",
        templateLabel: "",
        fieldName: "extendedDate",
        dbColumnName: "EXTENDED_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _extendedDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._extendedDateBaseColumnBinding),
    };
    public get extendedDate(): ColumnBinding<Date | null> {
        return this._extendedDateColumnBinding;
    }
    protected static _validityStatusDateBaseColumnBinding: BaseColumnBinding = {
        label: "Validity Status Date",
        templateLabel: "",
        fieldName: "validityStatusDate",
        dbColumnName: "VALIDITY_STATUS_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _validityStatusDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._validityStatusDateBaseColumnBinding),
    };
    public get validityStatusDate(): ColumnBinding<Date | null> {
        return this._validityStatusDateColumnBinding;
    }
    protected static _articleNoticeReceivedBaseColumnBinding: BaseColumnBinding = {
        label: "Article Notice Received?",
        templateLabel: "",
        fieldName: "articleNoticeReceived",
        dbColumnName: "ARTICLE_NOTICE_RECEIVED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _articleNoticeReceivedColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._articleNoticeReceivedBaseColumnBinding),
    };
    public get articleNoticeReceived(): ColumnBinding<number | null> {
        return this._articleNoticeReceivedColumnBinding;
    }
    protected static _dateArticleNoticeReceivedBaseColumnBinding: BaseColumnBinding = {
        label: "Date Article Notice Received",
        templateLabel: "",
        fieldName: "dateArticleNoticeReceived",
        dbColumnName: "DATE_ARTICLE_NOTICE_RECEIVED",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _dateArticleNoticeReceivedColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._dateArticleNoticeReceivedBaseColumnBinding),
    };
    public get dateArticleNoticeReceived(): ColumnBinding<Date | null> {
        return this._dateArticleNoticeReceivedColumnBinding;
    }
    protected static _articleNoticeCommentsBaseColumnBinding: BaseColumnBinding = {
        label: "Article Notice Comments",
        templateLabel: "",
        fieldName: "articleNoticeComments",
        dbColumnName: "ARTICLE_NOTICE_COMMENTS",
        isRequired: false,
        contentType: "TEXTAREA",
        length: 100,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _articleNoticeCommentsColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._articleNoticeCommentsBaseColumnBinding),
    };
    public get articleNoticeComments(): ColumnBinding<string | null> {
        return this._articleNoticeCommentsColumnBinding;
    }
    protected static _preApplicationIdBaseColumnBinding: BaseColumnBinding = {
        label: "Pre-application",
        templateLabel: "",
        fieldName: "preApplicationId",
        dbColumnName: "PRE_APPLICATION_ID",
        isRequired: false,
        contentType: "LOOKUP",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: "P_APPLICATION",
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _preApplicationIdColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._preApplicationIdBaseColumnBinding),
    };
    public get preApplicationId(): ColumnBinding<number | null> {
        return this._preApplicationIdColumnBinding;
    }
    protected static _consulteeResponsesDeadlineBaseColumnBinding: BaseColumnBinding = {
        label: "Consultee Responses Deadline",
        templateLabel: "",
        fieldName: "consulteeResponsesDeadline",
        dbColumnName: "CONSULTEE_RESPONSES_DEADLINE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _consulteeResponsesDeadlineColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._consulteeResponsesDeadlineBaseColumnBinding),
    };
    public get consulteeResponsesDeadline(): ColumnBinding<Date | null> {
        return this._consulteeResponsesDeadlineColumnBinding;
    }
    protected static _wasWithdrawnBaseColumnBinding: BaseColumnBinding = {
        label: "Withdrawn",
        templateLabel: "",
        fieldName: "wasWithdrawn",
        dbColumnName: "WAS_WITHDRAWN",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _wasWithdrawnColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._wasWithdrawnBaseColumnBinding),
    };
    public get wasWithdrawn(): ColumnBinding<number | null> {
        return this._wasWithdrawnColumnBinding;
    }
    protected static _calledInBaseColumnBinding: BaseColumnBinding = {
        label: "Called In",
        templateLabel: "",
        fieldName: "calledIn",
        dbColumnName: "CALLED_IN",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _calledInColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._calledInBaseColumnBinding),
    };
    public get calledIn(): ColumnBinding<number | null> {
        return this._calledInColumnBinding;
    }
    protected static _referredToSosBaseColumnBinding: BaseColumnBinding = {
        label: "Referred to Secretary of State",
        templateLabel: "",
        fieldName: "referredToSos",
        dbColumnName: "REFERRED_TO_SOS",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _referredToSosColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._referredToSosBaseColumnBinding),
    };
    public get referredToSos(): ColumnBinding<number | null> {
        return this._referredToSosColumnBinding;
    }
    protected static _locationBaseColumnBinding: BaseColumnBinding = {
        label: "Address",
        templateLabel: "",
        fieldName: "location",
        dbColumnName: "LOCATION",
        isRequired: false,
        contentType: "TEXTAREA",
        length: 1000,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _locationColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._locationBaseColumnBinding),
    };
    public get location(): ColumnBinding<string | null> {
        return this._locationColumnBinding;
    }
    protected static _articleNoticeDocumentBaseColumnBinding: BaseColumnBinding = {
        label: "Article Notice Document",
        templateLabel: "",
        fieldName: "articleNoticeDocument",
        dbColumnName: "ARTICLE_NOTICE_DOCUMENT",
        isRequired: false,
        contentType: "LOOKUP",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: "ATTACHMENT",
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _articleNoticeDocumentColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._articleNoticeDocumentBaseColumnBinding),
    };
    public get articleNoticeDocument(): ColumnBinding<number | null> {
        return this._articleNoticeDocumentColumnBinding;
    }
    protected static _reportDueDateBaseColumnBinding: BaseColumnBinding = {
        label: "Report Due Date",
        templateLabel: "",
        fieldName: "reportDueDate",
        dbColumnName: "REPORT_DUE_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _reportDueDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._reportDueDateBaseColumnBinding),
    };
    public get reportDueDate(): ColumnBinding<Date | null> {
        return this._reportDueDateColumnBinding;
    }
    protected static _certificateOfOwnershipTypeRequiredBaseColumnBinding: BaseColumnBinding = {
        label: "Type Required",
        templateLabel: "",
        fieldName: "certificateOfOwnershipTypeRequired",
        dbColumnName: "CERTIFICATE_OF_OWNERSHIP_TYPE_REQUIRED",
        isRequired: false,
        contentType: "PICKLIST",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: "PM_OWNERSHIPCERTIFICATE_TYPE",
        options: [
            "A",
            "B",
            "C",
            "D"
        ],
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _certificateOfOwnershipTypeRequiredColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._certificateOfOwnershipTypeRequiredBaseColumnBinding),
    };
    public get certificateOfOwnershipTypeRequired(): ColumnBinding<string | null> {
        return this._certificateOfOwnershipTypeRequiredColumnBinding;
    }
    protected static _appropriateCertificateProvidedBaseColumnBinding: BaseColumnBinding = {
        label: "Appropriate Certificate Provided?",
        templateLabel: "",
        fieldName: "appropriateCertificateProvided",
        dbColumnName: "APPROPRIATE_CERTIFICATE_PROVIDED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _appropriateCertificateProvidedColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._appropriateCertificateProvidedBaseColumnBinding),
    };
    public get appropriateCertificateProvided(): ColumnBinding<number | null> {
        return this._appropriateCertificateProvidedColumnBinding;
    }
    protected static _agriculturalCertificateProvidedBaseColumnBinding: BaseColumnBinding = {
        label: "Agricultural Certificate Provided?",
        templateLabel: "",
        fieldName: "agriculturalCertificateProvided",
        dbColumnName: "AGRICULTURAL_CERTIFICATE_PROVIDED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _agriculturalCertificateProvidedColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._agriculturalCertificateProvidedBaseColumnBinding),
    };
    public get agriculturalCertificateProvided(): ColumnBinding<number | null> {
        return this._agriculturalCertificateProvidedColumnBinding;
    }
    protected static _ownershipCertTitleBaseColumnBinding: BaseColumnBinding = {
        label: "Title",
        templateLabel: "",
        fieldName: "ownershipCertTitle",
        dbColumnName: "OWNERSHIP_CERT_TITLE",
        isRequired: false,
        contentType: "PICKLIST",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: "PM_TITLES",
        options: [
            "Mr",
            "Mrs",
            "Ms",
            "Miss",
            "Mr & Mrs",
            "Dr",
            "Sir",
            "Prof",
            "Dame"
        ],
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _ownershipCertTitleColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._ownershipCertTitleBaseColumnBinding),
    };
    public get ownershipCertTitle(): ColumnBinding<string | null> {
        return this._ownershipCertTitleColumnBinding;
    }
    protected static _declarationDateBaseColumnBinding: BaseColumnBinding = {
        label: "Declaration Date",
        templateLabel: "",
        fieldName: "declarationDate",
        dbColumnName: "DECLARATION_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _declarationDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._declarationDateBaseColumnBinding),
    };
    public get declarationDate(): ColumnBinding<Date | null> {
        return this._declarationDateColumnBinding;
    }
    protected static _declarationMadeBaseColumnBinding: BaseColumnBinding = {
        label: "Declaration Made",
        templateLabel: "",
        fieldName: "declarationMade",
        dbColumnName: "DECLARATION_MADE",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _declarationMadeColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._declarationMadeBaseColumnBinding),
    };
    public get declarationMade(): ColumnBinding<number | null> {
        return this._declarationMadeColumnBinding;
    }
    protected static _personRoleBaseColumnBinding: BaseColumnBinding = {
        label: "Person Role",
        templateLabel: "",
        fieldName: "personRole",
        dbColumnName: "PERSON_ROLE",
        isRequired: false,
        contentType: "PICKLIST",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: "PM_OWNERSHIPCERT_PERSONROLE",
        options: [
            "Applicant",
            "Agent"
        ],
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _personRoleColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._personRoleBaseColumnBinding),
    };
    public get personRole(): ColumnBinding<string | null> {
        return this._personRoleColumnBinding;
    }
    protected static _ownershipCertificateBaseColumnBinding: BaseColumnBinding = {
        label: "Ownership Certificate",
        templateLabel: "",
        fieldName: "ownershipCertificate",
        dbColumnName: "OWNERSHIP_CERTIFICATE",
        isRequired: false,
        contentType: "LOOKUP",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: "ATTACHMENT",
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _ownershipCertificateColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._ownershipCertificateBaseColumnBinding),
    };
    public get ownershipCertificate(): ColumnBinding<number | null> {
        return this._ownershipCertificateColumnBinding;
    }
    protected static _decisionBaseColumnBinding: BaseColumnBinding = {
        label: "Decision",
        templateLabel: "",
        fieldName: "decision",
        dbColumnName: "DECISION",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: "PENDING",
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _decisionColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._decisionBaseColumnBinding),
    };
    public get decision(): ColumnBinding<string | null> {
        return this._decisionColumnBinding;
    }
    protected static _refundDueBaseColumnBinding: BaseColumnBinding = {
        label: "Refund Due",
        templateLabel: "",
        fieldName: "refundDue",
        dbColumnName: "REFUND_DUE",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _refundDueColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._refundDueBaseColumnBinding),
    };
    public get refundDue(): ColumnBinding<number | null> {
        return this._refundDueColumnBinding;
    }
    protected static _uprnBaseColumnBinding: BaseColumnBinding = {
        label: "UPRN",
        templateLabel: "",
        fieldName: "uprn",
        dbColumnName: "UPRN",
        isRequired: false,
        contentType: "NUMBER",
        length: 12,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _uprnColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._uprnBaseColumnBinding),
    };
    public get uprn(): ColumnBinding<number | null> {
        return this._uprnColumnBinding;
    }
    protected static _siteVisitContactTypeBaseColumnBinding: BaseColumnBinding = {
        label: "Contact Type",
        templateLabel: "",
        fieldName: "siteVisitContactType",
        dbColumnName: "SITE_VISIT_CONTACT_TYPE",
        isRequired: false,
        contentType: "PICKLIST",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: "PM_CONTACT_TYPES",
        options: [
            "Applicant",
            "Agent",
            "Builder",
            "Other"
        ],
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _siteVisitContactTypeColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._siteVisitContactTypeBaseColumnBinding),
    };
    public get siteVisitContactType(): ColumnBinding<string | null> {
        return this._siteVisitContactTypeColumnBinding;
    }
    protected static _siteVisitContactNameBaseColumnBinding: BaseColumnBinding = {
        label: "Name",
        templateLabel: "Contact Name",
        fieldName: "siteVisitContactName",
        dbColumnName: "SITE_VISIT_CONTACT_NAME",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _siteVisitContactNameColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._siteVisitContactNameBaseColumnBinding),
    };
    public get siteVisitContactName(): ColumnBinding<string | null> {
        return this._siteVisitContactNameColumnBinding;
    }
    protected static _siteVisitContactCompanyBaseColumnBinding: BaseColumnBinding = {
        label: "Company",
        templateLabel: "",
        fieldName: "siteVisitContactCompany",
        dbColumnName: "SITE_VISIT_CONTACT_COMPANY",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _siteVisitContactCompanyColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._siteVisitContactCompanyBaseColumnBinding),
    };
    public get siteVisitContactCompany(): ColumnBinding<string | null> {
        return this._siteVisitContactCompanyColumnBinding;
    }
    protected static _siteVisitContactAddressBaseColumnBinding: BaseColumnBinding = {
        label: "Address",
        templateLabel: "Site Visit Contact Address",
        fieldName: "siteVisitContactAddress",
        dbColumnName: "SITE_VISIT_CONTACT_ADDRESS",
        isRequired: false,
        contentType: "TEXTAREA",
        length: 1000,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _siteVisitContactAddressColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._siteVisitContactAddressBaseColumnBinding),
    };
    public get siteVisitContactAddress(): ColumnBinding<string | null> {
        return this._siteVisitContactAddressColumnBinding;
    }
    protected static _siteVisitContactPhoneNoBaseColumnBinding: BaseColumnBinding = {
        label: "Phone No.",
        templateLabel: "",
        fieldName: "siteVisitContactPhoneNo",
        dbColumnName: "SITE_VISIT_CONTACT_PHONE_NO",
        isRequired: false,
        contentType: "TEXT",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _siteVisitContactPhoneNoColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._siteVisitContactPhoneNoBaseColumnBinding),
    };
    public get siteVisitContactPhoneNo(): ColumnBinding<string | null> {
        return this._siteVisitContactPhoneNoColumnBinding;
    }
    protected static _siteVisitContactEmailBaseColumnBinding: BaseColumnBinding = {
        label: "Email",
        templateLabel: "",
        fieldName: "siteVisitContactEmail",
        dbColumnName: "SITE_VISIT_CONTACT_EMAIL",
        isRequired: false,
        contentType: "TEXT",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _siteVisitContactEmailColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._siteVisitContactEmailBaseColumnBinding),
    };
    public get siteVisitContactEmail(): ColumnBinding<string | null> {
        return this._siteVisitContactEmailColumnBinding;
    }
    protected static _phoneTypeBaseColumnBinding: BaseColumnBinding = {
        label: "Phone Type",
        templateLabel: "",
        fieldName: "phoneType",
        dbColumnName: "PHONE_TYPE",
        isRequired: false,
        contentType: "PICKLIST",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: "PM_SITE_VISIT_PHONE_TYPE",
        options: [
            "Land",
            "Mobile"
        ],
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _phoneTypeColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._phoneTypeBaseColumnBinding),
    };
    public get phoneType(): ColumnBinding<string | null> {
        return this._phoneTypeColumnBinding;
    }
    protected static _residentialIncludesGainLossBaseColumnBinding: BaseColumnBinding = {
        label: "Residential - includes gain / loss?",
        templateLabel: "",
        fieldName: "residentialIncludesGainLoss",
        dbColumnName: "RESIDENTIAL__INCLUDES_GAIN__LOSS",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _residentialIncludesGainLossColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._residentialIncludesGainLossBaseColumnBinding),
    };
    public get residentialIncludesGainLoss(): ColumnBinding<number | null> {
        return this._residentialIncludesGainLossColumnBinding;
    }
    protected static _residentialMarketBaseColumnBinding: BaseColumnBinding = {
        label: "Market",
        templateLabel: "Residential Market",
        fieldName: "residentialMarket",
        dbColumnName: "RESIDENTIAL_MARKET",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _residentialMarketColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._residentialMarketBaseColumnBinding),
    };
    public get residentialMarket(): ColumnBinding<number | null> {
        return this._residentialMarketColumnBinding;
    }
    protected static _residentialSocialBaseColumnBinding: BaseColumnBinding = {
        label: "Social",
        templateLabel: "Residential Social",
        fieldName: "residentialSocial",
        dbColumnName: "RESIDENTIAL_SOCIAL",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _residentialSocialColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._residentialSocialBaseColumnBinding),
    };
    public get residentialSocial(): ColumnBinding<number | null> {
        return this._residentialSocialColumnBinding;
    }
    protected static _residentialKeyWorkerBaseColumnBinding: BaseColumnBinding = {
        label: "Key Worker",
        templateLabel: "",
        fieldName: "residentialKeyWorker",
        dbColumnName: "RESIDENTIAL_KEY_WORKER",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _residentialKeyWorkerColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._residentialKeyWorkerBaseColumnBinding),
    };
    public get residentialKeyWorker(): ColumnBinding<number | null> {
        return this._residentialKeyWorkerColumnBinding;
    }
    protected static _residentialIntermediateBaseColumnBinding: BaseColumnBinding = {
        label: "Intermediate",
        templateLabel: "",
        fieldName: "residentialIntermediate",
        dbColumnName: "RESIDENTIAL_INTERMEDIATE",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _residentialIntermediateColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._residentialIntermediateBaseColumnBinding),
    };
    public get residentialIntermediate(): ColumnBinding<number | null> {
        return this._residentialIntermediateColumnBinding;
    }
    protected static _residentialStarterHomesBaseColumnBinding: BaseColumnBinding = {
        label: "Starter Homes",
        templateLabel: "Starter Homes",
        fieldName: "residentialStarterHomes",
        dbColumnName: "RESIDENTIAL_STARTER_HOMES",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _residentialStarterHomesColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._residentialStarterHomesBaseColumnBinding),
    };
    public get residentialStarterHomes(): ColumnBinding<number | null> {
        return this._residentialStarterHomesColumnBinding;
    }
    protected static _residentialSelfBuildCustomBuiltBaseColumnBinding: BaseColumnBinding = {
        label: "Self-Build / Custom Built",
        templateLabel: "",
        fieldName: "residentialSelfBuildCustomBuilt",
        dbColumnName: "RESIDENTIAL_SELF_BUILD_CUSTOM_BUILT",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _residentialSelfBuildCustomBuiltColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._residentialSelfBuildCustomBuiltBaseColumnBinding),
    };
    public get residentialSelfBuildCustomBuilt(): ColumnBinding<number | null> {
        return this._residentialSelfBuildCustomBuiltColumnBinding;
    }
    protected static _scopingOpinionSoughtBaseColumnBinding: BaseColumnBinding = {
        label: "Scoping Opinion Sought",
        templateLabel: "",
        fieldName: "scopingOpinionSought",
        dbColumnName: "SCOPING_OPINION_SOUGHT",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _scopingOpinionSoughtColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._scopingOpinionSoughtBaseColumnBinding),
    };
    public get scopingOpinionSought(): ColumnBinding<number | null> {
        return this._scopingOpinionSoughtColumnBinding;
    }
    protected static _scopingOpinionProvidedBaseColumnBinding: BaseColumnBinding = {
        label: "Scoping Opinion Provided",
        templateLabel: "",
        fieldName: "scopingOpinionProvided",
        dbColumnName: "SCOPING_OPINION_PROVIDED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _scopingOpinionProvidedColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._scopingOpinionProvidedBaseColumnBinding),
    };
    public get scopingOpinionProvided(): ColumnBinding<number | null> {
        return this._scopingOpinionProvidedColumnBinding;
    }
    protected static _environmentalStatementReceivedBaseColumnBinding: BaseColumnBinding = {
        label: "Environmental Statement Received",
        templateLabel: "",
        fieldName: "environmentalStatementReceived",
        dbColumnName: "ENVIRONMENTAL_STATEMENT_RECEIVED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _environmentalStatementReceivedColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._environmentalStatementReceivedBaseColumnBinding),
    };
    public get environmentalStatementReceived(): ColumnBinding<number | null> {
        return this._environmentalStatementReceivedColumnBinding;
    }
    protected static _environmentalStatementRequiredBaseColumnBinding: BaseColumnBinding = {
        label: "Environmental Statement Required",
        templateLabel: "",
        fieldName: "environmentalStatementRequired",
        dbColumnName: "ENVIRONMENTAL_STATEMENT_REQUIRED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _environmentalStatementRequiredColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._environmentalStatementRequiredBaseColumnBinding),
    };
    public get environmentalStatementRequired(): ColumnBinding<number | null> {
        return this._environmentalStatementRequiredColumnBinding;
    }
    protected static _schedule_1Or_2BaseColumnBinding: BaseColumnBinding = {
        label: "Schedule 1 or 2",
        templateLabel: "",
        fieldName: "schedule_1Or_2",
        dbColumnName: "SCHEDULE_1_OR_2",
        isRequired: false,
        contentType: "PICKLIST",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: "PM_SCHEDULE_TYPE",
        options: [
            "Schedule 1",
            "Schedule 2"
        ],
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _schedule_1Or_2ColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._schedule_1Or_2BaseColumnBinding),
    };
    public get schedule_1Or_2(): ColumnBinding<string | null> {
        return this._schedule_1Or_2ColumnBinding;
    }
    protected static _planningPortalRefNoBaseColumnBinding: BaseColumnBinding = {
        label: "Planning Portal Reference No.",
        templateLabel: "",
        fieldName: "planningPortalRefNo",
        dbColumnName: "PLANNING_PORTAL_REF_NO",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _planningPortalRefNoColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._planningPortalRefNoBaseColumnBinding),
    };
    public get planningPortalRefNo(): ColumnBinding<string | null> {
        return this._planningPortalRefNoColumnBinding;
    }
    protected static _ps12CodeBaseColumnBinding: BaseColumnBinding = {
        label: "PS1/2 Code",
        templateLabel: "",
        fieldName: "ps12Code",
        dbColumnName: "PS12_CODE",
        isRequired: false,
        contentType: "LOOKUP",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: "P_PS_12_CODE",
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _ps12CodeColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._ps12CodeBaseColumnBinding),
    };
    public get ps12Code(): ColumnBinding<number | null> {
        return this._ps12CodeColumnBinding;
    }
    protected static _siteCanBeSeenFromPublicRoadPublicBaseColumnBinding: BaseColumnBinding = {
        label: "Site can be seen from public road, public footpath, bridleway or other public land",
        templateLabel: "",
        fieldName: "siteCanBeSeenFromPublicRoadPublic",
        dbColumnName: "SITE_CAN_BE_SEEN_FROM_PUBLIC_ROAD_PUBLIC",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _siteCanBeSeenFromPublicRoadPublicColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._siteCanBeSeenFromPublicRoadPublicBaseColumnBinding),
    };
    public get siteCanBeSeenFromPublicRoadPublic(): ColumnBinding<number | null> {
        return this._siteCanBeSeenFromPublicRoadPublicColumnBinding;
    }
    protected static _preferredContactMethodBaseColumnBinding: BaseColumnBinding = {
        label: "Preferred Contact Method",
        templateLabel: "",
        fieldName: "preferredContactMethod",
        dbColumnName: "PREFERRED_CONTACT_METHOD",
        isRequired: false,
        contentType: "PICKLIST",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: "PM_SITE_VISIT_PREFERRED_CONTACT",
        options: [
            "Post",
            "Phone",
            "Email"
        ],
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _preferredContactMethodColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._preferredContactMethodBaseColumnBinding),
    };
    public get preferredContactMethod(): ColumnBinding<string | null> {
        return this._preferredContactMethodColumnBinding;
    }
    protected static _residentialMarketProposedBaseColumnBinding: BaseColumnBinding = {
        label: "Market",
        templateLabel: "Residential Market Proposed",
        fieldName: "residentialMarketProposed",
        dbColumnName: "RESIDENTIAL_MARKET_PROPOSED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _residentialMarketProposedColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._residentialMarketProposedBaseColumnBinding),
    };
    public get residentialMarketProposed(): ColumnBinding<number | null> {
        return this._residentialMarketProposedColumnBinding;
    }
    protected static _residentialSocialProposedBaseColumnBinding: BaseColumnBinding = {
        label: "Social",
        templateLabel: "Residential Social Proposed",
        fieldName: "residentialSocialProposed",
        dbColumnName: "RESIDENTIAL_SOCIAL_PROPOSED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _residentialSocialProposedColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._residentialSocialProposedBaseColumnBinding),
    };
    public get residentialSocialProposed(): ColumnBinding<number | null> {
        return this._residentialSocialProposedColumnBinding;
    }
    protected static _residentialKeyWorkerProposedBaseColumnBinding: BaseColumnBinding = {
        label: "Key Worker",
        templateLabel: "Residential Key Worker Proposed",
        fieldName: "residentialKeyWorkerProposed",
        dbColumnName: "RESIDENTIAL_KEY_WORKER_PROPOSED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _residentialKeyWorkerProposedColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._residentialKeyWorkerProposedBaseColumnBinding),
    };
    public get residentialKeyWorkerProposed(): ColumnBinding<number | null> {
        return this._residentialKeyWorkerProposedColumnBinding;
    }
    protected static _residentialIntermediateProposedBaseColumnBinding: BaseColumnBinding = {
        label: "Intermediate",
        templateLabel: "Residential Intermediate Proposed",
        fieldName: "residentialIntermediateProposed",
        dbColumnName: "RESIDENTIAL_INTERMEDIATE_PROPOSED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _residentialIntermediateProposedColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._residentialIntermediateProposedBaseColumnBinding),
    };
    public get residentialIntermediateProposed(): ColumnBinding<number | null> {
        return this._residentialIntermediateProposedColumnBinding;
    }
    protected static _residentialStarterHomesProposedBaseColumnBinding: BaseColumnBinding = {
        label: "Starter Homes",
        templateLabel: "Starter Homes Proposed",
        fieldName: "residentialStarterHomesProposed",
        dbColumnName: "RESIDENTIAL_STARTER_HOMES_PROPOSED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _residentialStarterHomesProposedColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._residentialStarterHomesProposedBaseColumnBinding),
    };
    public get residentialStarterHomesProposed(): ColumnBinding<number | null> {
        return this._residentialStarterHomesProposedColumnBinding;
    }
    protected static _residentialSelfBuildCustomBuiltProposedBaseColumnBinding: BaseColumnBinding = {
        label: "Self-Build / Custom Built",
        templateLabel: "Residential Self-Build Custom Built Proposed",
        fieldName: "residentialSelfBuildCustomBuiltProposed",
        dbColumnName: "RESIDENTIAL_SELF_BUILD_CUSTOM_BUILT_PROPOSED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _residentialSelfBuildCustomBuiltProposedColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._residentialSelfBuildCustomBuiltProposedBaseColumnBinding),
    };
    public get residentialSelfBuildCustomBuiltProposed(): ColumnBinding<number | null> {
        return this._residentialSelfBuildCustomBuiltProposedColumnBinding;
    }
    protected static _involvesLossGainOrChangeOfNonresidentialBaseColumnBinding: BaseColumnBinding = {
        label: "Involves Loss, Gain, or Change of non-residential floorspace",
        templateLabel: "Involves Loss, Gain, or Change of non-residential floorspace",
        fieldName: "involvesLossGainOrChangeOfNonresidential",
        dbColumnName: "INVOLVES_LOSS_GAIN_OR_CHANGE_OF_NONRESIDENTIAL",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _involvesLossGainOrChangeOfNonresidentialColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._involvesLossGainOrChangeOfNonresidentialBaseColumnBinding),
    };
    public get involvesLossGainOrChangeOfNonresidential(): ColumnBinding<number | null> {
        return this._involvesLossGainOrChangeOfNonresidentialColumnBinding;
    }
    protected static _includesHotelsResidentialInstitutionsEtcBaseColumnBinding: BaseColumnBinding = {
        label: "Includes hotels, residential institutions, etc.",
        templateLabel: "Includes hotels, residential institutions, etc.",
        fieldName: "includesHotelsResidentialInstitutionsEtc",
        dbColumnName: "INCLUDES_HOTELS_RESIDENTIAL_INSTITUTIONS_ETC",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _includesHotelsResidentialInstitutionsEtcColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._includesHotelsResidentialInstitutionsEtcBaseColumnBinding),
    };
    public get includesHotelsResidentialInstitutionsEtc(): ColumnBinding<number | null> {
        return this._includesHotelsResidentialInstitutionsEtcColumnBinding;
    }
    protected static _anyPeoplePresentlyEmployedOnSiteBaseColumnBinding: BaseColumnBinding = {
        label: "Any people presently employed on site?",
        templateLabel: "",
        fieldName: "anyPeoplePresentlyEmployedOnSite",
        dbColumnName: "ANY_PEOPLE_PRESENTLY_EMPLOYED_ON_SITE",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _anyPeoplePresentlyEmployedOnSiteColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._anyPeoplePresentlyEmployedOnSiteBaseColumnBinding),
    };
    public get anyPeoplePresentlyEmployedOnSite(): ColumnBinding<number | null> {
        return this._anyPeoplePresentlyEmployedOnSiteColumnBinding;
    }
    protected static _proposedEmploymentAtSiteBaseColumnBinding: BaseColumnBinding = {
        label: "Proposed employment at site?",
        templateLabel: "",
        fieldName: "proposedEmploymentAtSite",
        dbColumnName: "PROPOSED_EMPLOYMENT_AT_SITE",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _proposedEmploymentAtSiteColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._proposedEmploymentAtSiteBaseColumnBinding),
    };
    public get proposedEmploymentAtSite(): ColumnBinding<number | null> {
        return this._proposedEmploymentAtSiteColumnBinding;
    }
    protected static _involvesOpeningHoursBaseColumnBinding: BaseColumnBinding = {
        label: "Involves Opening Hours",
        templateLabel: "",
        fieldName: "involvesOpeningHours",
        dbColumnName: "INVOLVES_OPENING_HOURS",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _involvesOpeningHoursColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._involvesOpeningHoursBaseColumnBinding),
    };
    public get involvesOpeningHours(): ColumnBinding<number | null> {
        return this._involvesOpeningHoursColumnBinding;
    }
    protected static _detailsOfIndustrialProcessesAndMachineryBaseColumnBinding: BaseColumnBinding = {
        label: "Details of Industrial Processes and Machinery",
        templateLabel: "",
        fieldName: "detailsOfIndustrialProcessesAndMachinery",
        dbColumnName: "DETAILS_OF_INDUSTRIAL_PROCESSES_AND_MACHINERY",
        isRequired: false,
        contentType: "TEXTAREA",
        length: 1000,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _detailsOfIndustrialProcessesAndMachineryColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._detailsOfIndustrialProcessesAndMachineryBaseColumnBinding),
    };
    public get detailsOfIndustrialProcessesAndMachinery(): ColumnBinding<string | null> {
        return this._detailsOfIndustrialProcessesAndMachineryColumnBinding;
    }
    protected static _employmentCommentsBaseColumnBinding: BaseColumnBinding = {
        label: "Employment comments",
        templateLabel: "",
        fieldName: "employmentComments",
        dbColumnName: "EMPLOYMENT_COMMENTS",
        isRequired: false,
        contentType: "TEXTAREA",
        length: 1000,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _employmentCommentsColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._employmentCommentsBaseColumnBinding),
    };
    public get employmentComments(): ColumnBinding<string | null> {
        return this._employmentCommentsColumnBinding;
    }
    protected static _cilAgreementDateBaseColumnBinding: BaseColumnBinding = {
        label: "CIL Agreement Date",
        templateLabel: "",
        fieldName: "cilAgreementDate",
        dbColumnName: "CIL_AGREEMENT_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _cilAgreementDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._cilAgreementDateBaseColumnBinding),
    };
    public get cilAgreementDate(): ColumnBinding<Date | null> {
        return this._cilAgreementDateColumnBinding;
    }
    protected static _expiryDateBaseColumnBinding: BaseColumnBinding = {
        label: "Expiry Date",
        templateLabel: "",
        fieldName: "expiryDate",
        dbColumnName: "EXPIRY_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _expiryDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._expiryDateBaseColumnBinding),
    };
    public get expiryDate(): ColumnBinding<Date | null> {
        return this._expiryDateColumnBinding;
    }
    protected static _adviceSoughtBaseColumnBinding: BaseColumnBinding = {
        label: "Advice Sought",
        templateLabel: "",
        fieldName: "adviceSought",
        dbColumnName: "ADVICE_SOUGHT",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _adviceSoughtColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._adviceSoughtBaseColumnBinding),
    };
    public get adviceSought(): ColumnBinding<number | null> {
        return this._adviceSoughtColumnBinding;
    }
    protected static _adviceDetailsBaseColumnBinding: BaseColumnBinding = {
        label: "Advice Details",
        templateLabel: "",
        fieldName: "adviceDetails",
        dbColumnName: "ADVICE_DETAILS",
        isRequired: false,
        contentType: "TEXTAREA",
        length: 1000,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _adviceDetailsColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._adviceDetailsBaseColumnBinding),
    };
    public get adviceDetails(): ColumnBinding<string | null> {
        return this._adviceDetailsColumnBinding;
    }
    protected static _unitMeasurementBaseColumnBinding: BaseColumnBinding = {
        label: "Unit Measurement",
        templateLabel: "",
        fieldName: "unitMeasurement",
        dbColumnName: "UNIT_MEASUREMENT",
        isRequired: false,
        contentType: "PICKLIST",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: "PM_UNIT_MEASUREMENT",
        options: [
            "Sq. metres",
            "HA",
            "Acres",
            "Sq. km"
        ],
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _unitMeasurementColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._unitMeasurementBaseColumnBinding),
    };
    public get unitMeasurement(): ColumnBinding<string | null> {
        return this._unitMeasurementColumnBinding;
    }
    protected static _workStartedWoPermissionBaseColumnBinding: BaseColumnBinding = {
        label: "Work Started Without Planning Permission",
        templateLabel: "",
        fieldName: "workStartedWoPermission",
        dbColumnName: "WORK_STARTED_WO_PERMISSION",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _workStartedWoPermissionColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._workStartedWoPermissionBaseColumnBinding),
    };
    public get workStartedWoPermission(): ColumnBinding<number | null> {
        return this._workStartedWoPermissionColumnBinding;
    }
    protected static _workStartedWoPermissionDateBaseColumnBinding: BaseColumnBinding = {
        label: "Work Started Date",
        templateLabel: "",
        fieldName: "workStartedWoPermissionDate",
        dbColumnName: "WORK_STARTED_WO_PERMISSION_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _workStartedWoPermissionDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._workStartedWoPermissionDateBaseColumnBinding),
    };
    public get workStartedWoPermissionDate(): ColumnBinding<Date | null> {
        return this._workStartedWoPermissionDateColumnBinding;
    }
    protected static _workCompletedWoPermissionBaseColumnBinding: BaseColumnBinding = {
        label: "Work Completed Without Planning Permission",
        templateLabel: "",
        fieldName: "workCompletedWoPermission",
        dbColumnName: "WORK_COMPLETED_WO_PERMISSION",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _workCompletedWoPermissionColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._workCompletedWoPermissionBaseColumnBinding),
    };
    public get workCompletedWoPermission(): ColumnBinding<number | null> {
        return this._workCompletedWoPermissionColumnBinding;
    }
    protected static _workCompletedWoPermissionDateBaseColumnBinding: BaseColumnBinding = {
        label: "Work Completed Date",
        templateLabel: "",
        fieldName: "workCompletedWoPermissionDate",
        dbColumnName: "WORK_COMPLETED_WO_PERMISSION_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _workCompletedWoPermissionDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._workCompletedWoPermissionDateBaseColumnBinding),
    };
    public get workCompletedWoPermissionDate(): ColumnBinding<Date | null> {
        return this._workCompletedWoPermissionDateColumnBinding;
    }
    protected static _buildingRegulationsRequiredBaseColumnBinding: BaseColumnBinding = {
        label: "Building Regulations Required",
        templateLabel: "",
        fieldName: "buildingRegulationsRequired",
        dbColumnName: "BUILDING_REGULATIONS_REQUIRED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _buildingRegulationsRequiredColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._buildingRegulationsRequiredBaseColumnBinding),
    };
    public get buildingRegulationsRequired(): ColumnBinding<number | null> {
        return this._buildingRegulationsRequiredColumnBinding;
    }
    protected static _siteAreaBaseColumnBinding: BaseColumnBinding = {
        label: "Site Area",
        templateLabel: "",
        fieldName: "siteArea",
        dbColumnName: "SITE_AREA",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _siteAreaColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._siteAreaBaseColumnBinding),
    };
    public get siteArea(): ColumnBinding<number | null> {
        return this._siteAreaColumnBinding;
    }
    protected static _buildingAgeBaseColumnBinding: BaseColumnBinding = {
        label: "Building Age",
        templateLabel: "",
        fieldName: "buildingAge",
        dbColumnName: "BUILDING_AGE",
        isRequired: false,
        contentType: "PICKLIST",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: "PM_BUILDING_AGE",
        options: [
            "Pre-war",
            "1970-1999",
            "1945-1969",
            "Post 2000"
        ],
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _buildingAgeColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._buildingAgeBaseColumnBinding),
    };
    public get buildingAge(): ColumnBinding<string | null> {
        return this._buildingAgeColumnBinding;
    }
    protected static _priorApprovalTypeBaseColumnBinding: BaseColumnBinding = {
        label: "Prior Approval Type",
        templateLabel: "",
        fieldName: "priorApprovalType",
        dbColumnName: "PRIOR_APPROVAL_TYPE",
        isRequired: false,
        contentType: "LOOKUP",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: "P_PRIOR_APPROVAL_TYPE",
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _priorApprovalTypeColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._priorApprovalTypeBaseColumnBinding),
    };
    public get priorApprovalType(): ColumnBinding<number | null> {
        return this._priorApprovalTypeColumnBinding;
    }
    protected static _detailedPlanningLikelyRequiredBaseColumnBinding: BaseColumnBinding = {
        label: "Detailed planning likely to be required",
        templateLabel: "",
        fieldName: "detailedPlanningLikelyRequired",
        dbColumnName: "DETAILED_PLANNING_LIKELY_REQUIRED",
        isRequired: false,
        contentType: "PICKLIST",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: "YESNOUNKNOWN",
        options: [
            "Yes",
            "No",
            "Unknown"
        ],
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _detailedPlanningLikelyRequiredColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._detailedPlanningLikelyRequiredBaseColumnBinding),
    };
    public get detailedPlanningLikelyRequired(): ColumnBinding<string | null> {
        return this._detailedPlanningLikelyRequiredColumnBinding;
    }
    protected static _notesHistoryAndInformationBaseColumnBinding: BaseColumnBinding = {
        label: "Notes",
        templateLabel: "",
        fieldName: "notesHistoryAndInformation",
        dbColumnName: "NOTES_HISTORY_AND_INFORMATION",
        isRequired: false,
        contentType: "TEXTAREA",
        length: 1000,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _notesHistoryAndInformationColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._notesHistoryAndInformationBaseColumnBinding),
    };
    public get notesHistoryAndInformation(): ColumnBinding<string | null> {
        return this._notesHistoryAndInformationColumnBinding;
    }
    protected static _buildingTypeBaseColumnBinding: BaseColumnBinding = {
        label: "Building Type",
        templateLabel: "",
        fieldName: "buildingType",
        dbColumnName: "BUILDING_TYPE",
        isRequired: false,
        contentType: "PICKLIST",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: "PM_BUILDING_TYPE",
        options: [
            "Purpose built office",
            "Other conversion",
            "Former residential building",
            "Other"
        ],
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _buildingTypeColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._buildingTypeBaseColumnBinding),
    };
    public get buildingType(): ColumnBinding<string | null> {
        return this._buildingTypeColumnBinding;
    }
    protected static _occupancyBaseColumnBinding: BaseColumnBinding = {
        label: "Occupancy",
        templateLabel: "",
        fieldName: "occupancy",
        dbColumnName: "OCCUPANCY",
        isRequired: false,
        contentType: "PICKLIST",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: "PM_OCCUPANCY",
        options: [
            "Wholly vacant",
            "Part vacant",
            "Occupied",
            "Derelict",
            "Other"
        ],
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _occupancyColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._occupancyBaseColumnBinding),
    };
    public get occupancy(): ColumnBinding<string | null> {
        return this._occupancyColumnBinding;
    }
    protected static _locationTypeBaseColumnBinding: BaseColumnBinding = {
        label: "Location Type",
        templateLabel: "",
        fieldName: "locationType",
        dbColumnName: "LOCATION_TYPE",
        isRequired: false,
        contentType: "PICKLIST",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: "PM_LOCATION_TYPE",
        options: [
            "Town centre",
            "Edge of centre",
            "Out of centre",
            "Business park dash industrial estate",
            "Other"
        ],
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _locationTypeColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._locationTypeBaseColumnBinding),
    };
    public get locationType(): ColumnBinding<string | null> {
        return this._locationTypeColumnBinding;
    }
    protected static _commercialFloorspaceLostMBaseColumnBinding: BaseColumnBinding = {
        label: "Sq.m",
        templateLabel: "",
        fieldName: "commercialFloorspaceLostM",
        dbColumnName: "COMMERCIAL_FLOORSPACE_LOST_M",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _commercialFloorspaceLostMColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._commercialFloorspaceLostMBaseColumnBinding),
    };
    public get commercialFloorspaceLostM(): ColumnBinding<number | null> {
        return this._commercialFloorspaceLostMColumnBinding;
    }
    protected static _commercialFloorspaceLostHaBaseColumnBinding: BaseColumnBinding = {
        label: "Ha.",
        templateLabel: "",
        fieldName: "commercialFloorspaceLostHa",
        dbColumnName: "COMMERCIAL_FLOORSPACE_LOST_HA",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _commercialFloorspaceLostHaColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._commercialFloorspaceLostHaBaseColumnBinding),
    };
    public get commercialFloorspaceLostHa(): ColumnBinding<number | null> {
        return this._commercialFloorspaceLostHaColumnBinding;
    }
    protected static _noOfDwellingsNewBaseColumnBinding: BaseColumnBinding = {
        label: "No. of dwellings",
        templateLabel: "",
        fieldName: "noOfDwellingsNew",
        dbColumnName: "NO_OF_DWELLINGS_NEW",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _noOfDwellingsNewColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._noOfDwellingsNewBaseColumnBinding),
    };
    public get noOfDwellingsNew(): ColumnBinding<number | null> {
        return this._noOfDwellingsNewColumnBinding;
    }
    protected static _proposedEmployeesFullTimeBaseColumnBinding: BaseColumnBinding = {
        label: "Proposed Employees (full time)",
        templateLabel: "",
        fieldName: "proposedEmployeesFullTime",
        dbColumnName: "PROPOSED_EMPLOYEES_FULL_TIME",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _proposedEmployeesFullTimeColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._proposedEmployeesFullTimeBaseColumnBinding),
    };
    public get proposedEmployeesFullTime(): ColumnBinding<number | null> {
        return this._proposedEmployeesFullTimeColumnBinding;
    }
    protected static _proposedEmployeesPartTimeBaseColumnBinding: BaseColumnBinding = {
        label: "Proposed Employees (part time)",
        templateLabel: "",
        fieldName: "proposedEmployeesPartTime",
        dbColumnName: "PROPOSED_EMPLOYEES_PART_TIME",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _proposedEmployeesPartTimeColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._proposedEmployeesPartTimeBaseColumnBinding),
    };
    public get proposedEmployeesPartTime(): ColumnBinding<number | null> {
        return this._proposedEmployeesPartTimeColumnBinding;
    }
    protected static _proposedEmployeesFullTimeEquivalentBaseColumnBinding: BaseColumnBinding = {
        label: "Proposed Employees (full time equivalent)",
        templateLabel: "",
        fieldName: "proposedEmployeesFullTimeEquivalent",
        dbColumnName: "PROPOSED_EMPLOYEES_FULL_TIME_EQUIVALENT",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _proposedEmployeesFullTimeEquivalentColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._proposedEmployeesFullTimeEquivalentBaseColumnBinding),
    };
    public get proposedEmployeesFullTimeEquivalent(): ColumnBinding<number | null> {
        return this._proposedEmployeesFullTimeEquivalentColumnBinding;
    }
    protected static _agentAddressTextareaBaseColumnBinding: BaseColumnBinding = {
        label: "Address",
        templateLabel: "Agent Address",
        fieldName: "agentAddressTextarea",
        dbColumnName: "AGENT_ADDRESS_TEXTAREA",
        isRequired: false,
        contentType: "TEXTAREA",
        length: 1000,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _agentAddressTextareaColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._agentAddressTextareaBaseColumnBinding),
    };
    public get agentAddressTextarea(): ColumnBinding<string | null> {
        return this._agentAddressTextareaColumnBinding;
    }
    protected static _agentPostTownBaseColumnBinding: BaseColumnBinding = {
        label: "Post Town",
        templateLabel: "Agent Post Town",
        fieldName: "agentPostTown",
        dbColumnName: "AGENT_POST_TOWN",
        isRequired: false,
        contentType: "TEXT",
        length: 100,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _agentPostTownColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._agentPostTownBaseColumnBinding),
    };
    public get agentPostTown(): ColumnBinding<string | null> {
        return this._agentPostTownColumnBinding;
    }
    protected static _agentPostcodeBaseColumnBinding: BaseColumnBinding = {
        label: "Postcode",
        templateLabel: "Agent Postcode",
        fieldName: "agentPostcode",
        dbColumnName: "AGENT_POSTCODE",
        isRequired: false,
        contentType: "TEXT",
        length: 100,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _agentPostcodeColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._agentPostcodeBaseColumnBinding),
    };
    public get agentPostcode(): ColumnBinding<string | null> {
        return this._agentPostcodeColumnBinding;
    }
    protected static _agentTelephoneBaseColumnBinding: BaseColumnBinding = {
        label: "Telephone",
        templateLabel: "Agent Telephone",
        fieldName: "agentTelephone",
        dbColumnName: "AGENT_TELEPHONE",
        isRequired: false,
        contentType: "TEXT",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _agentTelephoneColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._agentTelephoneBaseColumnBinding),
    };
    public get agentTelephone(): ColumnBinding<string | null> {
        return this._agentTelephoneColumnBinding;
    }
    protected static _agentFaxBaseColumnBinding: BaseColumnBinding = {
        label: "Fax",
        templateLabel: "Agent Fax",
        fieldName: "agentFax",
        dbColumnName: "AGENT_FAX",
        isRequired: false,
        contentType: "TEXT",
        length: 100,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _agentFaxColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._agentFaxBaseColumnBinding),
    };
    public get agentFax(): ColumnBinding<string | null> {
        return this._agentFaxColumnBinding;
    }
    protected static _agentMobileBaseColumnBinding: BaseColumnBinding = {
        label: "Mobile",
        templateLabel: "Agent Mobile",
        fieldName: "agentMobile",
        dbColumnName: "AGENT_MOBILE",
        isRequired: false,
        contentType: "TEXT",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _agentMobileColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._agentMobileBaseColumnBinding),
    };
    public get agentMobile(): ColumnBinding<string | null> {
        return this._agentMobileColumnBinding;
    }
    protected static _agentEmailBaseColumnBinding: BaseColumnBinding = {
        label: "Email",
        templateLabel: "Agent Email",
        fieldName: "agentEmail",
        dbColumnName: "AGENT_EMAIL",
        isRequired: false,
        contentType: "TEXT",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _agentEmailColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._agentEmailBaseColumnBinding),
    };
    public get agentEmail(): ColumnBinding<string | null> {
        return this._agentEmailColumnBinding;
    }
    protected static _agentTitleBaseColumnBinding: BaseColumnBinding = {
        label: "Title",
        templateLabel: "Agent Title",
        fieldName: "agentTitle",
        dbColumnName: "AGENT_TITLE",
        isRequired: false,
        contentType: "PICKLIST",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: "PM_TITLES",
        options: [
            "Mr",
            "Mrs",
            "Ms",
            "Miss",
            "Mr & Mrs",
            "Dr",
            "Sir",
            "Prof",
            "Dame"
        ],
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _agentTitleColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._agentTitleBaseColumnBinding),
    };
    public get agentTitle(): ColumnBinding<string | null> {
        return this._agentTitleColumnBinding;
    }
    protected static _agentFirstNameBaseColumnBinding: BaseColumnBinding = {
        label: "First Name",
        templateLabel: "Agent First Name",
        fieldName: "agentFirstName",
        dbColumnName: "AGENT_FIRST_NAME",
        isRequired: false,
        contentType: "TEXT",
        length: 100,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _agentFirstNameColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._agentFirstNameBaseColumnBinding),
    };
    public get agentFirstName(): ColumnBinding<string | null> {
        return this._agentFirstNameColumnBinding;
    }
    protected static _agentSurnameBaseColumnBinding: BaseColumnBinding = {
        label: "Surname",
        templateLabel: "Agent Surname",
        fieldName: "agentSurname",
        dbColumnName: "AGENT_SURNAME",
        isRequired: false,
        contentType: "TEXT",
        length: 100,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _agentSurnameColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._agentSurnameBaseColumnBinding),
    };
    public get agentSurname(): ColumnBinding<string | null> {
        return this._agentSurnameColumnBinding;
    }
    protected static _agentPreferredContactBaseColumnBinding: BaseColumnBinding = {
        label: "Preferred Contact",
        templateLabel: "Agent Preferred Contact",
        fieldName: "agentPreferredContact",
        dbColumnName: "AGENT_PREFERRED_CONTACT",
        isRequired: false,
        contentType: "PICKLIST",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: "PM_PREFERRED_CONTACT_MEAN",
        options: [
            "Telephone",
            "Mobile Phone",
            "Email",
            "Fax"
        ],
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _agentPreferredContactColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._agentPreferredContactBaseColumnBinding),
    };
    public get agentPreferredContact(): ColumnBinding<string | null> {
        return this._agentPreferredContactColumnBinding;
    }
    protected static _agentCountryBaseColumnBinding: BaseColumnBinding = {
        label: "Country",
        templateLabel: "Agent Country",
        fieldName: "agentCountry",
        dbColumnName: "AGENT_COUNTRY",
        isRequired: false,
        contentType: "TEXT",
        length: 100,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _agentCountryColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._agentCountryBaseColumnBinding),
    };
    public get agentCountry(): ColumnBinding<string | null> {
        return this._agentCountryColumnBinding;
    }
    protected static _agentAddressBaseColumnBinding: BaseColumnBinding = {
        label: "Address",
        templateLabel: "Agent Address",
        fieldName: "agentAddress",
        dbColumnName: "AGENT_ADDRESS",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _agentAddressColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._agentAddressBaseColumnBinding),
    };
    public get agentAddress(): ColumnBinding<string | null> {
        return this._agentAddressColumnBinding;
    }
    protected static _applicantAddressTextareaBaseColumnBinding: BaseColumnBinding = {
        label: "Address",
        templateLabel: "Applicant Address",
        fieldName: "applicantAddressTextarea",
        dbColumnName: "APPLICANT_ADDRESS_TEXTAREA",
        isRequired: false,
        contentType: "TEXTAREA",
        length: 1000,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _applicantAddressTextareaColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._applicantAddressTextareaBaseColumnBinding),
    };
    public get applicantAddressTextarea(): ColumnBinding<string | null> {
        return this._applicantAddressTextareaColumnBinding;
    }
    protected static _applicantPostTownBaseColumnBinding: BaseColumnBinding = {
        label: "Post Town",
        templateLabel: "Applicant Post Town",
        fieldName: "applicantPostTown",
        dbColumnName: "APPLICANT_POST_TOWN",
        isRequired: false,
        contentType: "TEXT",
        length: 100,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _applicantPostTownColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._applicantPostTownBaseColumnBinding),
    };
    public get applicantPostTown(): ColumnBinding<string | null> {
        return this._applicantPostTownColumnBinding;
    }
    protected static _applicantTelephoneBaseColumnBinding: BaseColumnBinding = {
        label: "Telephone",
        templateLabel: "Applicant Telephone",
        fieldName: "applicantTelephone",
        dbColumnName: "APPLICANT_TELEPHONE",
        isRequired: false,
        contentType: "TEXT",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _applicantTelephoneColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._applicantTelephoneBaseColumnBinding),
    };
    public get applicantTelephone(): ColumnBinding<string | null> {
        return this._applicantTelephoneColumnBinding;
    }
    protected static _applicantFaxBaseColumnBinding: BaseColumnBinding = {
        label: "Fax",
        templateLabel: "Applicant Fax",
        fieldName: "applicantFax",
        dbColumnName: "APPLICANT_FAX",
        isRequired: false,
        contentType: "TEXT",
        length: 100,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _applicantFaxColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._applicantFaxBaseColumnBinding),
    };
    public get applicantFax(): ColumnBinding<string | null> {
        return this._applicantFaxColumnBinding;
    }
    protected static _applicantMobileBaseColumnBinding: BaseColumnBinding = {
        label: "Mobile",
        templateLabel: "Applicant Mobile",
        fieldName: "applicantMobile",
        dbColumnName: "APPLICANT_MOBILE",
        isRequired: false,
        contentType: "TEXT",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _applicantMobileColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._applicantMobileBaseColumnBinding),
    };
    public get applicantMobile(): ColumnBinding<string | null> {
        return this._applicantMobileColumnBinding;
    }
    protected static _applicantEmailBaseColumnBinding: BaseColumnBinding = {
        label: "Email",
        templateLabel: "Applicant Email",
        fieldName: "applicantEmail",
        dbColumnName: "APPLICANT_EMAIL",
        isRequired: false,
        contentType: "TEXT",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _applicantEmailColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._applicantEmailBaseColumnBinding),
    };
    public get applicantEmail(): ColumnBinding<string | null> {
        return this._applicantEmailColumnBinding;
    }
    protected static _applicantTitleBaseColumnBinding: BaseColumnBinding = {
        label: "Title",
        templateLabel: "Applicant Title",
        fieldName: "applicantTitle",
        dbColumnName: "APPLICANT_TITLE",
        isRequired: false,
        contentType: "PICKLIST",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: "PM_TITLES",
        options: [
            "Mr",
            "Mrs",
            "Ms",
            "Miss",
            "Mr & Mrs",
            "Dr",
            "Sir",
            "Prof",
            "Dame"
        ],
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _applicantTitleColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._applicantTitleBaseColumnBinding),
    };
    public get applicantTitle(): ColumnBinding<string | null> {
        return this._applicantTitleColumnBinding;
    }
    protected static _applicantFirstNameBaseColumnBinding: BaseColumnBinding = {
        label: "First Name",
        templateLabel: "Applicant First Name",
        fieldName: "applicantFirstName",
        dbColumnName: "APPLICANT_FIRST_NAME",
        isRequired: false,
        contentType: "TEXT",
        length: 100,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _applicantFirstNameColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._applicantFirstNameBaseColumnBinding),
    };
    public get applicantFirstName(): ColumnBinding<string | null> {
        return this._applicantFirstNameColumnBinding;
    }
    protected static _applicantSurnameBaseColumnBinding: BaseColumnBinding = {
        label: "Surname",
        templateLabel: "Applicant Surname",
        fieldName: "applicantSurname",
        dbColumnName: "APPLICANT_SURNAME",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _applicantSurnameColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._applicantSurnameBaseColumnBinding),
    };
    public get applicantSurname(): ColumnBinding<string | null> {
        return this._applicantSurnameColumnBinding;
    }
    protected static _applicantPreferredContactBaseColumnBinding: BaseColumnBinding = {
        label: "Preferred Contact",
        templateLabel: "Applicant Preferred Contact",
        fieldName: "applicantPreferredContact",
        dbColumnName: "APPLICANT_PREFERRED_CONTACT",
        isRequired: false,
        contentType: "PICKLIST",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: "PM_PREFERRED_CONTACT_MEAN",
        options: [
            "Telephone",
            "Mobile Phone",
            "Email",
            "Fax"
        ],
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _applicantPreferredContactColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._applicantPreferredContactBaseColumnBinding),
    };
    public get applicantPreferredContact(): ColumnBinding<string | null> {
        return this._applicantPreferredContactColumnBinding;
    }
    protected static _applicantCountryBaseColumnBinding: BaseColumnBinding = {
        label: "Country",
        templateLabel: "Applicant Country",
        fieldName: "applicantCountry",
        dbColumnName: "APPLICANT_COUNTRY",
        isRequired: false,
        contentType: "TEXT",
        length: 100,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _applicantCountryColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._applicantCountryBaseColumnBinding),
    };
    public get applicantCountry(): ColumnBinding<string | null> {
        return this._applicantCountryColumnBinding;
    }
    protected static _applicantAddressBaseColumnBinding: BaseColumnBinding = {
        label: "Address",
        templateLabel: "Applicant Address",
        fieldName: "applicantAddress",
        dbColumnName: "APPLICANT_ADDRESS",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _applicantAddressColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._applicantAddressBaseColumnBinding),
    };
    public get applicantAddress(): ColumnBinding<string | null> {
        return this._applicantAddressColumnBinding;
    }
    protected static _vehicleParkingRelevantToApplicationBaseColumnBinding: BaseColumnBinding = {
        label: "Vehicle Parking relevant to application",
        templateLabel: "",
        fieldName: "vehicleParkingRelevantToApplication",
        dbColumnName: "VEHICLE_PARKING_RELEVANT_TO_APPLICATION",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _vehicleParkingRelevantToApplicationColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._vehicleParkingRelevantToApplicationBaseColumnBinding),
    };
    public get vehicleParkingRelevantToApplication(): ColumnBinding<number | null> {
        return this._vehicleParkingRelevantToApplicationColumnBinding;
    }
    protected static _sameAddressAsApplicationBaseColumnBinding: BaseColumnBinding = {
        label: "Same address as Application",
        templateLabel: "",
        fieldName: "sameAddressAsApplication",
        dbColumnName: "SAME_ADDRESS_AS_APPLICATION",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _sameAddressAsApplicationColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._sameAddressAsApplicationBaseColumnBinding),
    };
    public get sameAddressAsApplication(): ColumnBinding<number | null> {
        return this._sameAddressAsApplicationColumnBinding;
    }
    protected static _smApplicationFromPlanningPortalBaseColumnBinding: BaseColumnBinding = {
        label: "Application from Planning Portal?",
        templateLabel: "",
        fieldName: "smApplicationFromPlanningPortal",
        dbColumnName: "SM_APPLICATION_FROM_PLANNING_PORTAL",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _smApplicationFromPlanningPortalColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._smApplicationFromPlanningPortalBaseColumnBinding),
    };
    public get smApplicationFromPlanningPortal(): ColumnBinding<number | null> {
        return this._smApplicationFromPlanningPortalColumnBinding;
    }
    protected static _addressLine_1BaseColumnBinding: BaseColumnBinding = {
        label: "Address Line 1",
        templateLabel: "",
        fieldName: "addressLine_1",
        dbColumnName: "ADDRESS_LINE_1",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _addressLine_1ColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._addressLine_1BaseColumnBinding),
    };
    public get addressLine_1(): ColumnBinding<string | null> {
        return this._addressLine_1ColumnBinding;
    }
    protected static _addressLine_2BaseColumnBinding: BaseColumnBinding = {
        label: "Address Line 2",
        templateLabel: "",
        fieldName: "addressLine_2",
        dbColumnName: "ADDRESS_LINE_2",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _addressLine_2ColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._addressLine_2BaseColumnBinding),
    };
    public get addressLine_2(): ColumnBinding<string | null> {
        return this._addressLine_2ColumnBinding;
    }
    protected static _addressLine_3BaseColumnBinding: BaseColumnBinding = {
        label: "Address Line 3",
        templateLabel: "",
        fieldName: "addressLine_3",
        dbColumnName: "ADDRESS_LINE_3",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _addressLine_3ColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._addressLine_3BaseColumnBinding),
    };
    public get addressLine_3(): ColumnBinding<string | null> {
        return this._addressLine_3ColumnBinding;
    }
    protected static _postTownBaseColumnBinding: BaseColumnBinding = {
        label: "Post Town",
        templateLabel: "",
        fieldName: "postTown",
        dbColumnName: "POST_TOWN",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _postTownColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._postTownBaseColumnBinding),
    };
    public get postTown(): ColumnBinding<string | null> {
        return this._postTownColumnBinding;
    }
    protected static _plansIndexedBaseColumnBinding: BaseColumnBinding = {
        label: "Plans and Documents uploaded and indexed",
        templateLabel: "",
        fieldName: "plansIndexed",
        dbColumnName: "PLANS_INDEXED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _plansIndexedColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._plansIndexedBaseColumnBinding),
    };
    public get plansIndexed(): ColumnBinding<number | null> {
        return this._plansIndexedColumnBinding;
    }
    protected static _validationStageBaseColumnBinding: BaseColumnBinding = {
        label: "Validation Stage",
        templateLabel: "",
        fieldName: "validationStage",
        dbColumnName: "VALIDATION_STAGE",
        isRequired: false,
        contentType: "PICKLIST",
        length: 0,
        defaultValue: "NEW APPLICATION",
        helpText: null,
        picklistName: "PM_VALIDATION_STAGE",
        options: [
            "NEW APPLICATION",
            "PREVALIDATION",
            "VALIDATION CHECKING",
            "VALIDATION CROSS CHECK",
            "COMPLETED",
            "CANCELLED",
            "RECEIVED"
        ],
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _validationStageColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._validationStageBaseColumnBinding),
    };
    public get validationStage(): ColumnBinding<string | null> {
        return this._validationStageColumnBinding;
    }
    protected static _validationChallengeStatusBaseColumnBinding: BaseColumnBinding = {
        label: "Validation Challenge Status",
        templateLabel: "",
        fieldName: "validationChallengeStatus",
        dbColumnName: "VALIDATION_CHALLENGE_STATUS",
        isRequired: false,
        contentType: "PICKLIST",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: "PM_VALIDATION_CHALLENGE_STATUS",
        options: [
            "Pending",
            "Non Validation letter issued",
            "Validation letter issued",
            "Complied with",
            "Withdrawn",
            "Appealed"
        ],
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _validationChallengeStatusColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._validationChallengeStatusBaseColumnBinding),
    };
    public get validationChallengeStatus(): ColumnBinding<string | null> {
        return this._validationChallengeStatusColumnBinding;
    }
    protected static _challengeStatusAppealDecisionBaseColumnBinding: BaseColumnBinding = {
        label: "Challenge Status Appeal Decision",
        templateLabel: "",
        fieldName: "challengeStatusAppealDecision",
        dbColumnName: "CHALLENGE_STATUS_APPEAL_DECISION",
        isRequired: false,
        contentType: "PICKLIST",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: "PM_CHALLENGE_STATUS_APPEAL_DECISION",
        options: [
            "APPEAL ACCEPTED",
            "APPEAL REFUSED",
            "APPEAL WITHDRAWN"
        ],
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _challengeStatusAppealDecisionColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._challengeStatusAppealDecisionBaseColumnBinding),
    };
    public get challengeStatusAppealDecision(): ColumnBinding<string | null> {
        return this._challengeStatusAppealDecisionColumnBinding;
    }
    protected static _validationAppealIssuedBaseColumnBinding: BaseColumnBinding = {
        label: "Appeal Issued",
        templateLabel: "",
        fieldName: "validationAppealIssued",
        dbColumnName: "VALIDATION_APPEAL_ISSUED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _validationAppealIssuedColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._validationAppealIssuedBaseColumnBinding),
    };
    public get validationAppealIssued(): ColumnBinding<number | null> {
        return this._validationAppealIssuedColumnBinding;
    }
    protected static _validationPinsDecisionBaseColumnBinding: BaseColumnBinding = {
        label: "PINS Decision",
        templateLabel: "",
        fieldName: "validationPinsDecision",
        dbColumnName: "VALIDATION_PINS_DECISION",
        isRequired: false,
        contentType: "PICKLIST",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: "PM_CHALLENGE_STATUS_APPEAL_DECISION",
        options: [
            "APPEAL ACCEPTED",
            "APPEAL REFUSED",
            "APPEAL WITHDRAWN"
        ],
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _validationPinsDecisionColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._validationPinsDecisionBaseColumnBinding),
    };
    public get validationPinsDecision(): ColumnBinding<string | null> {
        return this._validationPinsDecisionColumnBinding;
    }
    protected static _caseOfficerIdBaseColumnBinding: BaseColumnBinding = {
        label: "Case Officer",
        templateLabel: "",
        fieldName: "caseOfficerId",
        dbColumnName: "CASE_OFFICER_ID",
        isRequired: false,
        contentType: "LOOKUP",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: "USERS_",
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _caseOfficerIdColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._caseOfficerIdBaseColumnBinding),
    };
    public get caseOfficerId(): ColumnBinding<number | null> {
        return this._caseOfficerIdColumnBinding;
    }
    protected static _applicationReceiptAcknowledgedBaseColumnBinding: BaseColumnBinding = {
        label: "Application Receipt Acknowledged",
        templateLabel: "",
        fieldName: "applicationReceiptAcknowledged",
        dbColumnName: "APPLICATION_RECEIPT_ACKNOWLEDGED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _applicationReceiptAcknowledgedColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._applicationReceiptAcknowledgedBaseColumnBinding),
    };
    public get applicationReceiptAcknowledged(): ColumnBinding<number | null> {
        return this._applicationReceiptAcknowledgedColumnBinding;
    }
    protected static _parentApplicationIdBaseColumnBinding: BaseColumnBinding = {
        label: "Parent Application",
        templateLabel: "",
        fieldName: "parentApplicationId",
        dbColumnName: "PARENT_APPLICATION_ID",
        isRequired: false,
        contentType: "LOOKUP",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: "P_APPLICATION",
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _parentApplicationIdColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._parentApplicationIdBaseColumnBinding),
    };
    public get parentApplicationId(): ColumnBinding<number | null> {
        return this._parentApplicationIdColumnBinding;
    }
    protected static _paymentFinalizedBaseColumnBinding: BaseColumnBinding = {
        label: "Payment Finalized",
        templateLabel: "",
        fieldName: "paymentFinalized",
        dbColumnName: "PAYMENT_FINALIZED",
        isRequired: false,
        contentType: "PICKLIST",
        length: 0,
        defaultValue: null,
        helpText: "When this value is changed an email is sent upon saving the record.",
        picklistName: "YESNO",
        options: [
            "Yes",
            "No"
        ],
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _paymentFinalizedColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._paymentFinalizedBaseColumnBinding),
    };
    public get paymentFinalized(): ColumnBinding<string | null> {
        return this._paymentFinalizedColumnBinding;
    }
    protected static _listedBuildingExemptionBaseColumnBinding: BaseColumnBinding = {
        label: "Listed Building Exemption",
        templateLabel: "",
        fieldName: "listedBuildingExemption",
        dbColumnName: "LISTED_BUILDING_EXEMPTION",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _listedBuildingExemptionColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._listedBuildingExemptionBaseColumnBinding),
    };
    public get listedBuildingExemption(): ColumnBinding<number | null> {
        return this._listedBuildingExemptionColumnBinding;
    }
    protected static _disabledAdaptationWorksBaseColumnBinding: BaseColumnBinding = {
        label: "Disabled Adaptation Works",
        templateLabel: "",
        fieldName: "disabledAdaptationWorks",
        dbColumnName: "DISABLED_ADAPTATION_WORKS",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _disabledAdaptationWorksColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._disabledAdaptationWorksBaseColumnBinding),
    };
    public get disabledAdaptationWorks(): ColumnBinding<number | null> {
        return this._disabledAdaptationWorksColumnBinding;
    }
    protected static _freeGoApplicationBaseColumnBinding: BaseColumnBinding = {
        label: "Free Go Application",
        templateLabel: "",
        fieldName: "freeGoApplication",
        dbColumnName: "FREE_GO_APPLICATION",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _freeGoApplicationColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._freeGoApplicationBaseColumnBinding),
    };
    public get freeGoApplication(): ColumnBinding<number | null> {
        return this._freeGoApplicationColumnBinding;
    }
    protected static _feesImportedBaseColumnBinding: BaseColumnBinding = {
        label: "Fees Imported",
        templateLabel: "",
        fieldName: "feesImported",
        dbColumnName: "FEES_IMPORTED",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _feesImportedColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._feesImportedBaseColumnBinding),
    };
    public get feesImported(): ColumnBinding<number | null> {
        return this._feesImportedColumnBinding;
    }
    protected static _feesPaidBaseColumnBinding: BaseColumnBinding = {
        label: "Fees Paid",
        templateLabel: "",
        fieldName: "feesPaid",
        dbColumnName: "FEES_PAID",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _feesPaidColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._feesPaidBaseColumnBinding),
    };
    public get feesPaid(): ColumnBinding<number | null> {
        return this._feesPaidColumnBinding;
    }
    protected static _feesTransferredBaseColumnBinding: BaseColumnBinding = {
        label: "Fees Transferred",
        templateLabel: "",
        fieldName: "feesTransferred",
        dbColumnName: "FEES_TRANSFERRED",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _feesTransferredColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._feesTransferredBaseColumnBinding),
    };
    public get feesTransferred(): ColumnBinding<number | null> {
        return this._feesTransferredColumnBinding;
    }
    protected static _feesExemptionBaseColumnBinding: BaseColumnBinding = {
        label: "Fees Exemption",
        templateLabel: "",
        fieldName: "feesExemption",
        dbColumnName: "FEES_EXEMPTION",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _feesExemptionColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._feesExemptionBaseColumnBinding),
    };
    public get feesExemption(): ColumnBinding<number | null> {
        return this._feesExemptionColumnBinding;
    }
    protected static _feesTransferredInBaseColumnBinding: BaseColumnBinding = {
        label: "Fees Transferred In",
        templateLabel: "",
        fieldName: "feesTransferredIn",
        dbColumnName: "FEES_TRANSFERRED_IN",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _feesTransferredInColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._feesTransferredInBaseColumnBinding),
    };
    public get feesTransferredIn(): ColumnBinding<number | null> {
        return this._feesTransferredInColumnBinding;
    }
    protected static _feesTransferredOutBaseColumnBinding: BaseColumnBinding = {
        label: "Fees Transferred Out",
        templateLabel: "",
        fieldName: "feesTransferredOut",
        dbColumnName: "FEES_TRANSFERRED_OUT",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _feesTransferredOutColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._feesTransferredOutBaseColumnBinding),
    };
    public get feesTransferredOut(): ColumnBinding<number | null> {
        return this._feesTransferredOutColumnBinding;
    }
    protected static _applicantFullNameBaseColumnBinding: BaseColumnBinding = {
        label: "Full Name",
        templateLabel: "Applicant Full Name",
        fieldName: "applicantFullName",
        dbColumnName: "APPLICANT_FULL_NAME",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _applicantFullNameColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._applicantFullNameBaseColumnBinding),
    };
    public get applicantFullName(): ColumnBinding<string | null> {
        return this._applicantFullNameColumnBinding;
    }
    protected static _agentFullNameBaseColumnBinding: BaseColumnBinding = {
        label: "Full Name",
        templateLabel: "Agent Full Name",
        fieldName: "agentFullName",
        dbColumnName: "AGENT_FULL_NAME",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _agentFullNameColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._agentFullNameBaseColumnBinding),
    };
    public get agentFullName(): ColumnBinding<string | null> {
        return this._agentFullNameColumnBinding;
    }
    protected static _applicantAddressLine_2BaseColumnBinding: BaseColumnBinding = {
        label: "Address Line 2",
        templateLabel: "Applicant Address Line 2",
        fieldName: "applicantAddressLine_2",
        dbColumnName: "APPLICANT_ADDRESS_LINE_2",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _applicantAddressLine_2ColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._applicantAddressLine_2BaseColumnBinding),
    };
    public get applicantAddressLine_2(): ColumnBinding<string | null> {
        return this._applicantAddressLine_2ColumnBinding;
    }
    protected static _applicantAddressLine_3BaseColumnBinding: BaseColumnBinding = {
        label: "Address Line 3",
        templateLabel: "Applicant Address Line 3",
        fieldName: "applicantAddressLine_3",
        dbColumnName: "APPLICANT_ADDRESS_LINE_3",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _applicantAddressLine_3ColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._applicantAddressLine_3BaseColumnBinding),
    };
    public get applicantAddressLine_3(): ColumnBinding<string | null> {
        return this._applicantAddressLine_3ColumnBinding;
    }
    protected static _applicantAddressLine_1BaseColumnBinding: BaseColumnBinding = {
        label: "Address Line 1",
        templateLabel: "Applicant Address Line 1",
        fieldName: "applicantAddressLine_1",
        dbColumnName: "APPLICANT_ADDRESS_LINE_1",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _applicantAddressLine_1ColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._applicantAddressLine_1BaseColumnBinding),
    };
    public get applicantAddressLine_1(): ColumnBinding<string | null> {
        return this._applicantAddressLine_1ColumnBinding;
    }
    protected static _agentAddressLine_2BaseColumnBinding: BaseColumnBinding = {
        label: "Address Line 2",
        templateLabel: "Agent Address Line 2",
        fieldName: "agentAddressLine_2",
        dbColumnName: "AGENT_ADDRESS_LINE_2",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _agentAddressLine_2ColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._agentAddressLine_2BaseColumnBinding),
    };
    public get agentAddressLine_2(): ColumnBinding<string | null> {
        return this._agentAddressLine_2ColumnBinding;
    }
    protected static _agentAddressLine_3BaseColumnBinding: BaseColumnBinding = {
        label: "Address Line 3",
        templateLabel: "Agent Address Line 3",
        fieldName: "agentAddressLine_3",
        dbColumnName: "AGENT_ADDRESS_LINE_3",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _agentAddressLine_3ColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._agentAddressLine_3BaseColumnBinding),
    };
    public get agentAddressLine_3(): ColumnBinding<string | null> {
        return this._agentAddressLine_3ColumnBinding;
    }
    protected static _agentAddressLine_1BaseColumnBinding: BaseColumnBinding = {
        label: "Address Line 1",
        templateLabel: "Agent Address Line 1",
        fieldName: "agentAddressLine_1",
        dbColumnName: "AGENT_ADDRESS_LINE_1",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _agentAddressLine_1ColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._agentAddressLine_1BaseColumnBinding),
    };
    public get agentAddressLine_1(): ColumnBinding<string | null> {
        return this._agentAddressLine_1ColumnBinding;
    }
    protected static _applicantPostcodeBaseColumnBinding: BaseColumnBinding = {
        label: "Postcode",
        templateLabel: "Applicant Postcode",
        fieldName: "applicantPostcode",
        dbColumnName: "APPLICANT_POSTCODE",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _applicantPostcodeColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._applicantPostcodeBaseColumnBinding),
    };
    public get applicantPostcode(): ColumnBinding<string | null> {
        return this._applicantPostcodeColumnBinding;
    }
    protected static _validationProcessingCompleteBaseColumnBinding: BaseColumnBinding = {
        label: "Validation Processing Complete",
        templateLabel: "",
        fieldName: "validationProcessingComplete",
        dbColumnName: "VALIDATION_PROCESSING_COMPLETE",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _validationProcessingCompleteColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._validationProcessingCompleteBaseColumnBinding),
    };
    public get validationProcessingComplete(): ColumnBinding<number | null> {
        return this._validationProcessingCompleteColumnBinding;
    }
    protected static _correctFeeConfirmedBaseColumnBinding: BaseColumnBinding = {
        label: "Correct Fee Confirmed",
        templateLabel: "",
        fieldName: "correctFeeConfirmed",
        dbColumnName: "CORRECT_FEE_CONFIRMED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _correctFeeConfirmedColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._correctFeeConfirmedBaseColumnBinding),
    };
    public get correctFeeConfirmed(): ColumnBinding<number | null> {
        return this._correctFeeConfirmedColumnBinding;
    }
    protected static _plottedBoundaryConfirmedBaseColumnBinding: BaseColumnBinding = {
        label: "Plotted Boundary Confirmed",
        templateLabel: "",
        fieldName: "plottedBoundaryConfirmed",
        dbColumnName: "PLOTTED_BOUNDARY_CONFIRMED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _plottedBoundaryConfirmedColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._plottedBoundaryConfirmedBaseColumnBinding),
    };
    public get plottedBoundaryConfirmed(): ColumnBinding<number | null> {
        return this._plottedBoundaryConfirmedColumnBinding;
    }
    protected static _plansScannedBaseColumnBinding: BaseColumnBinding = {
        label: "Plans and Documents being scanned",
        templateLabel: "",
        fieldName: "plansScanned",
        dbColumnName: "PLANS_SCANNED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _plansScannedColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._plansScannedBaseColumnBinding),
    };
    public get plansScanned(): ColumnBinding<number | null> {
        return this._plansScannedColumnBinding;
    }
    protected static _validationStatusBaseColumnBinding: BaseColumnBinding = {
        label: "Validation Status",
        templateLabel: "",
        fieldName: "validationStatus",
        dbColumnName: "VALIDATION_STATUS",
        isRequired: false,
        contentType: "PICKLIST",
        length: 0,
        defaultValue: "RECEIVED",
        helpText: null,
        picklistName: "PM_VALIDATION_STATUS",
        options: [
            "RECEIVED",
            "REGISTERED",
            "FURTHER INFORMATION REQUIRED",
            "FURTHER INFORMATION RECEIVED",
            "VALID",
            "WITHDRAWN",
            "RETURNED",
            "APPEAL ARTICLE 12 PINS",
            "APPEAL FOR NON-DETERMINATION"
        ],
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _validationStatusColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._validationStatusBaseColumnBinding),
    };
    public get validationStatus(): ColumnBinding<string | null> {
        return this._validationStatusColumnBinding;
    }
    protected static _validationChallengedBaseColumnBinding: BaseColumnBinding = {
        label: "Validation Challenged",
        templateLabel: "",
        fieldName: "validationChallenged",
        dbColumnName: "VALIDATION_CHALLENGED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _validationChallengedColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._validationChallengedBaseColumnBinding),
    };
    public get validationChallenged(): ColumnBinding<number | null> {
        return this._validationChallengedColumnBinding;
    }
    protected static _plottedBoundaryRequiredBaseColumnBinding: BaseColumnBinding = {
        label: "Plotted Boundary Required",
        templateLabel: "",
        fieldName: "plottedBoundaryRequired",
        dbColumnName: "PLOTTED_BOUNDARY_REQUIRED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _plottedBoundaryRequiredColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._plottedBoundaryRequiredBaseColumnBinding),
    };
    public get plottedBoundaryRequired(): ColumnBinding<number | null> {
        return this._plottedBoundaryRequiredColumnBinding;
    }
    protected static _validationChallengeStatusAppealedBaseColumnBinding: BaseColumnBinding = {
        label: "Challenge Status Appealed",
        templateLabel: "",
        fieldName: "validationChallengeStatusAppealed",
        dbColumnName: "VALIDATION_CHALLENGE_STATUS_APPEALED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _validationChallengeStatusAppealedColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._validationChallengeStatusAppealedBaseColumnBinding),
    };
    public get validationChallengeStatusAppealed(): ColumnBinding<number | null> {
        return this._validationChallengeStatusAppealedColumnBinding;
    }
    protected static _plansToFollowBaseColumnBinding: BaseColumnBinding = {
        label: "Plans and Documents to follow",
        templateLabel: "",
        fieldName: "plansToFollow",
        dbColumnName: "PLANS_TO_FOLLOW",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _plansToFollowColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._plansToFollowBaseColumnBinding),
    };
    public get plansToFollow(): ColumnBinding<number | null> {
        return this._plansToFollowColumnBinding;
    }
    protected static _involvesChangeOfUseClassBaseColumnBinding: BaseColumnBinding = {
        label: "Involves Change of Use",
        templateLabel: "",
        fieldName: "involvesChangeOfUseClass",
        dbColumnName: "INVOLVES_CHANGE_OF_USE_CLASS",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _involvesChangeOfUseClassColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._involvesChangeOfUseClassBaseColumnBinding),
    };
    public get involvesChangeOfUseClass(): ColumnBinding<number | null> {
        return this._involvesChangeOfUseClassColumnBinding;
    }
    protected static _boundaryPlotRequiredBaseColumnBinding: BaseColumnBinding = {
        label: "Boundary Plot Required",
        templateLabel: "",
        fieldName: "boundaryPlotRequired",
        dbColumnName: "BOUNDARY_PLOT_REQUIRED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _boundaryPlotRequiredColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._boundaryPlotRequiredBaseColumnBinding),
    };
    public get boundaryPlotRequired(): ColumnBinding<number | null> {
        return this._boundaryPlotRequiredColumnBinding;
    }
    protected static _applicationPlottedBaseColumnBinding: BaseColumnBinding = {
        label: "Application Plotted",
        templateLabel: "",
        fieldName: "applicationPlotted",
        dbColumnName: "APPLICATION_PLOTTED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _applicationPlottedColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._applicationPlottedBaseColumnBinding),
    };
    public get applicationPlotted(): ColumnBinding<number | null> {
        return this._applicationPlottedColumnBinding;
    }
    protected static _noBoundaryInformationProvidedBaseColumnBinding: BaseColumnBinding = {
        label: "No Boundary Information Provided",
        templateLabel: "",
        fieldName: "noBoundaryInformationProvided",
        dbColumnName: "NO_BOUNDARY_INFORMATION_PROVIDED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _noBoundaryInformationProvidedColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._noBoundaryInformationProvidedBaseColumnBinding),
    };
    public get noBoundaryInformationProvided(): ColumnBinding<number | null> {
        return this._noBoundaryInformationProvidedColumnBinding;
    }
    protected static _declaredBoundaryAreaBaseColumnBinding: BaseColumnBinding = {
        label: "Declared Boundary Area",
        templateLabel: "",
        fieldName: "declaredBoundaryArea",
        dbColumnName: "DECLARED_BOUNDARY_AREA",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _declaredBoundaryAreaColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._declaredBoundaryAreaBaseColumnBinding),
    };
    public get declaredBoundaryArea(): ColumnBinding<number | null> {
        return this._declaredBoundaryAreaColumnBinding;
    }
    protected static _feeAmountBaseColumnBinding: BaseColumnBinding = {
        label: "Fee Amount (\u00A3)",
        templateLabel: "",
        fieldName: "feeAmount",
        dbColumnName: "FEE_AMOUNT",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _feeAmountColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._feeAmountBaseColumnBinding),
    };
    public get feeAmount(): ColumnBinding<number | null> {
        return this._feeAmountColumnBinding;
    }
    protected static _originalBoundaryAreaBaseColumnBinding: BaseColumnBinding = {
        label: "Original Boundary Area",
        templateLabel: "",
        fieldName: "originalBoundaryArea",
        dbColumnName: "ORIGINAL_BOUNDARY_AREA",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _originalBoundaryAreaColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._originalBoundaryAreaBaseColumnBinding),
    };
    public get originalBoundaryArea(): ColumnBinding<number | null> {
        return this._originalBoundaryAreaColumnBinding;
    }
    protected static _agentCompanyBaseColumnBinding: BaseColumnBinding = {
        label: "Company",
        templateLabel: "Agent Company",
        fieldName: "agentCompany",
        dbColumnName: "AGENT_COMPANY",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _agentCompanyColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._agentCompanyBaseColumnBinding),
    };
    public get agentCompany(): ColumnBinding<string | null> {
        return this._agentCompanyColumnBinding;
    }
    protected static _applicantCompanyBaseColumnBinding: BaseColumnBinding = {
        label: "Company",
        templateLabel: "Applicant Company",
        fieldName: "applicantCompany",
        dbColumnName: "APPLICANT_COMPANY",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _applicantCompanyColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._applicantCompanyBaseColumnBinding),
    };
    public get applicantCompany(): ColumnBinding<string | null> {
        return this._applicantCompanyColumnBinding;
    }
    protected static _registrationValidationConfirmedDateBaseColumnBinding: BaseColumnBinding = {
        label: "Registration Validation Confirmation Date",
        templateLabel: "",
        fieldName: "registrationValidationConfirmedDate",
        dbColumnName: "REGISTRATION_VALIDATION_CONFIRMED_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _registrationValidationConfirmedDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._registrationValidationConfirmedDateBaseColumnBinding),
    };
    public get registrationValidationConfirmedDate(): ColumnBinding<Date | null> {
        return this._registrationValidationConfirmedDateColumnBinding;
    }
    protected static _registrationValidationConfirmedBaseColumnBinding: BaseColumnBinding = {
        label: "Registration Validation Confirmed",
        templateLabel: "",
        fieldName: "registrationValidationConfirmed",
        dbColumnName: "REGISTRATION_VALIDATION_CONFIRMED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: "\"Validation Decision should be 'Valid' and Validation Stage should be 'Validation Cross Check'.\"",
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _registrationValidationConfirmedColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._registrationValidationConfirmedBaseColumnBinding),
    };
    public get registrationValidationConfirmed(): ColumnBinding<number | null> {
        return this._registrationValidationConfirmedColumnBinding;
    }
    protected static _applicationStatusBaseColumnBinding: BaseColumnBinding = {
        label: "Status",
        templateLabel: "",
        fieldName: "applicationStatus",
        dbColumnName: "APPLICATION_STATUS",
        isRequired: false,
        contentType: "PICKLIST",
        length: 0,
        defaultValue: "Received",
        helpText: null,
        picklistName: "PM_APPLICATION_STATUS",
        options: [
            "Live",
            "Withdrawn",
            "Called In",
            "Referred to GLA",
            "Returned From GLA",
            "Referred to SOS",
            "Returned From SOS",
            "APPEAL ARTICLE 12 PINS",
            "Further Information Required",
            "Further Information Received",
            "Returned",
            "Appeal Determined",
            "Determined",
            "Appealed",
            "Received",
            "Invalid"
        ],
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _applicationStatusColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._applicationStatusBaseColumnBinding),
    };
    public get applicationStatus(): ColumnBinding<string | null> {
        return this._applicationStatusColumnBinding;
    }
    protected static _timeExtensionDateBaseColumnBinding: BaseColumnBinding = {
        label: "Agreed Time Extension Date",
        templateLabel: "",
        fieldName: "timeExtensionDate",
        dbColumnName: "TIME_EXTENSION_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _timeExtensionDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._timeExtensionDateBaseColumnBinding),
    };
    public get timeExtensionDate(): ColumnBinding<Date | null> {
        return this._timeExtensionDateColumnBinding;
    }
    protected static _notificationsConsultationsSentBaseColumnBinding: BaseColumnBinding = {
        label: "Notifications / Consultations Sent",
        templateLabel: "",
        fieldName: "notificationsConsultationsSent",
        dbColumnName: "NOTIFICATIONS_CONSULTATIONS_SENT",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _notificationsConsultationsSentColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._notificationsConsultationsSentBaseColumnBinding),
    };
    public get notificationsConsultationsSent(): ColumnBinding<Date | null> {
        return this._notificationsConsultationsSentColumnBinding;
    }
    protected static _publicNoticePublishedBaseColumnBinding: BaseColumnBinding = {
        label: "Public Notice Published",
        templateLabel: "",
        fieldName: "publicNoticePublished",
        dbColumnName: "PUBLIC_NOTICE_PUBLISHED",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _publicNoticePublishedColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._publicNoticePublishedBaseColumnBinding),
    };
    public get publicNoticePublished(): ColumnBinding<Date | null> {
        return this._publicNoticePublishedColumnBinding;
    }
    protected static _furtherInformationRequestedDateBaseColumnBinding: BaseColumnBinding = {
        label: "Further Information Requested Date",
        templateLabel: "",
        fieldName: "furtherInformationRequestedDate",
        dbColumnName: "FURTHER_INFORMATION_REQUESTED_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _furtherInformationRequestedDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._furtherInformationRequestedDateBaseColumnBinding),
    };
    public get furtherInformationRequestedDate(): ColumnBinding<Date | null> {
        return this._furtherInformationRequestedDateColumnBinding;
    }
    protected static _initialSiteVisitUndertakenBaseColumnBinding: BaseColumnBinding = {
        label: "Initial Site Visit Undertaken",
        templateLabel: "",
        fieldName: "initialSiteVisitUndertaken",
        dbColumnName: "INITIAL_SITE_VISIT_UNDERTAKEN",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _initialSiteVisitUndertakenColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._initialSiteVisitUndertakenBaseColumnBinding),
    };
    public get initialSiteVisitUndertaken(): ColumnBinding<Date | null> {
        return this._initialSiteVisitUndertakenColumnBinding;
    }
    protected static _amendedApplicationBaseColumnBinding: BaseColumnBinding = {
        label: "Amended Application",
        templateLabel: "",
        fieldName: "amendedApplication",
        dbColumnName: "AMENDED_APPLICATION",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _amendedApplicationColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._amendedApplicationBaseColumnBinding),
    };
    public get amendedApplication(): ColumnBinding<number | null> {
        return this._amendedApplicationColumnBinding;
    }
    protected static _retrospectiveApplicationBaseColumnBinding: BaseColumnBinding = {
        label: "Retrospective Application",
        templateLabel: "",
        fieldName: "retrospectiveApplication",
        dbColumnName: "RETROSPECTIVE_APPLICATION",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _retrospectiveApplicationColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._retrospectiveApplicationBaseColumnBinding),
    };
    public get retrospectiveApplication(): ColumnBinding<number | null> {
        return this._retrospectiveApplicationColumnBinding;
    }
    protected static _addressCareOfAgentBaseColumnBinding: BaseColumnBinding = {
        label: "Address Care of Agent",
        templateLabel: "",
        fieldName: "addressCareOfAgent",
        dbColumnName: "ADDRESS_CARE_OF_AGENT",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _addressCareOfAgentColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._addressCareOfAgentBaseColumnBinding),
    };
    public get addressCareOfAgent(): ColumnBinding<number | null> {
        return this._addressCareOfAgentColumnBinding;
    }
    protected static _applicantAgentIsAMemberOfStaffBaseColumnBinding: BaseColumnBinding = {
        label: "Applicant, Agent is a member of staff, councillor, or related to one",
        templateLabel: "",
        fieldName: "applicantAgentIsAMemberOfStaff",
        dbColumnName: "APPLICANT_AGENT_IS_A_MEMBER_OF_STAFF",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _applicantAgentIsAMemberOfStaffColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._applicantAgentIsAMemberOfStaffBaseColumnBinding),
    };
    public get applicantAgentIsAMemberOfStaff(): ColumnBinding<number | null> {
        return this._applicantAgentIsAMemberOfStaffColumnBinding;
    }
    protected static _councillorRelativeDetailsBaseColumnBinding: BaseColumnBinding = {
        label: "Relationship details",
        templateLabel: "",
        fieldName: "councillorRelativeDetails",
        dbColumnName: "COUNCILLOR_RELATIVE_DETAILS",
        isRequired: false,
        contentType: "TEXTAREA",
        length: 1000,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _councillorRelativeDetailsColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._councillorRelativeDetailsBaseColumnBinding),
    };
    public get councillorRelativeDetails(): ColumnBinding<string | null> {
        return this._councillorRelativeDetailsColumnBinding;
    }
    protected static _proposalBaseColumnBinding: BaseColumnBinding = {
        label: "Proposal Details",
        templateLabel: "",
        fieldName: "proposal",
        dbColumnName: "PROPOSAL",
        isRequired: false,
        contentType: "TEXTAREA",
        length: 1000,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _proposalColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._proposalBaseColumnBinding),
    };
    public get proposal(): ColumnBinding<string | null> {
        return this._proposalColumnBinding;
    }
    protected static _existingGrossFloorspaceBaseColumnBinding: BaseColumnBinding = {
        label: "Existing Gross Floorspace",
        templateLabel: "",
        fieldName: "existingGrossFloorspace",
        dbColumnName: "EXISTING_GROSS_FLOORSPACE",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _existingGrossFloorspaceColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._existingGrossFloorspaceBaseColumnBinding),
    };
    public get existingGrossFloorspace(): ColumnBinding<number | null> {
        return this._existingGrossFloorspaceColumnBinding;
    }
    protected static _grossFloorspaceToBeLostBaseColumnBinding: BaseColumnBinding = {
        label: "Gross Floorspace to be Lost",
        templateLabel: "",
        fieldName: "grossFloorspaceToBeLost",
        dbColumnName: "GROSS_FLOORSPACE_TO_BE_LOST",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _grossFloorspaceToBeLostColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._grossFloorspaceToBeLostBaseColumnBinding),
    };
    public get grossFloorspaceToBeLost(): ColumnBinding<number | null> {
        return this._grossFloorspaceToBeLostColumnBinding;
    }
    protected static _totalGrossFloorspaceProposedBaseColumnBinding: BaseColumnBinding = {
        label: "Total Gross Floorspace Proposed",
        templateLabel: "",
        fieldName: "totalGrossFloorspaceProposed",
        dbColumnName: "TOTAL_GROSS_FLOORSPACE_PROPOSED",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _totalGrossFloorspaceProposedColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._totalGrossFloorspaceProposedBaseColumnBinding),
    };
    public get totalGrossFloorspaceProposed(): ColumnBinding<number | null> {
        return this._totalGrossFloorspaceProposedColumnBinding;
    }
    protected static _netAdditionalGrossFloorspaceBaseColumnBinding: BaseColumnBinding = {
        label: "Net Additional Gross Floorspace",
        templateLabel: "",
        fieldName: "netAdditionalGrossFloorspace",
        dbColumnName: "NET_ADDITIONAL_GROSS_FLOORSPACE",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _netAdditionalGrossFloorspaceColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._netAdditionalGrossFloorspaceBaseColumnBinding),
    };
    public get netAdditionalGrossFloorspace(): ColumnBinding<number | null> {
        return this._netAdditionalGrossFloorspaceColumnBinding;
    }
    protected static _technicalOfficerIdBaseColumnBinding: BaseColumnBinding = {
        label: "Technical Officer",
        templateLabel: "",
        fieldName: "technicalOfficerId",
        dbColumnName: "TECHNICAL_OFFICER_ID",
        isRequired: false,
        contentType: "LOOKUP",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: "USERS_",
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _technicalOfficerIdColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._technicalOfficerIdBaseColumnBinding),
    };
    public get technicalOfficerId(): ColumnBinding<number | null> {
        return this._technicalOfficerIdColumnBinding;
    }
    protected static _submittedDetailsBaseColumnBinding: BaseColumnBinding = {
        label: "Submitted Details",
        templateLabel: "",
        fieldName: "submittedDetails",
        dbColumnName: "SUBMITTED_DETAILS",
        isRequired: false,
        contentType: "TEXTAREA",
        length: 1000,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _submittedDetailsColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._submittedDetailsBaseColumnBinding),
    };
    public get submittedDetails(): ColumnBinding<string | null> {
        return this._submittedDetailsColumnBinding;
    }
    protected static _feesCommentsBaseColumnBinding: BaseColumnBinding = {
        label: "Fees Comments",
        templateLabel: "",
        fieldName: "feesComments",
        dbColumnName: "FEES_COMMENTS",
        isRequired: false,
        contentType: "TEXTAREA",
        length: 1000,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _feesCommentsColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._feesCommentsBaseColumnBinding),
    };
    public get feesComments(): ColumnBinding<string | null> {
        return this._feesCommentsColumnBinding;
    }
    protected static _parishCouncilDiscountBaseColumnBinding: BaseColumnBinding = {
        label: "Parish Council Discount",
        templateLabel: "",
        fieldName: "parishCouncilDiscount",
        dbColumnName: "PARISH_COUNCIL_DISCOUNT",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _parishCouncilDiscountColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._parishCouncilDiscountBaseColumnBinding),
    };
    public get parishCouncilDiscount(): ColumnBinding<number | null> {
        return this._parishCouncilDiscountColumnBinding;
    }
    protected static _decisionCodeBaseColumnBinding: BaseColumnBinding = {
        label: "Decision Code",
        templateLabel: "",
        fieldName: "decisionCode",
        dbColumnName: "DECISION_CODE",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _decisionCodeColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._decisionCodeBaseColumnBinding),
    };
    public get decisionCode(): ColumnBinding<string | null> {
        return this._decisionCodeColumnBinding;
    }
    protected static _decisionClassBaseColumnBinding: BaseColumnBinding = {
        label: "Decision Class",
        templateLabel: "",
        fieldName: "decisionClass",
        dbColumnName: "DECISION_CLASS",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _decisionClassColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._decisionClassBaseColumnBinding),
    };
    public get decisionClass(): ColumnBinding<string | null> {
        return this._decisionClassColumnBinding;
    }
    protected static _changeAffectingCentreBaseColumnBinding: BaseColumnBinding = {
        label: "Change of Use Affecting Town Centre",
        templateLabel: "",
        fieldName: "changeAffectingCentre",
        dbColumnName: "CHANGE_AFFECTING_CENTRE",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _changeAffectingCentreColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._changeAffectingCentreBaseColumnBinding),
    };
    public get changeAffectingCentre(): ColumnBinding<number | null> {
        return this._changeAffectingCentreColumnBinding;
    }
    protected static _appealTargetDateBaseColumnBinding: BaseColumnBinding = {
        label: "Appeal Target Date",
        templateLabel: "",
        fieldName: "appealTargetDate",
        dbColumnName: "APPEAL_TARGET_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _appealTargetDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._appealTargetDateBaseColumnBinding),
    };
    public get appealTargetDate(): ColumnBinding<Date | null> {
        return this._appealTargetDateColumnBinding;
    }
    protected static _notificationResponseDeadlineBaseColumnBinding: BaseColumnBinding = {
        label: "Notification Response Deadline",
        templateLabel: "",
        fieldName: "notificationResponseDeadline",
        dbColumnName: "NOTIFICATION_RESPONSE_DEADLINE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _notificationResponseDeadlineColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._notificationResponseDeadlineBaseColumnBinding),
    };
    public get notificationResponseDeadline(): ColumnBinding<Date | null> {
        return this._notificationResponseDeadlineColumnBinding;
    }
    protected static _renotificationResponseDeadlineBaseColumnBinding: BaseColumnBinding = {
        label: "Renotification Response Deadline",
        templateLabel: "",
        fieldName: "renotificationResponseDeadline",
        dbColumnName: "RENOTIFICATION_RESPONSE_DEADLINE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _renotificationResponseDeadlineColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._renotificationResponseDeadlineBaseColumnBinding),
    };
    public get renotificationResponseDeadline(): ColumnBinding<Date | null> {
        return this._renotificationResponseDeadlineColumnBinding;
    }
    protected static _consultationResponseDeadlineBaseColumnBinding: BaseColumnBinding = {
        label: "Consultation Response Deadline",
        templateLabel: "",
        fieldName: "consultationResponseDeadline",
        dbColumnName: "CONSULTATION_RESPONSE_DEADLINE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _consultationResponseDeadlineColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._consultationResponseDeadlineBaseColumnBinding),
    };
    public get consultationResponseDeadline(): ColumnBinding<Date | null> {
        return this._consultationResponseDeadlineColumnBinding;
    }
    protected static _reconsultationResponseDeadlineBaseColumnBinding: BaseColumnBinding = {
        label: "Reconsultation Response Deadline",
        templateLabel: "",
        fieldName: "reconsultationResponseDeadline",
        dbColumnName: "RECONSULTATION_RESPONSE_DEADLINE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _reconsultationResponseDeadlineColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._reconsultationResponseDeadlineBaseColumnBinding),
    };
    public get reconsultationResponseDeadline(): ColumnBinding<Date | null> {
        return this._reconsultationResponseDeadlineColumnBinding;
    }
    protected static _siteVisitContactBeforeBaseColumnBinding: BaseColumnBinding = {
        label: "Contact before arrival",
        templateLabel: "",
        fieldName: "siteVisitContactBefore",
        dbColumnName: "SITE_VISIT_CONTACT_BEFORE",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _siteVisitContactBeforeColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._siteVisitContactBeforeBaseColumnBinding),
    };
    public get siteVisitContactBefore(): ColumnBinding<number | null> {
        return this._siteVisitContactBeforeColumnBinding;
    }
    protected static _plottedBoundaryAreaBaseColumnBinding: BaseColumnBinding = {
        label: "Plotted Boundary Area",
        templateLabel: "",
        fieldName: "plottedBoundaryArea",
        dbColumnName: "PLOTTED_BOUNDARY_AREA",
        isRequired: false,
        contentType: "NUMBER",
        length: 16,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _plottedBoundaryAreaColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._plottedBoundaryAreaBaseColumnBinding),
    };
    public get plottedBoundaryArea(): ColumnBinding<number | null> {
        return this._plottedBoundaryAreaColumnBinding;
    }
    protected static _validationConfirmationOfficerIdBaseColumnBinding: BaseColumnBinding = {
        label: "Registration Validation Confirmation Officer",
        templateLabel: "",
        fieldName: "validationConfirmationOfficerId",
        dbColumnName: "VALIDATION_CONFIRMATION_OFFICER_ID",
        isRequired: false,
        contentType: "LOOKUP",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: "USERS_",
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _validationConfirmationOfficerIdColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._validationConfirmationOfficerIdBaseColumnBinding),
    };
    public get validationConfirmationOfficerId(): ColumnBinding<number | null> {
        return this._validationConfirmationOfficerIdColumnBinding;
    }
    protected static _registrationValidationConfirmationUserIdBaseColumnBinding: BaseColumnBinding = {
        label: "Registration Validation Confirmation Officer",
        templateLabel: "",
        fieldName: "registrationValidationConfirmationUserId",
        dbColumnName: "REGISTRATION_VALIDATION_CONFIRMATION_USER_ID",
        isRequired: false,
        contentType: "LOOKUP",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: "USERS_",
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _registrationValidationConfirmationUserIdColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._registrationValidationConfirmationUserIdBaseColumnBinding),
    };
    public get registrationValidationConfirmationUserId(): ColumnBinding<number | null> {
        return this._registrationValidationConfirmationUserIdColumnBinding;
    }
    protected static _feeCategoryBaseColumnBinding: BaseColumnBinding = {
        label: "Fee Category",
        templateLabel: "",
        fieldName: "feeCategory",
        dbColumnName: "FEE_CATEGORY",
        isRequired: false,
        contentType: "PICKLIST",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: "PM_FEE_CATEGORY",
        options: [
            "General",
            "Condition Request"
        ],
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _feeCategoryColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._feeCategoryBaseColumnBinding),
    };
    public get feeCategory(): ColumnBinding<string | null> {
        return this._feeCategoryColumnBinding;
    }
    protected static _applicantTypeIdBaseColumnBinding: BaseColumnBinding = {
        label: "Applicant Type",
        templateLabel: "",
        fieldName: "applicantTypeId",
        dbColumnName: "APPLICANT_TYPE_ID",
        isRequired: false,
        contentType: "LOOKUP",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: "P_APPLICANT_TYPE",
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _applicantTypeIdColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._applicantTypeIdBaseColumnBinding),
    };
    public get applicantTypeId(): ColumnBinding<number | null> {
        return this._applicantTypeIdColumnBinding;
    }
    protected static _addedDateBaseColumnBinding: BaseColumnBinding = {
        label: "Added Date",
        templateLabel: "",
        fieldName: "addedDate",
        dbColumnName: "ADDED_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _addedDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._addedDateBaseColumnBinding),
    };
    public get addedDate(): ColumnBinding<Date | null> {
        return this._addedDateColumnBinding;
    }
    protected static _registeredDateBaseColumnBinding: BaseColumnBinding = {
        label: "Registered Date",
        templateLabel: "",
        fieldName: "registeredDate",
        dbColumnName: "REGISTERED_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _registeredDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._registeredDateBaseColumnBinding),
    };
    public get registeredDate(): ColumnBinding<Date | null> {
        return this._registeredDateColumnBinding;
    }
    protected static _existingEmployeesFullTimeBaseColumnBinding: BaseColumnBinding = {
        label: "Existing Employees (full time)",
        templateLabel: "",
        fieldName: "existingEmployeesFullTime",
        dbColumnName: "EXISTING_EMPLOYEES_FULL_TIME",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _existingEmployeesFullTimeColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._existingEmployeesFullTimeBaseColumnBinding),
    };
    public get existingEmployeesFullTime(): ColumnBinding<number | null> {
        return this._existingEmployeesFullTimeColumnBinding;
    }
    protected static _existingEmployeesFullTimeEquivalentBaseColumnBinding: BaseColumnBinding = {
        label: "Existing Employees (full time equivalent)",
        templateLabel: "",
        fieldName: "existingEmployeesFullTimeEquivalent",
        dbColumnName: "EXISTING_EMPLOYEES_FULL_TIME_EQUIVALENT",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _existingEmployeesFullTimeEquivalentColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._existingEmployeesFullTimeEquivalentBaseColumnBinding),
    };
    public get existingEmployeesFullTimeEquivalent(): ColumnBinding<number | null> {
        return this._existingEmployeesFullTimeEquivalentColumnBinding;
    }
    protected static _existingEmployeesPartTimeBaseColumnBinding: BaseColumnBinding = {
        label: "Existing Employees (part time)",
        templateLabel: "",
        fieldName: "existingEmployeesPartTime",
        dbColumnName: "EXISTING_EMPLOYEES_PART_TIME",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _existingEmployeesPartTimeColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._existingEmployeesPartTimeBaseColumnBinding),
    };
    public get existingEmployeesPartTime(): ColumnBinding<number | null> {
        return this._existingEmployeesPartTimeColumnBinding;
    }
    protected static _declarationFirstNameBaseColumnBinding: BaseColumnBinding = {
        label: "First Name",
        templateLabel: "",
        fieldName: "declarationFirstName",
        dbColumnName: "DECLARATION_FIRST_NAME",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _declarationFirstNameColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._declarationFirstNameBaseColumnBinding),
    };
    public get declarationFirstName(): ColumnBinding<string | null> {
        return this._declarationFirstNameColumnBinding;
    }
    protected static _declarationSurnameBaseColumnBinding: BaseColumnBinding = {
        label: "Surname",
        templateLabel: "",
        fieldName: "declarationSurname",
        dbColumnName: "DECLARATION_SURNAME",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _declarationSurnameColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._declarationSurnameBaseColumnBinding),
    };
    public get declarationSurname(): ColumnBinding<string | null> {
        return this._declarationSurnameColumnBinding;
    }
    protected static _committeeAreaIdBaseColumnBinding: BaseColumnBinding = {
        label: "Committee Area",
        templateLabel: "",
        fieldName: "committeeAreaId",
        dbColumnName: "COMMITTEE_AREA_ID",
        isRequired: false,
        contentType: "LOOKUP",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: "P_COMMITTEE",
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _committeeAreaIdColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._committeeAreaIdBaseColumnBinding),
    };
    public get committeeAreaId(): ColumnBinding<number | null> {
        return this._committeeAreaIdColumnBinding;
    }
    protected static _referredToGlaBaseColumnBinding: BaseColumnBinding = {
        label: "Referred to GLA",
        templateLabel: "",
        fieldName: "referredToGla",
        dbColumnName: "REFERRED_TO_GLA",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _referredToGlaColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._referredToGlaBaseColumnBinding),
    };
    public get referredToGla(): ColumnBinding<number | null> {
        return this._referredToGlaColumnBinding;
    }
    protected static _dateSentToGlaBaseColumnBinding: BaseColumnBinding = {
        label: "Date Sent To GLA",
        templateLabel: "",
        fieldName: "dateSentToGla",
        dbColumnName: "DATE_SENT_TO_GLA",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _dateSentToGlaColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._dateSentToGlaBaseColumnBinding),
    };
    public get dateSentToGla(): ColumnBinding<Date | null> {
        return this._dateSentToGlaColumnBinding;
    }
    protected static _dateReturnedFromGlaBaseColumnBinding: BaseColumnBinding = {
        label: "Date Returned from GLA",
        templateLabel: "",
        fieldName: "dateReturnedFromGla",
        dbColumnName: "DATE_RETURNED_FROM_GLA",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _dateReturnedFromGlaColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._dateReturnedFromGlaBaseColumnBinding),
    };
    public get dateReturnedFromGla(): ColumnBinding<Date | null> {
        return this._dateReturnedFromGlaColumnBinding;
    }
    protected static _daysForGlaReturnBaseColumnBinding: BaseColumnBinding = {
        label: "Days for GLA return",
        templateLabel: "",
        fieldName: "daysForGlaReturn",
        dbColumnName: "DAYS_FOR_GLA_RETURN",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _daysForGlaReturnColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._daysForGlaReturnBaseColumnBinding),
    };
    public get daysForGlaReturn(): ColumnBinding<number | null> {
        return this._daysForGlaReturnColumnBinding;
    }
    protected static _reasonForGlaBaseColumnBinding: BaseColumnBinding = {
        label: "Reason for referral to GLA",
        templateLabel: "",
        fieldName: "reasonForGla",
        dbColumnName: "REASON_FOR_GLA",
        isRequired: false,
        contentType: "TEXTAREA",
        length: 1000,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _reasonForGlaColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._reasonForGlaBaseColumnBinding),
    };
    public get reasonForGla(): ColumnBinding<string | null> {
        return this._reasonForGlaColumnBinding;
    }
    protected static _dateSentToSosBaseColumnBinding: BaseColumnBinding = {
        label: "Date sent to SoS",
        templateLabel: "",
        fieldName: "dateSentToSos",
        dbColumnName: "DATE_SENT_TO_SOS",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _dateSentToSosColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._dateSentToSosBaseColumnBinding),
    };
    public get dateSentToSos(): ColumnBinding<Date | null> {
        return this._dateSentToSosColumnBinding;
    }
    protected static _dateReturnedFromSosBaseColumnBinding: BaseColumnBinding = {
        label: "Date returned from SoS",
        templateLabel: "",
        fieldName: "dateReturnedFromSos",
        dbColumnName: "DATE_RETURNED_FROM_SOS",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _dateReturnedFromSosColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._dateReturnedFromSosBaseColumnBinding),
    };
    public get dateReturnedFromSos(): ColumnBinding<Date | null> {
        return this._dateReturnedFromSosColumnBinding;
    }
    protected static _daysMtgReturnFromSosBaseColumnBinding: BaseColumnBinding = {
        label: "No. days from MTG to return from SoS",
        templateLabel: "",
        fieldName: "daysMtgReturnFromSos",
        dbColumnName: "DAYS_MTG_RETURN_FROM_SOS",
        isRequired: false,
        contentType: "NUMBER",
        length: 10,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _daysMtgReturnFromSosColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._daysMtgReturnFromSosBaseColumnBinding),
    };
    public get daysMtgReturnFromSos(): ColumnBinding<number | null> {
        return this._daysMtgReturnFromSosColumnBinding;
    }
    protected static _reasonForSosBaseColumnBinding: BaseColumnBinding = {
        label: "Reason for referral to SoS",
        templateLabel: "",
        fieldName: "reasonForSos",
        dbColumnName: "REASON_FOR_SOS",
        isRequired: false,
        contentType: "TEXTAREA",
        length: 1000,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _reasonForSosColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._reasonForSosBaseColumnBinding),
    };
    public get reasonForSos(): ColumnBinding<string | null> {
        return this._reasonForSosColumnBinding;
    }
    protected static _initialAppRefBaseColumnBinding: BaseColumnBinding = {
        label: "Initial Application Reference",
        templateLabel: "",
        fieldName: "initialAppRef",
        dbColumnName: "INITIAL_APP_REF",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _initialAppRefColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._initialAppRefBaseColumnBinding),
    };
    public get initialAppRef(): ColumnBinding<string | null> {
        return this._initialAppRefColumnBinding;
    }
    protected static _outstandingValidationStageTasksBaseColumnBinding: BaseColumnBinding = {
        label: "Outstanding Tasks",
        templateLabel: "",
        fieldName: "outstandingValidationStageTasks",
        dbColumnName: "OUTSTANDING_VALIDATION_STAGE_TASKS",
        isRequired: false,
        contentType: "TEXTAREA",
        length: 1000,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _outstandingValidationStageTasksColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._outstandingValidationStageTasksBaseColumnBinding),
    };
    public get outstandingValidationStageTasks(): ColumnBinding<string | null> {
        return this._outstandingValidationStageTasksColumnBinding;
    }
    protected static _advertisementDateBaseColumnBinding: BaseColumnBinding = {
        label: "Advertisement Date",
        templateLabel: "",
        fieldName: "advertisementDate",
        dbColumnName: "ADVERTISEMENT_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _advertisementDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._advertisementDateBaseColumnBinding),
    };
    public get advertisementDate(): ColumnBinding<Date | null> {
        return this._advertisementDateColumnBinding;
    }
    protected static _advertisementPublicationBaseColumnBinding: BaseColumnBinding = {
        label: "Advertisement Publication",
        templateLabel: "",
        fieldName: "advertisementPublication",
        dbColumnName: "ADVERTISEMENT_PUBLICATION",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _advertisementPublicationColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._advertisementPublicationBaseColumnBinding),
    };
    public get advertisementPublication(): ColumnBinding<string | null> {
        return this._advertisementPublicationColumnBinding;
    }
    protected static _notificationStepsTakenBaseColumnBinding: BaseColumnBinding = {
        label: "Notification Steps Taken",
        templateLabel: "",
        fieldName: "notificationStepsTaken",
        dbColumnName: "NOTIFICATION_STEPS_TAKEN",
        isRequired: false,
        contentType: "TEXTAREA",
        length: 1000,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _notificationStepsTakenColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._notificationStepsTakenBaseColumnBinding),
    };
    public get notificationStepsTaken(): ColumnBinding<string | null> {
        return this._notificationStepsTakenColumnBinding;
    }
    protected static _smFullNameGeneratedBaseColumnBinding: BaseColumnBinding = {
        label: "SM Full Name Generated",
        templateLabel: "",
        fieldName: "smFullNameGenerated",
        dbColumnName: "SM_FULL_NAME_GENERATED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _smFullNameGeneratedColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._smFullNameGeneratedBaseColumnBinding),
    };
    public get smFullNameGenerated(): ColumnBinding<number | null> {
        return this._smFullNameGeneratedColumnBinding;
    }
    protected static _paymentStatusNotesBaseColumnBinding: BaseColumnBinding = {
        label: "Payment Status Notes",
        templateLabel: "",
        fieldName: "paymentStatusNotes",
        dbColumnName: "PAYMENT_STATUS_NOTES",
        isRequired: false,
        contentType: "TEXTAREA",
        length: 1000,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _paymentStatusNotesColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._paymentStatusNotesBaseColumnBinding),
    };
    public get paymentStatusNotes(): ColumnBinding<string | null> {
        return this._paymentStatusNotesColumnBinding;
    }
    protected static _prevalidationCommentaryBaseColumnBinding: BaseColumnBinding = {
        label: "Prevalidation Commentary",
        templateLabel: "",
        fieldName: "prevalidationCommentary",
        dbColumnName: "PREVALIDATION_COMMENTARY",
        isRequired: false,
        contentType: "TEXTAREA",
        length: 1000,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _prevalidationCommentaryColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._prevalidationCommentaryBaseColumnBinding),
    };
    public get prevalidationCommentary(): ColumnBinding<string | null> {
        return this._prevalidationCommentaryColumnBinding;
    }
    protected static _certificateOfOwnershipTypeProvidedBaseColumnBinding: BaseColumnBinding = {
        label: "Type Provided",
        templateLabel: "",
        fieldName: "certificateOfOwnershipTypeProvided",
        dbColumnName: "CERTIFICATE_OF_OWNERSHIP_TYPE_PROVIDED",
        isRequired: false,
        contentType: "PICKLIST",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: "PM_OWNERSHIPCERTIFICATE_TYPE",
        options: [
            "A",
            "B",
            "C",
            "D"
        ],
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _certificateOfOwnershipTypeProvidedColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._certificateOfOwnershipTypeProvidedBaseColumnBinding),
    };
    public get certificateOfOwnershipTypeProvided(): ColumnBinding<string | null> {
        return this._certificateOfOwnershipTypeProvidedColumnBinding;
    }
    protected static _incorrectPlanningAuthorityBaseColumnBinding: BaseColumnBinding = {
        label: "Incorrect Planning Authority",
        templateLabel: "",
        fieldName: "incorrectPlanningAuthority",
        dbColumnName: "INCORRECT_PLANNING_AUTHORITY",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _incorrectPlanningAuthorityColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._incorrectPlanningAuthorityBaseColumnBinding),
    };
    public get incorrectPlanningAuthority(): ColumnBinding<number | null> {
        return this._incorrectPlanningAuthorityColumnBinding;
    }
    protected static _proposalDescriptionConfirmedBaseColumnBinding: BaseColumnBinding = {
        label: "Proposal Description Confirmed",
        templateLabel: "",
        fieldName: "proposalDescriptionConfirmed",
        dbColumnName: "PROPOSAL_DESCRIPTION_CONFIRMED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _proposalDescriptionConfirmedColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._proposalDescriptionConfirmedBaseColumnBinding),
    };
    public get proposalDescriptionConfirmed(): ColumnBinding<number | null> {
        return this._proposalDescriptionConfirmedColumnBinding;
    }
    protected static _importFromApplicationIdBaseColumnBinding: BaseColumnBinding = {
        label: "Import from Application",
        templateLabel: "",
        fieldName: "importFromApplicationId",
        dbColumnName: "IMPORT_FROM_APPLICATION_ID",
        isRequired: false,
        contentType: "LOOKUP",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: "P_APPLICATION",
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _importFromApplicationIdColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._importFromApplicationIdBaseColumnBinding),
    };
    public get importFromApplicationId(): ColumnBinding<number | null> {
        return this._importFromApplicationIdColumnBinding;
    }
    protected static _plottedBoundaryAreaTempBaseColumnBinding: BaseColumnBinding = {
        label: "Plotted Boundary Area Temp",
        templateLabel: "",
        fieldName: "plottedBoundaryAreaTemp",
        dbColumnName: "PLOTTED_BOUNDARY_AREA_TEMP",
        isRequired: false,
        contentType: "NUMBER",
        length: 16,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _plottedBoundaryAreaTempColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._plottedBoundaryAreaTempBaseColumnBinding),
    };
    public get plottedBoundaryAreaTemp(): ColumnBinding<number | null> {
        return this._plottedBoundaryAreaTempColumnBinding;
    }
    protected static _agentIdBaseColumnBinding: BaseColumnBinding = {
        label: "Agent",
        templateLabel: "",
        fieldName: "agentId",
        dbColumnName: "AGENT_ID",
        isRequired: false,
        contentType: "LOOKUP",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: "P_AGENT",
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _agentIdColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._agentIdBaseColumnBinding),
    };
    public get agentId(): ColumnBinding<number | null> {
        return this._agentIdColumnBinding;
    }
    protected static _validationDecisionDateBaseColumnBinding: BaseColumnBinding = {
        label: "Validation Decision Date",
        templateLabel: "",
        fieldName: "validationDecisionDate",
        dbColumnName: "VALIDATION_DECISION_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _validationDecisionDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._validationDecisionDateBaseColumnBinding),
    };
    public get validationDecisionDate(): ColumnBinding<Date | null> {
        return this._validationDecisionDateColumnBinding;
    }
    protected static _timeExtensionAgreedCorrespIdBaseColumnBinding: BaseColumnBinding = {
        label: "Time Extension Agreement Correspondence",
        templateLabel: "",
        fieldName: "timeExtensionAgreedCorrespId",
        dbColumnName: "TIME_EXTENSION_AGREED_CORRESP_ID",
        isRequired: false,
        contentType: "LOOKUP",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: "ATTACHMENT",
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _timeExtensionAgreedCorrespIdColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._timeExtensionAgreedCorrespIdBaseColumnBinding),
    };
    public get timeExtensionAgreedCorrespId(): ColumnBinding<number | null> {
        return this._timeExtensionAgreedCorrespIdColumnBinding;
    }
    protected static _multipleApplicantsBaseColumnBinding: BaseColumnBinding = {
        label: "Multiple Applicants",
        templateLabel: "",
        fieldName: "multipleApplicants",
        dbColumnName: "MULTIPLE_APPLICANTS",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _multipleApplicantsColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._multipleApplicantsBaseColumnBinding),
    };
    public get multipleApplicants(): ColumnBinding<number | null> {
        return this._multipleApplicantsColumnBinding;
    }
    protected static _importFromDecisionIdBaseColumnBinding: BaseColumnBinding = {
        label: "Conditions from Decision",
        templateLabel: "",
        fieldName: "importFromDecisionId",
        dbColumnName: "IMPORT_FROM_DECISION_ID",
        isRequired: false,
        contentType: "LOOKUP",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: "P_DECISION",
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _importFromDecisionIdColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._importFromDecisionIdBaseColumnBinding),
    };
    public get importFromDecisionId(): ColumnBinding<number | null> {
        return this._importFromDecisionIdColumnBinding;
    }
    protected static _consultationsRequiredBaseColumnBinding: BaseColumnBinding = {
        label: "Consultations Required",
        templateLabel: "",
        fieldName: "consultationsRequired",
        dbColumnName: "CONSULTATIONS_REQUIRED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _consultationsRequiredColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._consultationsRequiredBaseColumnBinding),
    };
    public get consultationsRequired(): ColumnBinding<number | null> {
        return this._consultationsRequiredColumnBinding;
    }
    protected static _notificationsRequiredBaseColumnBinding: BaseColumnBinding = {
        label: "Neighbour Notifications Required",
        templateLabel: "",
        fieldName: "notificationsRequired",
        dbColumnName: "NOTIFICATIONS_REQUIRED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _notificationsRequiredColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._notificationsRequiredBaseColumnBinding),
    };
    public get notificationsRequired(): ColumnBinding<number | null> {
        return this._notificationsRequiredColumnBinding;
    }
    protected static _supersedesPreviousApplicationBaseColumnBinding: BaseColumnBinding = {
        label: "Supersedes Previous Application",
        templateLabel: "",
        fieldName: "supersedesPreviousApplication",
        dbColumnName: "SUPERSEDES_PREVIOUS_APPLICATION",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _supersedesPreviousApplicationColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._supersedesPreviousApplicationBaseColumnBinding),
    };
    public get supersedesPreviousApplication(): ColumnBinding<number | null> {
        return this._supersedesPreviousApplicationColumnBinding;
    }
    protected static _applicationSupersededBaseColumnBinding: BaseColumnBinding = {
        label: "Application Superseded",
        templateLabel: "",
        fieldName: "applicationSuperseded",
        dbColumnName: "APPLICATION_SUPERSEDED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _applicationSupersededColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._applicationSupersededBaseColumnBinding),
    };
    public get applicationSuperseded(): ColumnBinding<number | null> {
        return this._applicationSupersededColumnBinding;
    }
    protected static _supersededByBaseColumnBinding: BaseColumnBinding = {
        label: "Application Superseded By",
        templateLabel: "",
        fieldName: "supersededBy",
        dbColumnName: "SUPERSEDED_BY",
        isRequired: false,
        contentType: "LOOKUP",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: "P_APPLICATION",
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _supersededByColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._supersededByBaseColumnBinding),
    };
    public get supersededBy(): ColumnBinding<number | null> {
        return this._supersededByColumnBinding;
    }
    protected static _partiallySupersededBaseColumnBinding: BaseColumnBinding = {
        label: "Partially Superseded",
        templateLabel: "",
        fieldName: "partiallySuperseded",
        dbColumnName: "PARTIALLY_SUPERSEDED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _partiallySupersededColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._partiallySupersededBaseColumnBinding),
    };
    public get partiallySuperseded(): ColumnBinding<number | null> {
        return this._partiallySupersededColumnBinding;
    }
    protected static _validationDecisionBaseColumnBinding: BaseColumnBinding = {
        label: "Validation Decision",
        templateLabel: "",
        fieldName: "validationDecision",
        dbColumnName: "VALIDATION_DECISION",
        isRequired: false,
        contentType: "PICKLIST",
        length: 0,
        defaultValue: "AWAITING VALIDATION",
        helpText: null,
        picklistName: "PM_VALIDATION_DECISION",
        options: [
            "AWAITING REGISTRATION",
            "REGISTERED",
            "AWAITING VALIDATION",
            "VALID",
            "INVALID",
            "FURTHER INFORMATION REQUIRED",
            "FURTHER INFORMATION RECEIVED",
            "WITHDRAWN",
            "CHALLENGED"
        ],
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _validationDecisionColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._validationDecisionBaseColumnBinding),
    };
    public get validationDecision(): ColumnBinding<string | null> {
        return this._validationDecisionColumnBinding;
    }
    protected static _proposedUseClassIdBaseColumnBinding: BaseColumnBinding = {
        label: "Proposed Use Class",
        templateLabel: "",
        fieldName: "proposedUseClassId",
        dbColumnName: "PROPOSED_USE_CLASS_ID",
        isRequired: false,
        contentType: "LOOKUP",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: "P_USE_CLASS",
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _proposedUseClassIdColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._proposedUseClassIdBaseColumnBinding),
    };
    public get proposedUseClassId(): ColumnBinding<number | null> {
        return this._proposedUseClassIdColumnBinding;
    }
    protected static _currentUseClassIdBaseColumnBinding: BaseColumnBinding = {
        label: "Current Use Class",
        templateLabel: "",
        fieldName: "currentUseClassId",
        dbColumnName: "CURRENT_USE_CLASS_ID",
        isRequired: false,
        contentType: "LOOKUP",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: "P_USE_CLASS",
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _currentUseClassIdColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._currentUseClassIdBaseColumnBinding),
    };
    public get currentUseClassId(): ColumnBinding<number | null> {
        return this._currentUseClassIdColumnBinding;
    }
    protected static _amendmentDecisionBaseColumnBinding: BaseColumnBinding = {
        label: "Amendment Decision",
        templateLabel: "",
        fieldName: "amendmentDecision",
        dbColumnName: "AMENDMENT_DECISION",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _amendmentDecisionColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._amendmentDecisionBaseColumnBinding),
    };
    public get amendmentDecision(): ColumnBinding<string | null> {
        return this._amendmentDecisionColumnBinding;
    }
    protected static _eiaDocumentLocationBaseColumnBinding: BaseColumnBinding = {
        label: "EIA Document Location",
        templateLabel: "",
        fieldName: "eiaDocumentLocation",
        dbColumnName: "EIA_DOCUMENT_LOCATION",
        isRequired: false,
        contentType: "TEXTAREA",
        length: 1000,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _eiaDocumentLocationColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._eiaDocumentLocationBaseColumnBinding),
    };
    public get eiaDocumentLocation(): ColumnBinding<string | null> {
        return this._eiaDocumentLocationColumnBinding;
    }
    protected static _validationChallengeStatusDateBaseColumnBinding: BaseColumnBinding = {
        label: "Validation Challenge Status Date",
        templateLabel: "",
        fieldName: "validationChallengeStatusDate",
        dbColumnName: "VALIDATION_CHALLENGE_STATUS_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _validationChallengeStatusDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._validationChallengeStatusDateBaseColumnBinding),
    };
    public get validationChallengeStatusDate(): ColumnBinding<Date | null> {
        return this._validationChallengeStatusDateColumnBinding;
    }
    protected static _publicNoticeDisplayedOnSiteBaseColumnBinding: BaseColumnBinding = {
        label: "Public Notice Displayed On Site",
        templateLabel: "",
        fieldName: "publicNoticeDisplayedOnSite",
        dbColumnName: "PUBLIC_NOTICE_DISPLAYED_ON_SITE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _publicNoticeDisplayedOnSiteColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._publicNoticeDisplayedOnSiteBaseColumnBinding),
    };
    public get publicNoticeDisplayedOnSite(): ColumnBinding<Date | null> {
        return this._publicNoticeDisplayedOnSiteColumnBinding;
    }
    protected static _footpathCrossesBoundaryBaseColumnBinding: BaseColumnBinding = {
        label: "Footpath crosses boundary",
        templateLabel: "",
        fieldName: "footpathCrossesBoundary",
        dbColumnName: "FOOTPATH_CROSSES_BOUNDARY",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _footpathCrossesBoundaryColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._footpathCrossesBoundaryBaseColumnBinding),
    };
    public get footpathCrossesBoundary(): ColumnBinding<number | null> {
        return this._footpathCrossesBoundaryColumnBinding;
    }
    protected static _isADepartureFromLocalPlanBaseColumnBinding: BaseColumnBinding = {
        label: "Is a departure from Local Plan",
        templateLabel: "",
        fieldName: "isADepartureFromLocalPlan",
        dbColumnName: "IS_A_DEPARTURE_FROM_LOCAL_PLAN",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _isADepartureFromLocalPlanColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._isADepartureFromLocalPlanBaseColumnBinding),
    };
    public get isADepartureFromLocalPlan(): ColumnBinding<number | null> {
        return this._isADepartureFromLocalPlanColumnBinding;
    }
    protected static _workToAListedBuildingBaseColumnBinding: BaseColumnBinding = {
        label: "Work to a Listed Building",
        templateLabel: "",
        fieldName: "workToAListedBuilding",
        dbColumnName: "WORK_TO_A_LISTED_BUILDING",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _workToAListedBuildingColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._workToAListedBuildingBaseColumnBinding),
    };
    public get workToAListedBuilding(): ColumnBinding<number | null> {
        return this._workToAListedBuildingColumnBinding;
    }
    protected static _affectsSettingOfListedBuildingBaseColumnBinding: BaseColumnBinding = {
        label: "Affects setting of Listed Building",
        templateLabel: "",
        fieldName: "affectsSettingOfListedBuilding",
        dbColumnName: "AFFECTS_SETTING_OF_LISTED_BUILDING",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _affectsSettingOfListedBuildingColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._affectsSettingOfListedBuildingBaseColumnBinding),
    };
    public get affectsSettingOfListedBuilding(): ColumnBinding<number | null> {
        return this._affectsSettingOfListedBuildingColumnBinding;
    }
    protected static _demolitionInConservationAreaBaseColumnBinding: BaseColumnBinding = {
        label: "Demolition in Conservation Area",
        templateLabel: "",
        fieldName: "demolitionInConservationArea",
        dbColumnName: "DEMOLITION_IN_CONSERVATION_AREA",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _demolitionInConservationAreaColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._demolitionInConservationAreaBaseColumnBinding),
    };
    public get demolitionInConservationArea(): ColumnBinding<number | null> {
        return this._demolitionInConservationAreaColumnBinding;
    }
    protected static _affectsSettingOfConservationAreaBaseColumnBinding: BaseColumnBinding = {
        label: "Affects setting of Conservation Area",
        templateLabel: "",
        fieldName: "affectsSettingOfConservationArea",
        dbColumnName: "AFFECTS_SETTING_OF_CONSERVATION_AREA",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _affectsSettingOfConservationAreaColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._affectsSettingOfConservationAreaBaseColumnBinding),
    };
    public get affectsSettingOfConservationArea(): ColumnBinding<number | null> {
        return this._affectsSettingOfConservationAreaColumnBinding;
    }
    protected static _includeInNextWeeklyListBaseColumnBinding: BaseColumnBinding = {
        label: "Include in next Weekly List",
        templateLabel: "",
        fieldName: "includeInNextWeeklyList",
        dbColumnName: "INCLUDE_IN_NEXT_WEEKLY_LIST",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _includeInNextWeeklyListColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._includeInNextWeeklyListBaseColumnBinding),
    };
    public get includeInNextWeeklyList(): ColumnBinding<number | null> {
        return this._includeInNextWeeklyListColumnBinding;
    }
    protected static _proposalDetailsChangedBaseColumnBinding: BaseColumnBinding = {
        label: "Proposal Details Changed",
        templateLabel: "",
        fieldName: "proposalDetailsChanged",
        dbColumnName: "PROPOSAL_DETAILS_CHANGED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _proposalDetailsChangedColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._proposalDetailsChangedBaseColumnBinding),
    };
    public get proposalDetailsChanged(): ColumnBinding<number | null> {
        return this._proposalDetailsChangedColumnBinding;
    }
    protected static _requiresReadvertisementBaseColumnBinding: BaseColumnBinding = {
        label: "Requires Readvertisement",
        templateLabel: "",
        fieldName: "requiresReadvertisement",
        dbColumnName: "REQUIRES_READVERTISEMENT",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _requiresReadvertisementColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._requiresReadvertisementBaseColumnBinding),
    };
    public get requiresReadvertisement(): ColumnBinding<number | null> {
        return this._requiresReadvertisementColumnBinding;
    }
    protected static _dateProposalChangedBaseColumnBinding: BaseColumnBinding = {
        label: "Date Proposal Changed",
        templateLabel: "",
        fieldName: "dateProposalChanged",
        dbColumnName: "DATE_PROPOSAL_CHANGED",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _dateProposalChangedColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._dateProposalChangedBaseColumnBinding),
    };
    public get dateProposalChanged(): ColumnBinding<Date | null> {
        return this._dateProposalChangedColumnBinding;
    }
    protected static _weeklyListDateBaseColumnBinding: BaseColumnBinding = {
        label: "Weekly List Date",
        templateLabel: "",
        fieldName: "weeklyListDate",
        dbColumnName: "WEEKLY_LIST_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _weeklyListDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._weeklyListDateBaseColumnBinding),
    };
    public get weeklyListDate(): ColumnBinding<Date | null> {
        return this._weeklyListDateColumnBinding;
    }
    protected static _weeklyListSetDateBaseColumnBinding: BaseColumnBinding = {
        label: "Weekly List Set Date",
        templateLabel: "",
        fieldName: "weeklyListSetDate",
        dbColumnName: "WEEKLY_LIST_SET_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _weeklyListSetDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._weeklyListSetDateBaseColumnBinding),
    };
    public get weeklyListSetDate(): ColumnBinding<Date | null> {
        return this._weeklyListSetDateColumnBinding;
    }
    protected static _weeklyListSetByBaseColumnBinding: BaseColumnBinding = {
        label: "Weekly List Set By",
        templateLabel: "",
        fieldName: "weeklyListSetBy",
        dbColumnName: "WEEKLY_LIST_SET_BY",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _weeklyListSetByColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._weeklyListSetByBaseColumnBinding),
    };
    public get weeklyListSetBy(): ColumnBinding<string | null> {
        return this._weeklyListSetByColumnBinding;
    }
    protected static _mediaPublicationIdBaseColumnBinding: BaseColumnBinding = {
        label: "Media Publication",
        templateLabel: "",
        fieldName: "mediaPublicationId",
        dbColumnName: "MEDIA_PUBLICATION_ID",
        isRequired: false,
        contentType: "LOOKUP",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: "P_MEDIA_PUBLICATION_COVERAGE",
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _mediaPublicationIdColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._mediaPublicationIdBaseColumnBinding),
    };
    public get mediaPublicationId(): ColumnBinding<number | null> {
        return this._mediaPublicationIdColumnBinding;
    }
    protected static _ward_1BaseColumnBinding: BaseColumnBinding = {
        label: "Ward 2",
        templateLabel: "",
        fieldName: "ward_1",
        dbColumnName: "WARD_1",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _ward_1ColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._ward_1BaseColumnBinding),
    };
    public get ward_1(): ColumnBinding<string | null> {
        return this._ward_1ColumnBinding;
    }
    protected static _ward_2BaseColumnBinding: BaseColumnBinding = {
        label: "Ward 3",
        templateLabel: "",
        fieldName: "ward_2",
        dbColumnName: "WARD_2",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _ward_2ColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._ward_2BaseColumnBinding),
    };
    public get ward_2(): ColumnBinding<string | null> {
        return this._ward_2ColumnBinding;
    }
    protected static _ward_3BaseColumnBinding: BaseColumnBinding = {
        label: "Ward 4",
        templateLabel: "",
        fieldName: "ward_3",
        dbColumnName: "WARD_3",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _ward_3ColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._ward_3BaseColumnBinding),
    };
    public get ward_3(): ColumnBinding<string | null> {
        return this._ward_3ColumnBinding;
    }
    protected static _ward_4BaseColumnBinding: BaseColumnBinding = {
        label: "Ward 5",
        templateLabel: "",
        fieldName: "ward_4",
        dbColumnName: "WARD_4",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _ward_4ColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._ward_4BaseColumnBinding),
    };
    public get ward_4(): ColumnBinding<string | null> {
        return this._ward_4ColumnBinding;
    }
    protected static _ward_5BaseColumnBinding: BaseColumnBinding = {
        label: "Ward 6",
        templateLabel: "",
        fieldName: "ward_5",
        dbColumnName: "WARD_5",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _ward_5ColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._ward_5BaseColumnBinding),
    };
    public get ward_5(): ColumnBinding<string | null> {
        return this._ward_5ColumnBinding;
    }
    protected static _parish_1BaseColumnBinding: BaseColumnBinding = {
        label: "Parish 2",
        templateLabel: "",
        fieldName: "parish_1",
        dbColumnName: "PARISH_1",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _parish_1ColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._parish_1BaseColumnBinding),
    };
    public get parish_1(): ColumnBinding<string | null> {
        return this._parish_1ColumnBinding;
    }
    protected static _parish_2BaseColumnBinding: BaseColumnBinding = {
        label: "Parish 3",
        templateLabel: "",
        fieldName: "parish_2",
        dbColumnName: "PARISH_2",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _parish_2ColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._parish_2BaseColumnBinding),
    };
    public get parish_2(): ColumnBinding<string | null> {
        return this._parish_2ColumnBinding;
    }
    protected static _parish_3BaseColumnBinding: BaseColumnBinding = {
        label: "Parish 4",
        templateLabel: "",
        fieldName: "parish_3",
        dbColumnName: "PARISH_3",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _parish_3ColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._parish_3BaseColumnBinding),
    };
    public get parish_3(): ColumnBinding<string | null> {
        return this._parish_3ColumnBinding;
    }
    protected static _parish_4BaseColumnBinding: BaseColumnBinding = {
        label: "Parish 5",
        templateLabel: "",
        fieldName: "parish_4",
        dbColumnName: "PARISH_4",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _parish_4ColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._parish_4BaseColumnBinding),
    };
    public get parish_4(): ColumnBinding<string | null> {
        return this._parish_4ColumnBinding;
    }
    protected static _parish_5BaseColumnBinding: BaseColumnBinding = {
        label: "Parish 6",
        templateLabel: "",
        fieldName: "parish_5",
        dbColumnName: "PARISH_5",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _parish_5ColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._parish_5BaseColumnBinding),
    };
    public get parish_5(): ColumnBinding<string | null> {
        return this._parish_5ColumnBinding;
    }
    protected static _multipleWardsBaseColumnBinding: BaseColumnBinding = {
        label: "Multiple Wards",
        templateLabel: "",
        fieldName: "multipleWards",
        dbColumnName: "MULTIPLE_WARDS",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _multipleWardsColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._multipleWardsBaseColumnBinding),
    };
    public get multipleWards(): ColumnBinding<number | null> {
        return this._multipleWardsColumnBinding;
    }
    protected static _multipleParishesBaseColumnBinding: BaseColumnBinding = {
        label: "Multiple Parishes",
        templateLabel: "",
        fieldName: "multipleParishes",
        dbColumnName: "MULTIPLE_PARISHES",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _multipleParishesColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._multipleParishesBaseColumnBinding),
    };
    public get multipleParishes(): ColumnBinding<number | null> {
        return this._multipleParishesColumnBinding;
    }
    protected static _publicResponseDeadlineBaseColumnBinding: BaseColumnBinding = {
        label: "Public Response Deadline",
        templateLabel: "",
        fieldName: "publicResponseDeadline",
        dbColumnName: "PUBLIC_RESPONSE_DEADLINE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _publicResponseDeadlineColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._publicResponseDeadlineBaseColumnBinding),
    };
    public get publicResponseDeadline(): ColumnBinding<Date | null> {
        return this._publicResponseDeadlineColumnBinding;
    }
    protected static _finalCorrectionNoticeIdBaseColumnBinding: BaseColumnBinding = {
        label: "FInal Correction Decision Notice",
        templateLabel: "",
        fieldName: "finalCorrectionNoticeId",
        dbColumnName: "FINAL_CORRECTION_NOTICE_ID",
        isRequired: false,
        contentType: "LOOKUP",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: "P_DRAFT_DECISION_NOTICE",
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _finalCorrectionNoticeIdColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._finalCorrectionNoticeIdBaseColumnBinding),
    };
    public get finalCorrectionNoticeId(): ColumnBinding<number | null> {
        return this._finalCorrectionNoticeIdColumnBinding;
    }
    protected static _planningPerformanceAgreementIdBaseColumnBinding: BaseColumnBinding = {
        label: "PPA",
        templateLabel: "",
        fieldName: "planningPerformanceAgreementId",
        dbColumnName: "PLANNING_PERFORMANCE_AGREEMENT_ID",
        isRequired: false,
        contentType: "LOOKUP",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: "P_PLANNING_PERFORMANCE_AGREEMENT",
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _planningPerformanceAgreementIdColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._planningPerformanceAgreementIdBaseColumnBinding),
    };
    public get planningPerformanceAgreementId(): ColumnBinding<number | null> {
        return this._planningPerformanceAgreementIdColumnBinding;
    }
    protected static _publicNoticeAssessmentCheckBaseColumnBinding: BaseColumnBinding = {
        label: "Public Notice Assessment Checks Completed",
        templateLabel: "",
        fieldName: "publicNoticeAssessmentCheck",
        dbColumnName: "PUBLIC_NOTICE_ASSESSMENT_CHECK",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _publicNoticeAssessmentCheckColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._publicNoticeAssessmentCheckBaseColumnBinding),
    };
    public get publicNoticeAssessmentCheck(): ColumnBinding<number | null> {
        return this._publicNoticeAssessmentCheckColumnBinding;
    }
    protected static _councillorCallInBaseColumnBinding: BaseColumnBinding = {
        label: "Councillor Call In",
        templateLabel: "",
        fieldName: "councillorCallIn",
        dbColumnName: "COUNCILLOR_CALL_IN",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _councillorCallInColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._councillorCallInBaseColumnBinding),
    };
    public get councillorCallIn(): ColumnBinding<number | null> {
        return this._councillorCallInColumnBinding;
    }
    protected static _decisionLevelBaseColumnBinding: BaseColumnBinding = {
        label: "Decision Level",
        templateLabel: "",
        fieldName: "decisionLevel",
        dbColumnName: "DECISION_LEVEL",
        isRequired: true,
        contentType: "PICKLIST",
        length: 0,
        defaultValue: "Delegated",
        helpText: null,
        picklistName: "PM_DECISION_LEVEL",
        options: [
            "Delegated",
            "Planning Committee"
        ],
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _decisionLevelColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._decisionLevelBaseColumnBinding),
    };
    public get decisionLevel(): ColumnBinding<string | null> {
        return this._decisionLevelColumnBinding;
    }
    protected static _planningTeamNameBaseColumnBinding: BaseColumnBinding = {
        label: "Planning Team Name",
        templateLabel: "",
        fieldName: "planningTeamName",
        dbColumnName: "PLANNING_TEAM_NAME",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _planningTeamNameColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._planningTeamNameBaseColumnBinding),
    };
    public get planningTeamName(): ColumnBinding<string | null> {
        return this._planningTeamNameColumnBinding;
    }
    protected static _cilLiableBaseColumnBinding: BaseColumnBinding = {
        label: "CIL Liable",
        templateLabel: "",
        fieldName: "cilLiable",
        dbColumnName: "CIL_LIABLE",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _cilLiableColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._cilLiableBaseColumnBinding),
    };
    public get cilLiable(): ColumnBinding<number | null> {
        return this._cilLiableColumnBinding;
    }
    protected static _cilLiableNotesBaseColumnBinding: BaseColumnBinding = {
        label: "CIL Liable Notes",
        templateLabel: "",
        fieldName: "cilLiableNotes",
        dbColumnName: "CIL_LIABLE_NOTES",
        isRequired: false,
        contentType: "TEXTAREA",
        length: 1000,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _cilLiableNotesColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._cilLiableNotesBaseColumnBinding),
    };
    public get cilLiableNotes(): ColumnBinding<string | null> {
        return this._cilLiableNotesColumnBinding;
    }
    protected static _potentiallyCilLiableBaseColumnBinding: BaseColumnBinding = {
        label: "Potentially CIL Liable",
        templateLabel: "",
        fieldName: "potentiallyCilLiable",
        dbColumnName: "POTENTIALLY_CIL_LIABLE",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _potentiallyCilLiableColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._potentiallyCilLiableBaseColumnBinding),
    };
    public get potentiallyCilLiable(): ColumnBinding<number | null> {
        return this._potentiallyCilLiableColumnBinding;
    }
    protected static _potentiallyCilLiableNotesBaseColumnBinding: BaseColumnBinding = {
        label: "Potentially CIL Liable Notes",
        templateLabel: "",
        fieldName: "potentiallyCilLiableNotes",
        dbColumnName: "POTENTIALLY_CIL_LIABLE_NOTES",
        isRequired: false,
        contentType: "TEXTAREA",
        length: 1000,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _potentiallyCilLiableNotesColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._potentiallyCilLiableNotesBaseColumnBinding),
    };
    public get potentiallyCilLiableNotes(): ColumnBinding<string | null> {
        return this._potentiallyCilLiableNotesColumnBinding;
    }
    protected static _s106LiableBaseColumnBinding: BaseColumnBinding = {
        label: "S106 Liable",
        templateLabel: "",
        fieldName: "s106Liable",
        dbColumnName: "S106_LIABLE",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _s106LiableColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._s106LiableBaseColumnBinding),
    };
    public get s106Liable(): ColumnBinding<number | null> {
        return this._s106LiableColumnBinding;
    }
    protected static _s106LiableNotesBaseColumnBinding: BaseColumnBinding = {
        label: "S106 Liable Notes",
        templateLabel: "",
        fieldName: "s106LiableNotes",
        dbColumnName: "S106_LIABLE_NOTES",
        isRequired: false,
        contentType: "TEXTAREA",
        length: 1000,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _s106LiableNotesColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._s106LiableNotesBaseColumnBinding),
    };
    public get s106LiableNotes(): ColumnBinding<string | null> {
        return this._s106LiableNotesColumnBinding;
    }
    protected static _useCategoryBaseColumnBinding: BaseColumnBinding = {
        label: "Use Category",
        templateLabel: "",
        fieldName: "useCategory",
        dbColumnName: "USE_CATEGORY",
        isRequired: false,
        contentType: "PICKLIST",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: "PM_USE_CATEGORY",
        options: [
            "(i) COMMERCIAL",
            "(ii) RESIDENTIAL"
        ],
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _useCategoryColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._useCategoryBaseColumnBinding),
    };
    public get useCategory(): ColumnBinding<string | null> {
        return this._useCategoryColumnBinding;
    }
    protected static _ppaAgreedDateBaseColumnBinding: BaseColumnBinding = {
        label: "PPA Agreed Date",
        templateLabel: "",
        fieldName: "ppaAgreedDate",
        dbColumnName: "PPA_AGREED_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _ppaAgreedDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._ppaAgreedDateBaseColumnBinding),
    };
    public get ppaAgreedDate(): ColumnBinding<Date | null> {
        return this._ppaAgreedDateColumnBinding;
    }
    protected static _ppApplicationVersionBaseColumnBinding: BaseColumnBinding = {
        label: "PP Application version",
        templateLabel: "",
        fieldName: "ppApplicationVersion",
        dbColumnName: "PP_APPLICATION_VERSION",
        isRequired: false,
        contentType: "TEXT",
        length: 255,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _ppApplicationVersionColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._ppApplicationVersionBaseColumnBinding),
    };
    public get ppApplicationVersion(): ColumnBinding<string | null> {
        return this._ppApplicationVersionColumnBinding;
    }
    protected static _applicationNotesBaseColumnBinding: BaseColumnBinding = {
        label: "Application Notes",
        templateLabel: "",
        fieldName: "applicationNotes",
        dbColumnName: "APPLICATION_NOTES",
        isRequired: false,
        contentType: "TEXTAREA",
        length: 1000,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _applicationNotesColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._applicationNotesBaseColumnBinding),
    };
    public get applicationNotes(): ColumnBinding<string | null> {
        return this._applicationNotesColumnBinding;
    }
    protected static _sameDetailsAsApplicantBaseColumnBinding: BaseColumnBinding = {
        label: "Same details as Applicant",
        templateLabel: "",
        fieldName: "sameDetailsAsApplicant",
        dbColumnName: "SAME_DETAILS_AS_APPLICANT",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _sameDetailsAsApplicantColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._sameDetailsAsApplicantBaseColumnBinding),
    };
    public get sameDetailsAsApplicant(): ColumnBinding<number | null> {
        return this._sameDetailsAsApplicantColumnBinding;
    }
    protected static _vuidBaseColumnBinding: BaseColumnBinding = {
        label: "Virtual user id",
        templateLabel: "",
        fieldName: "vuid",
        dbColumnName: "VUID",
        isRequired: false,
        contentType: "TEXT",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _vuidColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._vuidBaseColumnBinding),
    };
    public get vuid(): ColumnBinding<string | null> {
        return this._vuidColumnBinding;
    }
    protected static _publicResponseDeadlineManuallyBaseColumnBinding: BaseColumnBinding = {
        label: "Public Response Deadline Manually",
        templateLabel: "",
        fieldName: "publicResponseDeadlineManually",
        dbColumnName: "PUBLIC_RESPONSE_DEADLINE_MANUALLY",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _publicResponseDeadlineManuallyColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._publicResponseDeadlineManuallyBaseColumnBinding),
    };
    public get publicResponseDeadlineManually(): ColumnBinding<number | null> {
        return this._publicResponseDeadlineManuallyColumnBinding;
    }
    protected static _eiaRequestedDateBaseColumnBinding: BaseColumnBinding = {
        label: "EIA Requested Date",
        templateLabel: "",
        fieldName: "eiaRequestedDate",
        dbColumnName: "EIA_REQUESTED_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _eiaRequestedDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._eiaRequestedDateBaseColumnBinding),
    };
    public get eiaRequestedDate(): ColumnBinding<Date | null> {
        return this._eiaRequestedDateColumnBinding;
    }
    protected static _eiaReceivedDateBaseColumnBinding: BaseColumnBinding = {
        label: "EIA Received Date",
        templateLabel: "",
        fieldName: "eiaReceivedDate",
        dbColumnName: "EIA_RECEIVED_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _eiaReceivedDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._eiaReceivedDateBaseColumnBinding),
    };
    public get eiaReceivedDate(): ColumnBinding<Date | null> {
        return this._eiaReceivedDateColumnBinding;
    }
    protected static _netIncreaseOfDwellingsBaseColumnBinding: BaseColumnBinding = {
        label: "Net Increase of Dwellings",
        templateLabel: "",
        fieldName: "netIncreaseOfDwellings",
        dbColumnName: "NET_INCREASE_OF_DWELLINGS",
        isRequired: false,
        contentType: "PICKLIST",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: "YESNOUNDECIDED",
        options: [
            "Yes",
            "No",
            "Undecided"
        ],
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _netIncreaseOfDwellingsColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._netIncreaseOfDwellingsBaseColumnBinding),
    };
    public get netIncreaseOfDwellings(): ColumnBinding<string | null> {
        return this._netIncreaseOfDwellingsColumnBinding;
    }
    protected static _publicApplicationNotesBaseColumnBinding: BaseColumnBinding = {
        label: "Public Application Notes",
        templateLabel: "",
        fieldName: "publicApplicationNotes",
        dbColumnName: "PUBLIC_APPLICATION_NOTES",
        isRequired: false,
        contentType: "TEXTAREA",
        length: 1000,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _publicApplicationNotesColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._publicApplicationNotesBaseColumnBinding),
    };
    public get publicApplicationNotes(): ColumnBinding<string | null> {
        return this._publicApplicationNotesColumnBinding;
    }
    protected static _geometryBaseColumnBinding: BaseColumnBinding = {
        label: "Geometry",
        templateLabel: "",
        fieldName: "geometry",
        dbColumnName: "GEOMETRY",
        isRequired: false,
        contentType: "TEXTAREA",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _geometryColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._geometryBaseColumnBinding),
    };
    public get geometry(): ColumnBinding<string | null> {
        return this._geometryColumnBinding;
    }
    protected static _constraintCheckDateBaseColumnBinding: BaseColumnBinding = {
        label: "Last Check Run on",
        templateLabel: "",
        fieldName: "constraintCheckDate",
        dbColumnName: "CONSTRAINT_CHECK_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _constraintCheckDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._constraintCheckDateBaseColumnBinding),
    };
    public get constraintCheckDate(): ColumnBinding<Date | null> {
        return this._constraintCheckDateColumnBinding;
    }
    protected static _bngApplicableBaseColumnBinding: BaseColumnBinding = {
        label: "BNG Applicable",
        templateLabel: "",
        fieldName: "bngApplicable",
        dbColumnName: "BNG_APPLICABLE",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _bngApplicableColumnBinding: ColumnBinding<boolean | null> = {
        ...(PApplicationBinding._bngApplicableBaseColumnBinding),
    };
    public get bngApplicable(): ColumnBinding<boolean | null> {
        return this._bngApplicableColumnBinding;
    }
    protected static _includeOnRegisterBaseColumnBinding: BaseColumnBinding = {
        label: "Include On Register",
        templateLabel: "",
        fieldName: "includeOnRegister",
        dbColumnName: "INCLUDE_ON_REGISTER",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _includeOnRegisterColumnBinding: ColumnBinding<boolean | null> = {
        ...(PApplicationBinding._includeOnRegisterBaseColumnBinding),
    };
    public get includeOnRegister(): ColumnBinding<boolean | null> {
        return this._includeOnRegisterColumnBinding;
    }
    protected static _initialHabitatSurveyUndertakenBaseColumnBinding: BaseColumnBinding = {
        label: "Initial Habitat Survey Undertaken",
        templateLabel: "",
        fieldName: "initialHabitatSurveyUndertaken",
        dbColumnName: "INITIAL_HABITAT_SURVEY_UNDERTAKEN",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _initialHabitatSurveyUndertakenColumnBinding: ColumnBinding<boolean | null> = {
        ...(PApplicationBinding._initialHabitatSurveyUndertakenBaseColumnBinding),
    };
    public get initialHabitatSurveyUndertaken(): ColumnBinding<boolean | null> {
        return this._initialHabitatSurveyUndertakenColumnBinding;
    }
    protected static _surveyDateBaseColumnBinding: BaseColumnBinding = {
        label: "Survey Date",
        templateLabel: "",
        fieldName: "surveyDate",
        dbColumnName: "SURVEY_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _surveyDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._surveyDateBaseColumnBinding),
    };
    public get surveyDate(): ColumnBinding<Date | null> {
        return this._surveyDateColumnBinding;
    }
    protected static _surveyNotesBaseColumnBinding: BaseColumnBinding = {
        label: "Survey Notes",
        templateLabel: "",
        fieldName: "surveyNotes",
        dbColumnName: "SURVEY_NOTES",
        isRequired: false,
        contentType: "TEXTAREA",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _surveyNotesColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._surveyNotesBaseColumnBinding),
    };
    public get surveyNotes(): ColumnBinding<string | null> {
        return this._surveyNotesColumnBinding;
    }
    protected static _ecologicalImpactAssessmentBaseColumnBinding: BaseColumnBinding = {
        label: "Ecological Impact Assessment",
        templateLabel: "",
        fieldName: "ecologicalImpactAssessment",
        dbColumnName: "ECOLOGICAL_IMPACT_ASSESSMENT",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _ecologicalImpactAssessmentColumnBinding: ColumnBinding<boolean | null> = {
        ...(PApplicationBinding._ecologicalImpactAssessmentBaseColumnBinding),
    };
    public get ecologicalImpactAssessment(): ColumnBinding<boolean | null> {
        return this._ecologicalImpactAssessmentColumnBinding;
    }
    protected static _assessmentDateBaseColumnBinding: BaseColumnBinding = {
        label: "Ecological Impact Assessment Date",
        templateLabel: "",
        fieldName: "assessmentDate",
        dbColumnName: "ECOLOGICAL_IMPACT_ASSESSMENT_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _assessmentDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._assessmentDateBaseColumnBinding),
    };
    public get assessmentDate(): ColumnBinding<Date | null> {
        return this._assessmentDateColumnBinding;
    }
    protected static _assessmentNotesBaseColumnBinding: BaseColumnBinding = {
        label: "Assessment Notes",
        templateLabel: "",
        fieldName: "assessmentNotes",
        dbColumnName: "ASSESSMENT_NOTES",
        isRequired: false,
        contentType: "TEXTAREA",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _assessmentNotesColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._assessmentNotesBaseColumnBinding),
    };
    public get assessmentNotes(): ColumnBinding<string | null> {
        return this._assessmentNotesColumnBinding;
    }
    protected static _unitChangeHabitatBaseColumnBinding: BaseColumnBinding = {
        label: "Unit Change Habitat",
        templateLabel: "",
        fieldName: "unitChangeHabitat",
        dbColumnName: "UNIT_CHANGE_HABITAT",
        isRequired: false,
        contentType: "NUMBER",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _unitChangeHabitatColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._unitChangeHabitatBaseColumnBinding),
    };
    public get unitChangeHabitat(): ColumnBinding<number | null> {
        return this._unitChangeHabitatColumnBinding;
    }
    protected static _unitChangeHedgeRowBaseColumnBinding: BaseColumnBinding = {
        label: "Unit Change Hedge Row",
        templateLabel: "",
        fieldName: "unitChangeHedgeRow",
        dbColumnName: "UNIT_CHANGE_HEDGE_ROW",
        isRequired: false,
        contentType: "NUMBER",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _unitChangeHedgeRowColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._unitChangeHedgeRowBaseColumnBinding),
    };
    public get unitChangeHedgeRow(): ColumnBinding<number | null> {
        return this._unitChangeHedgeRowColumnBinding;
    }
    protected static _unitChangeRiverBaseColumnBinding: BaseColumnBinding = {
        label: "Unit Change River",
        templateLabel: "",
        fieldName: "unitChangeRiver",
        dbColumnName: "UNIT_CHANGE_RIVER",
        isRequired: false,
        contentType: "NUMBER",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _unitChangeRiverColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._unitChangeRiverBaseColumnBinding),
    };
    public get unitChangeRiver(): ColumnBinding<number | null> {
        return this._unitChangeRiverColumnBinding;
    }
    protected static _percentChangeHabitatBaseColumnBinding: BaseColumnBinding = {
        label: "Percent Change Habitat",
        templateLabel: "",
        fieldName: "percentChangeHabitat",
        dbColumnName: "PERCENT_CHANGE_HABITAT",
        isRequired: false,
        contentType: "NUMBER",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _percentChangeHabitatColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._percentChangeHabitatBaseColumnBinding),
    };
    public get percentChangeHabitat(): ColumnBinding<number | null> {
        return this._percentChangeHabitatColumnBinding;
    }
    protected static _percentChangeHedgeRowBaseColumnBinding: BaseColumnBinding = {
        label: "Percent Change Hedge Row",
        templateLabel: "",
        fieldName: "percentChangeHedgeRow",
        dbColumnName: "PERCENT_CHANGE_HEDGE_ROW",
        isRequired: false,
        contentType: "NUMBER",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _percentChangeHedgeRowColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._percentChangeHedgeRowBaseColumnBinding),
    };
    public get percentChangeHedgeRow(): ColumnBinding<number | null> {
        return this._percentChangeHedgeRowColumnBinding;
    }
    protected static _percentChangeRiverBaseColumnBinding: BaseColumnBinding = {
        label: "Percent Change River",
        templateLabel: "",
        fieldName: "percentChangeRiver",
        dbColumnName: "PERCENT_CHANGE_RIVER",
        isRequired: false,
        contentType: "NUMBER",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _percentChangeRiverColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._percentChangeRiverBaseColumnBinding),
    };
    public get percentChangeRiver(): ColumnBinding<number | null> {
        return this._percentChangeRiverColumnBinding;
    }
    protected static _onSiteBaselineHabitatBaseColumnBinding: BaseColumnBinding = {
        label: "On Site Baseline Habitat",
        templateLabel: "",
        fieldName: "onSiteBaselineHabitat",
        dbColumnName: "ON_SITE_BASELINE_HABITAT",
        isRequired: false,
        contentType: "NUMBER",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _onSiteBaselineHabitatColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._onSiteBaselineHabitatBaseColumnBinding),
    };
    public get onSiteBaselineHabitat(): ColumnBinding<number | null> {
        return this._onSiteBaselineHabitatColumnBinding;
    }
    protected static _onSiteBaselineHedgeRowBaseColumnBinding: BaseColumnBinding = {
        label: "On Site Baseline Hedge Row",
        templateLabel: "",
        fieldName: "onSiteBaselineHedgeRow",
        dbColumnName: "ON_SITE_BASELINE_HEDGE_ROW",
        isRequired: false,
        contentType: "NUMBER",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _onSiteBaselineHedgeRowColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._onSiteBaselineHedgeRowBaseColumnBinding),
    };
    public get onSiteBaselineHedgeRow(): ColumnBinding<number | null> {
        return this._onSiteBaselineHedgeRowColumnBinding;
    }
    protected static _onSiteBaselineRiverBaseColumnBinding: BaseColumnBinding = {
        label: "On Site Baseline River",
        templateLabel: "",
        fieldName: "onSiteBaselineRiver",
        dbColumnName: "ON_SITE_BASELINE_RIVER",
        isRequired: false,
        contentType: "NUMBER",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _onSiteBaselineRiverColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._onSiteBaselineRiverBaseColumnBinding),
    };
    public get onSiteBaselineRiver(): ColumnBinding<number | null> {
        return this._onSiteBaselineRiverColumnBinding;
    }
    protected static _postInterventionHabitatBaseColumnBinding: BaseColumnBinding = {
        label: "Post Intervention Habitat",
        templateLabel: "",
        fieldName: "postInterventionHabitat",
        dbColumnName: "POST_INTERVENTION_HABITAT",
        isRequired: false,
        contentType: "NUMBER",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _postInterventionHabitatColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._postInterventionHabitatBaseColumnBinding),
    };
    public get postInterventionHabitat(): ColumnBinding<number | null> {
        return this._postInterventionHabitatColumnBinding;
    }
    protected static _postInterventionHedgeRowBaseColumnBinding: BaseColumnBinding = {
        label: "Post Intervention Hedge Row",
        templateLabel: "",
        fieldName: "postInterventionHedgeRow",
        dbColumnName: "POST_INTERVENTION_HEDGE_ROW",
        isRequired: false,
        contentType: "NUMBER",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _postInterventionHedgeRowColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._postInterventionHedgeRowBaseColumnBinding),
    };
    public get postInterventionHedgeRow(): ColumnBinding<number | null> {
        return this._postInterventionHedgeRowColumnBinding;
    }
    protected static _postInterventionRiverBaseColumnBinding: BaseColumnBinding = {
        label: "Post Intervention River",
        templateLabel: "",
        fieldName: "postInterventionRiver",
        dbColumnName: "POST_INTERVENTION_RIVER",
        isRequired: false,
        contentType: "NUMBER",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _postInterventionRiverColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._postInterventionRiverBaseColumnBinding),
    };
    public get postInterventionRiver(): ColumnBinding<number | null> {
        return this._postInterventionRiverColumnBinding;
    }
    protected static _onSiteNetChangeHabitatBaseColumnBinding: BaseColumnBinding = {
        label: "On Site Net Change Habitat",
        templateLabel: "",
        fieldName: "onSiteNetChangeHabitat",
        dbColumnName: "ON_SITE_NET_CHANGE_HABITAT",
        isRequired: false,
        contentType: "NUMBER",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _onSiteNetChangeHabitatColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._onSiteNetChangeHabitatBaseColumnBinding),
    };
    public get onSiteNetChangeHabitat(): ColumnBinding<number | null> {
        return this._onSiteNetChangeHabitatColumnBinding;
    }
    protected static _onSiteNetChangeHedgeRowBaseColumnBinding: BaseColumnBinding = {
        label: "On Site Net Change Hedge Row",
        templateLabel: "",
        fieldName: "onSiteNetChangeHedgeRow",
        dbColumnName: "ON_SITE_NET_CHANGE_HEDGE_ROW",
        isRequired: false,
        contentType: "NUMBER",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _onSiteNetChangeHedgeRowColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._onSiteNetChangeHedgeRowBaseColumnBinding),
    };
    public get onSiteNetChangeHedgeRow(): ColumnBinding<number | null> {
        return this._onSiteNetChangeHedgeRowColumnBinding;
    }
    protected static _onSiteNetChangeRiverBaseColumnBinding: BaseColumnBinding = {
        label: "On Site Net Change River",
        templateLabel: "",
        fieldName: "onSiteNetChangeRiver",
        dbColumnName: "ON_SITE_NET_CHANGE_RIVER",
        isRequired: false,
        contentType: "NUMBER",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _onSiteNetChangeRiverColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._onSiteNetChangeRiverBaseColumnBinding),
    };
    public get onSiteNetChangeRiver(): ColumnBinding<number | null> {
        return this._onSiteNetChangeRiverColumnBinding;
    }
    protected static _offSiteBaselineHabitatBaseColumnBinding: BaseColumnBinding = {
        label: "Off Site Baseline Habitat",
        templateLabel: "",
        fieldName: "offSiteBaselineHabitat",
        dbColumnName: "OFF_SITE_BASELINE_HABITAT",
        isRequired: false,
        contentType: "NUMBER",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _offSiteBaselineHabitatColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._offSiteBaselineHabitatBaseColumnBinding),
    };
    public get offSiteBaselineHabitat(): ColumnBinding<number | null> {
        return this._offSiteBaselineHabitatColumnBinding;
    }
    protected static _offSiteBaselineHedgeRowBaseColumnBinding: BaseColumnBinding = {
        label: "Off Site Baseline Hedge Row",
        templateLabel: "",
        fieldName: "offSiteBaselineHedgeRow",
        dbColumnName: "OFF_SITE_BASELINE_HEDGE_ROW",
        isRequired: false,
        contentType: "NUMBER",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _offSiteBaselineHedgeRowColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._offSiteBaselineHedgeRowBaseColumnBinding),
    };
    public get offSiteBaselineHedgeRow(): ColumnBinding<number | null> {
        return this._offSiteBaselineHedgeRowColumnBinding;
    }
    protected static _offSiteBaselineRiverBaseColumnBinding: BaseColumnBinding = {
        label: "Off Site Baseline River",
        templateLabel: "",
        fieldName: "offSiteBaselineRiver",
        dbColumnName: "OFF_SITE_BASELINE_RIVER",
        isRequired: false,
        contentType: "NUMBER",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _offSiteBaselineRiverColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._offSiteBaselineRiverBaseColumnBinding),
    };
    public get offSiteBaselineRiver(): ColumnBinding<number | null> {
        return this._offSiteBaselineRiverColumnBinding;
    }
    protected static _offSitePostInterventionHabitatBaseColumnBinding: BaseColumnBinding = {
        label: "Off Site Post Intervention Habitat",
        templateLabel: "",
        fieldName: "offSitePostInterventionHabitat",
        dbColumnName: "OFF_SITE_POST_INTERVENTION_HABITAT",
        isRequired: false,
        contentType: "NUMBER",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _offSitePostInterventionHabitatColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._offSitePostInterventionHabitatBaseColumnBinding),
    };
    public get offSitePostInterventionHabitat(): ColumnBinding<number | null> {
        return this._offSitePostInterventionHabitatColumnBinding;
    }
    protected static _offSitePostInterventionHedgeRowBaseColumnBinding: BaseColumnBinding = {
        label: "Off Site Post Intervention Hedge Row",
        templateLabel: "",
        fieldName: "offSitePostInterventionHedgeRow",
        dbColumnName: "OFF_SITE_POST_INTERVENTION_HEDGE_ROW",
        isRequired: false,
        contentType: "NUMBER",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _offSitePostInterventionHedgeRowColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._offSitePostInterventionHedgeRowBaseColumnBinding),
    };
    public get offSitePostInterventionHedgeRow(): ColumnBinding<number | null> {
        return this._offSitePostInterventionHedgeRowColumnBinding;
    }
    protected static _offSitePostInterventionRiverBaseColumnBinding: BaseColumnBinding = {
        label: "Off Site Post Intervention River",
        templateLabel: "",
        fieldName: "offSitePostInterventionRiver",
        dbColumnName: "OFF_SITE_POST_INTERVENTION_RIVER",
        isRequired: false,
        contentType: "NUMBER",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _offSitePostInterventionRiverColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._offSitePostInterventionRiverBaseColumnBinding),
    };
    public get offSitePostInterventionRiver(): ColumnBinding<number | null> {
        return this._offSitePostInterventionRiverColumnBinding;
    }
    protected static _offSiteNetChangeHabitatBaseColumnBinding: BaseColumnBinding = {
        label: "Off Site Net Change Habitat",
        templateLabel: "",
        fieldName: "offSiteNetChangeHabitat",
        dbColumnName: "OFF_SITE_NET_CHANGE_HABITAT",
        isRequired: false,
        contentType: "NUMBER",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _offSiteNetChangeHabitatColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._offSiteNetChangeHabitatBaseColumnBinding),
    };
    public get offSiteNetChangeHabitat(): ColumnBinding<number | null> {
        return this._offSiteNetChangeHabitatColumnBinding;
    }
    protected static _offSiteNetChangeHedgeRowBaseColumnBinding: BaseColumnBinding = {
        label: "Off Site Net Change Hedge Row",
        templateLabel: "",
        fieldName: "offSiteNetChangeHedgeRow",
        dbColumnName: "OFF_SITE_NET_CHANGE_HEDGE_ROW",
        isRequired: false,
        contentType: "NUMBER",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _offSiteNetChangeHedgeRowColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._offSiteNetChangeHedgeRowBaseColumnBinding),
    };
    public get offSiteNetChangeHedgeRow(): ColumnBinding<number | null> {
        return this._offSiteNetChangeHedgeRowColumnBinding;
    }
    protected static _offSiteNetChangeRiverBaseColumnBinding: BaseColumnBinding = {
        label: "Off Site Net Change River",
        templateLabel: "",
        fieldName: "offSiteNetChangeRiver",
        dbColumnName: "OFF_SITE_NET_CHANGE_RIVER",
        isRequired: false,
        contentType: "NUMBER",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _offSiteNetChangeRiverColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._offSiteNetChangeRiverBaseColumnBinding),
    };
    public get offSiteNetChangeRiver(): ColumnBinding<number | null> {
        return this._offSiteNetChangeRiverColumnBinding;
    }
    protected static _unitsFromCreditsHabitatBaseColumnBinding: BaseColumnBinding = {
        label: "Units from Credits Habitat",
        templateLabel: "",
        fieldName: "unitsFromCreditsHabitat",
        dbColumnName: "UNITS_FROM_CREDITS_HABITAT",
        isRequired: false,
        contentType: "NUMBER",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _unitsFromCreditsHabitatColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._unitsFromCreditsHabitatBaseColumnBinding),
    };
    public get unitsFromCreditsHabitat(): ColumnBinding<number | null> {
        return this._unitsFromCreditsHabitatColumnBinding;
    }
    protected static _unitsFromCreditsHedgeRowBaseColumnBinding: BaseColumnBinding = {
        label: "Units from Credits Hedge Row",
        templateLabel: "",
        fieldName: "unitsFromCreditsHedgeRow",
        dbColumnName: "UNITS_FROM_CREDITS_HEDGE_ROW",
        isRequired: false,
        contentType: "NUMBER",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _unitsFromCreditsHedgeRowColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._unitsFromCreditsHedgeRowBaseColumnBinding),
    };
    public get unitsFromCreditsHedgeRow(): ColumnBinding<number | null> {
        return this._unitsFromCreditsHedgeRowColumnBinding;
    }
    protected static _unitsFromCreditsRiverBaseColumnBinding: BaseColumnBinding = {
        label: "Units from Credits River",
        templateLabel: "",
        fieldName: "unitsFromCreditsRiver",
        dbColumnName: "UNITS_FROM_CREDITS_RIVER",
        isRequired: false,
        contentType: "NUMBER",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _unitsFromCreditsRiverColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._unitsFromCreditsRiverBaseColumnBinding),
    };
    public get unitsFromCreditsRiver(): ColumnBinding<number | null> {
        return this._unitsFromCreditsRiverColumnBinding;
    }
    protected static _offsettingSitesIdentifiedBaseColumnBinding: BaseColumnBinding = {
        label: "Offsetting Sites Identified",
        templateLabel: "",
        fieldName: "offsettingSitesIdentified",
        dbColumnName: "OFFSETTING_SITES_IDENTIFIED",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _offsettingSitesIdentifiedColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._offsettingSitesIdentifiedBaseColumnBinding),
    };
    public get offsettingSitesIdentified(): ColumnBinding<number | null> {
        return this._offsettingSitesIdentifiedColumnBinding;
    }
    protected static _offsettingWhereWhatBaseColumnBinding: BaseColumnBinding = {
        label: "Where/What",
        templateLabel: "",
        fieldName: "offsettingWhereWhat",
        dbColumnName: "OFFSETTING_WHERE_WHAT",
        isRequired: false,
        contentType: "TEXTAREA",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _offsettingWhereWhatColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._offsettingWhereWhatBaseColumnBinding),
    };
    public get offsettingWhereWhat(): ColumnBinding<string | null> {
        return this._offsettingWhereWhatColumnBinding;
    }
    protected static _ecologicalCompensationBaseColumnBinding: BaseColumnBinding = {
        label: "Ecological Compensation",
        templateLabel: "",
        fieldName: "ecologicalCompensation",
        dbColumnName: "ECOLOGICAL_COMPENSATION",
        isRequired: false,
        contentType: "TEXTAREA",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _ecologicalCompensationColumnBinding: ColumnBinding<string | null> = {
        ...(PApplicationBinding._ecologicalCompensationBaseColumnBinding),
    };
    public get ecologicalCompensation(): ColumnBinding<string | null> {
        return this._ecologicalCompensationColumnBinding;
    }
    protected static _selfBuildBaseColumnBinding: BaseColumnBinding = {
        label: "Self Build",
        templateLabel: "",
        fieldName: "selfBuild",
        dbColumnName: "SELF_BUILD",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 1,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _selfBuildColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._selfBuildBaseColumnBinding),
    };
    public get selfBuild(): ColumnBinding<number | null> {
        return this._selfBuildColumnBinding;
    }
    protected static _decisionExpiryDateBaseColumnBinding: BaseColumnBinding = {
        label: "Decision Expiry Date",
        templateLabel: "",
        fieldName: "decisionExpiryDate",
        dbColumnName: "DECISION_EXPIRY_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _decisionExpiryDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._decisionExpiryDateBaseColumnBinding),
    };
    public get decisionExpiryDate(): ColumnBinding<Date | null> {
        return this._decisionExpiryDateColumnBinding;
    }
    protected static _committeeDecisionDateBaseColumnBinding: BaseColumnBinding = {
        label: "Committee Decision Date",
        templateLabel: "",
        fieldName: "committeeDecisionDate",
        dbColumnName: "COMMITTEE_DECISION_DATE",
        isRequired: false,
        contentType: "DATE",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _committeeDecisionDateColumnBinding: ColumnBinding<Date | null> = {
        ...(PApplicationBinding._committeeDecisionDateBaseColumnBinding),
    };
    public get committeeDecisionDate(): ColumnBinding<Date | null> {
        return this._committeeDecisionDateColumnBinding;
    }
    protected static _biologicalNetGainDoesNotApplyBaseColumnBinding: BaseColumnBinding = {
        label: "Biodiversity Net Gain DOES NOT Apply",
        templateLabel: "",
        fieldName: "biologicalNetGainDoesNotApply",
        dbColumnName: "BIOLOGICAL_NET_GAIN_DOES_NOT_APPLY",
        isRequired: false,
        contentType: "CHECKBOX",
        length: 1,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: null,
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _biologicalNetGainDoesNotApplyColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._biologicalNetGainDoesNotApplyBaseColumnBinding),
    };
    public get biologicalNetGainDoesNotApply(): ColumnBinding<number | null> {
        return this._biologicalNetGainDoesNotApplyColumnBinding;
    }
    protected static _reasonForBngNotApplyingIdBaseColumnBinding: BaseColumnBinding = {
        label: "Reason for BNG Not Applying",
        templateLabel: "",
        fieldName: "reasonForBngNotApplyingId",
        dbColumnName: "REASON_FOR_BNG_NOT_APPLYING_ID",
        isRequired: false,
        contentType: "LOOKUP",
        length: 0,
        defaultValue: null,
        helpText: null,
        picklistName: null,
        options: null,
        relatedObject: "P_BNG_NOT_APPLYING_REASON",
        minValue: null,
        maxValue: null,
        roundTo: null,
        unique: false,
        hideForTemplate: false,
        schemaColumnName: null,
        schemaRelationColumn: null,
    };
    protected _reasonForBngNotApplyingIdColumnBinding: ColumnBinding<number | null> = {
        ...(PApplicationBinding._reasonForBngNotApplyingIdBaseColumnBinding),
    };
    public get reasonForBngNotApplyingId(): ColumnBinding<number | null> {
        return this._reasonForBngNotApplyingIdColumnBinding;
    }
}